import axios from 'axios'

import moment from 'moment'
import router from '../../router/index.js'

var dayjs = require('dayjs')
var dayjs2 = require('dayjs/locale/es')

/* var utc = require('dayjs/plugin/utc') // dependent on utc plugin
var timezone = require('dayjs/plugin/timezone') */

import timeZone from 'dayjs-ext/plugin/timeZone'



import store from '../index.js';

var masterCIFURL = 'https://connectapi.nadia.com.my/cif/'
//var masterCIFUAT = 'http://bwceuat.nadia.com.my:46100/swagger'

var apiconnect = 'https://connectapi.nadia.com.my';
var apiconnectuat = process.env.VUE_APP_APICONNECT
//'https://connectapiuat.nadia.com.my/'
//=process.env.VUE_APP_APICONNECT
 //'https://connectapiuat.nadia.com.my'
var apibwce = 'http://bwceuat.nadia.com.my:'

//var cifToken = 'j3at24ymcwwjrzbsmvzqg2qp'

var tempApikey = process.env.VUE_APP_TEMP
var CIFToken = process.env.VUE_APP_CIF
//'s7kggyt5kmr6k94ct5xqrr6v '
var tokenkey_fund = process.env.VUE_APP_FUND
//'vrjbx7hu63k6jzj83cwmyjbg'
var tokenkey_onboarding = process.env.VUE_APP_ONBOARDING
//'2ypkxeazmae744axkd5mzt4c'
var tokenkey_notification = process.env.VUE_APP_NOTIFICATIONTOKEN
//'ww7dnh9h55db4fx5xxspmxpf';
var tokenkey_transaction = process.env.VUE_APP_TRANSACTIONTOKEN
//"pqdw5cm2dvjvtrd45pjvk4ag"
var tokenkey_agentapi = process.env.VUE_APP_AGENTAPI
//"6hd4ud8csa7keevnu2zfndht"
var token_AUM_ACCOUNTHOLDING =process.env.VUE_APP_AUM_ACCOUNTHOLDING
//"kvxd7pgwfd5dg9d3ag2tqhwe"
var tokenkey_iaccess  = process.env.VUE_APP_IACCESSTOKEN
//"7wjvynebhw7x4pqucfw936pp";
var tokenkey_logger = process.env.VUE_APP_LOGGER

var iaccessAccountMSG = process.env.VUE_APP_IACCESS_MSG
//'4k7rnvgxqcjrv23jaj3ehhap';


//'ut39n2xaxnftu7dya3x6yxqf';
/* var tokenkey_onelook = 'jccndhtuvyxc5r49avpk7wpe'
var tokenkey_tbyservicingagentdv = 'yevm5rpkbdf36j2fxhqhvbrg'; */

//var onelookuat = 'http://bwceuat.nadia.com.my:46001'
var apidir_onboarding_self = 'onboarding/registration/self'
var apidir_onboarding_formlookup = 'onboarding/form/lookups'
var apidir_notification_requesttac = 'notification/tac'
var apidir_notification_verifytac = 'notification/verifytac'
var apidir_fund = 'fund/product/scheme/listing'
var apidir_onelook_accountholding = 'accountholding'
var apidir_transaction = 'transaction/application'
var apidir_emis = 'transaction/emis?ApplicationId='
var apidir_emis_confirm= 'transaction/emis/confirm'
var apidir_emis_lookup= 'transaction/emis/lookup/'
var apidir_iaccess_security_info = 'iaccess/um'
var apidir_cif = 'enquiry/cifinformation'
var apidir_iaccess = 'iaccess/um/loginsecurityinfo?customerid='


var apidir_iaccess_login_info = apiconnectuat + apidir_iaccess;
var apipath_iaccess_security_info =  apiconnectuat + apidir_iaccess_security_info;


//var apipath_notification_requesttac = "https://connectapi.nadia.com.my/" + apidir_notification_requesttac;

var apipath_notification_requesttac = apiconnectuat + apidir_notification_requesttac;
var apipath_notification_verifytac = apiconnectuat + apidir_notification_verifytac;
var apipath_onboarding_self = apiconnectuat + apidir_onboarding_self;
var apipath_onboarding_formlookup = apiconnectuat + apidir_onboarding_formlookup;
var apipath_fund = apiconnectuat + apidir_fund;
var apipath_onelook_accountholding = apiconnectuat + apidir_onelook_accountholding;
var apipath_transaction_selfdraft = apiconnectuat + apidir_transaction
var apipath_transaction_selfprocess = apiconnectuat + apidir_transaction
var apipath_transaction_emis = apiconnectuat + apidir_emis
var apipath_transaction_emis_confirmation = apiconnectuat + apidir_emis_confirm
var apipath_transaction_emis_lookup = apiconnectuat + apidir_emis_lookup





const getDefaultState = () => {
    return {
        FundAPIToken:'',
        OnboardingAPIToken:'',
        TransactionAPIToken:'',
        OnelookAPIToken:'',
        IAccessAPIToken:'',
        LoggerAPIToken:'',
        NotificationAPIToken:'',
        CIFAPIToken:'',
        EmisAPIToken:'',
        AgentAPIToken:'',
        UserID : '',
        route : '',
        AgentList:[],
        PostCodeList:[],
        TempFundList:[],
        DOB:'',
        Age:'',
        Gender:'',
        EmisFund:'',
        EmisOnboardFund:'',
        EmisBuyFund:'',
        emisJson:'',
        accID:[],
        FundList:'',
        Age:'',
    }
}

const state = getDefaultState()

//getters
const getters = {
    GetSalutationNameByValue: (state, getters, rootState) => (SalValue) => {
        const Salutation = rootState.Lookup.Salutation_LK.find(x => x.value === SalValue)
        if(Salutation!==undefined){
            return Salutation.label
        }
        else{
            return SalValue
        }
    },
   
    GetRaceNameByValue: (state, getters, rootState) => (RaceValue) => {
        const Race = rootState.Lookup.Race_LK.find(x => x.value === RaceValue)
        if(Race!==undefined){
            return Race.label
        }
        else{
            return RaceValue
        }
    },
    GetGenderNameByValue: (state, getters, rootState) => (GenderValue) => {
        const Gender = rootState.Lookup.Gender_LK.find(x => x.value === GenderValue)
        if(Gender!==undefined){
            return Gender.label
        }
        else{
            return GenderValue
        }
    },
    GetNationalityNameByValue: (state, getters, rootState) => (NatValue) => {
        const Nationality = rootState.Lookup.Nationality_LK.find(x => x.value === NatValue)
        if(Nationality!==undefined){
            return Nationality.label
        }
        else{
            return NatValue
        }
    },
    GetHolderStatusNameByValue: (state, getters, rootState) => (HSValue) => {
        const HolderStatus = rootState.Lookup.HolderStatus_LK.find(x => x.value === HSValue)
        if(HolderStatus!==undefined){
            return HolderStatus.label
        }
        else{
            return HSValue
        }
    },
    GetStateNameByValue: (state, getters, rootState) => (StateValue) => {
        const State = rootState.Lookup.State_LK.find(x => x.value === StateValue)
        if(State!==undefined){
            return State.label
        }
        else{
            return StateValue
        }
    },
    GetCountryNameByValue: (state, getters, rootState) => (CountryValue) => {
        const Country = rootState.Lookup.Country_LK.find(x => x.value === CountryValue)
        if(Country!==undefined){
            return Country.label
        }
        else{
            return CountryValue
        }
    },
    GetEmploymentStatusNameByValue: (state, getters, rootState) => (EmpStatusValue) => {
        const EmploymentStatus = rootState.Lookup.EmploymentStatus_LK.find(x => x.value === EmpStatusValue)
        if(EmploymentStatus!==undefined){
            return EmploymentStatus.label
        }
        else{
            return EmpStatusValue
        }
    },
    GetTaxResidencyNameByValue: (state, getters, rootState) => (TaxResValue) => {
        const TaxResidency = rootState.Lookup.TaxResidency_LK.find(x => x.value === TaxResValue)
        if(TaxResidency!==undefined){
            return TaxResidency.label
        }
        else{
            return TaxResValue
        }
    },
    GetTINReasonNameByValue: (state, getters, rootState) => (TINReasonValue) => {
        const TINReason = rootState.Lookup.UnavailableTINReason_LK.find(x => x.value === TINReasonValue)
        if(TINReason!==undefined){
            return TINReason.label
        }
        else{
            return TINReasonValue
        }
    },
    GetUSResidentNameByValue: (state, getters, rootState) => (USResidentValue) => {
        const USResident = rootState.Lookup.USResident_LK.find(x => x.value === USResidentValue)
        if(USResident!==undefined){
            return USResident.label
        }
        else{
            return USResidentValue
        }
    },
    GetUSResidentIndiciaNameByValue: (state, getters, rootState) => (USResidentIndValue) => {
        const UsResidentIndicia = rootState.Lookup.UsResidentIndicia_LK.find(x => x.value === USResidentIndValue)
        if(UsResidentIndicia!==undefined){
            return UsResidentIndicia.label
        }
        else{
            return USResidentIndValue
        }
    },
    GetSchemeNameByValue: (state, getters, rootState) => (Scheme) => {
        const Schemes = rootState.Lookup.Schemes_LK.find(x => x.value === Scheme)
        if(Schemes!==undefined){
            return Schemes.label
        }
        else{
            return Scheme
        }
    },
    GetSchemeRedeemCutoffTime: (state, getters, rootState) => (Scheme) => {
        const Schemes = rootState.Lookup.Schemes_LK.find(x => x.value === Scheme)
        if(Schemes!==undefined){
            return Schemes.RequestCutoffTime.Redeem
        }
        else{
            return Scheme
        }
    }
}

//actions
const actions = { 
    
    UpdateAgentList({state,commit}, Obj) { 
        state.AgentList = Obj;
    },
    UpdatePostCodeList({state,commit}, Obj) { 
        
        state.PostCodeList = Obj;
    },
    UpdateFundList({state,commit,rootState}, Obj) {
       // console.log('--> ')
       // console.log(Obj)
        state.TempFundList = Obj
        //rootState.Lookup.Schemes_LK = Obj;
    },

    async GetEmisIC({ getters, rootState,state,dispatch }, Obj){
    
        rootState.AOD.OnboardingAppID = rootState.Login.incomingAppID 

        let applicationId = Obj.ApplicationId ? Obj.ApplicationId : rootState.AOD.OnboardingAppID 
        return this.$httpClient({
            method: "get",
            url: apipath_transaction_emis + applicationId, 
            // headers: { Authorization: "Bearer " + state.TransactionAPIToken }
            //tokenkey_transaction
            //process.env.VUE_APP_TRANSACTIONTOKEN
        })
        .then(function(json){
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(json)
            })
            if(json.data.eMISApplication.ApplicationId != undefined){
               

                if((json.data.eMISApplication.newNric!=undefined)||(json.data.eMISApplication.newNric!="")){
                   
                    var icnumber = json.data.eMISApplication.newNric
                    rootState.AOD.PersonalInformation.NRIC =   json.data.eMISApplication.newNric  
                    var part1 = icnumber.slice(0, 6)
                    var part2 = icnumber.slice(6,8)
                    var part3 = icnumber.slice(8)
                    rootState.AOD.PersonalInformation.tempIC = part1 +'-'+part2+'-'+part3
                  //  console.log(part1 +'-'+part2+'-'+part3)
                   // console.log( rootState.AOD.PersonalInformation.tempIC)
                    //[icnumber.slice(0, 6), "-", icnumber.slice(6,8), "-", icnumber.slice(8)].join('')
              
                      return true
                }else{
                    if((json.data.eMISApplication.oldNric!=undefined)||(json.data.eMISApplication.oldNric!="")){

                        rootState.AOD.PersonalInformation.DateOfBirth = json.data.eMISApplication.eMISAccountOpeningInfo.memberBirthDate
                        rootState.AOD.PersonalInformation.NRIC = json.data.eMISApplication.oldNric
                        rootState.AOD.PersonalInformation.tempIC =json.data.eMISApplication.oldNric
                        return true
                    }else{
                        rootState.AOD.PersonalInformation.DateOfBirth = json.data.eMISApplication.eMISAccountOpeningInfo.memberBirthDate
                        rootState.AOD.PersonalInformation.NRIC = json.data.eMISApplication.otherId
                        rootState.AOD.PersonalInformation.tempIC =json.data.eMISApplication.otherId
                        return true
                    }
                }
              
            }else{
              

             return 'Sorry, Looks like your Application ID is wrong! Unable to locate your transaction data from our system'
            }

          
        })
        .catch(function (error) {
           var payload = "Method: GetEmisIC -> " + error.toString() 

           dispatch('GenEmail',{payload: payload}) 


            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 
            //console.log(error)
            //console.log(error.response);
            return false
        });
    },
    async checkIAccessLoginCredential({commit,state, rootState,dispatch},Obj){
       
      return this.$httpClient({
            method: "get",
            //.slice(-1)apidir_iaccess = 'iaccess/um/loginsecurityinfo?customerid='
             //apidir_iaccess_login_info + Obj.data,
            url: apiconnectuat+'iaccess/um/loginsecurityinfo?customerid='+ Obj.data,           
            // headers: { Authorization: "Bearer " + state.IAccessAPIToken}
            //tokenkey_iaccess
            //process.env.VUE_APP_IACCESSTOKEN 
        }).then(function(json){
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(json)
            })

         //   console.log(json)
            if(json.data.isSuccessful == true){
                rootState.AOD.loginUserName = ""
                rootState.AD.LoginAccountType = json.data.StatusCode
                rootState.AD.hasLoginCredential = true
                return true
                
                //  rootState.AD.LoginAccountType = ""
                //  rootState.AD.hasLoginCredential = false
                 // return false
            }else{
                rootState.AD.LoginAccountType = ""
                rootState.AD.hasLoginCredential = false
                return false
            }
        }) .catch(function (error) {
             var payload = "Method: checkIAccessLoginCredential -> " + error.toString()
             
           dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 
          //  console.log(error);
            return error
        });
    },
    async getExistingInvestorUTAccount({commit,state, rootState,dispatch},Obj){
        //rootState.AOD.PersonalInformation.NRIC
        return this.$httpClient({
            method: "get",
            url: apiconnectuat+'cif/searchaccountbycustomer?pcustomerid='+ rootState.AOD.PersonalInformation.NRIC + '&paccounttype=1&pcustomerstatus=1,2',
          
           // url: apiconnectuat+'searchaccountbyservicingagentdv?pSearch='+ rootState.AOD.PersonalInformation.NRIC + '&pAccountType=1&pCustomerStatus=1,2',
          //  headers: { Authorization: "Bearer " + state.CIFAPIToken }
           //CIFToken
           //process.env.VUE_APP_BYSERVICING_AGENT
        }).then(function(json){
          //  console.log(json.data)
                
            if(json.data.SearchAccountByCustomerResult != undefined){
                if(json.data.SearchAccountByCustomerResult.length > 0){
                    for(var i=0; i < json.data.SearchAccountByCustomerResult.length; i++){
                        if( (json.data.SearchAccountByCustomerResult[i].AccountStatus == "A") && (json.data.SearchAccountByCustomerResult[i].HoldingCategory=="S")&& (json.data.SearchAccountByCustomerResult[i].IsSubAccount==0)){ 
                          
                            rootState.AOD.PersonalInformation.FullName =  json.data.SearchAccountByCustomerResult[i].CustomerName
                            rootState.CD.CustomerDetails.CustomerName =  json.data.SearchAccountByCustomerResult[i].CustomerName
                            rootState.CD.CustomerDetails.CustomerId = json.data.SearchAccountByCustomerResult[i].CustomerId
                            rootState.AOD.ContactInformation.MobileNo = json.data.SearchAccountByCustomerResult[i].CustomerHandphoneNo
                            rootState.AOD.ContactInformation.EmailAddress =json.data.SearchAccountByCustomerResult[i].CustomerEmail
                            rootState.CD.Account.AccountId = json.data.SearchAccountByCustomerResult[i].AccountID
                            rootState.AOD.OnBoardUTAccountNo  = json.data.SearchAccountByCustomerResult[i].AccountID
                        }
                       /*  else if((json.data.SearchAccountByCustomerResult[i].AccountStatus == "A") && (json.data.SearchAccountByCustomerResult[i].JointCustomerId==null)){ 
                          
                            rootState.AOD.PersonalInformation.FullName =  json.data.SearchAccountByServicingAgentResult[i].CustomerName
                            rootState.CD.CustomerDetails.CustomerName =  json.data.SearchAccountByServicingAgentResult[i].CustomerName
                            rootState.CD.CustomerDetails.CustomerId = json.data.SearchAccountByServicingAgentResult[i].CustomerID
                            rootState.AOD.ContactInformation.MobileNo = json.data.SearchAccountByServicingAgentResult[i].CustomerHandphoneNo
                            rootState.AOD.ContactInformation.EmailAddress = json.data.SearchAccountByServicingAgentResult[i].CustomerEmail
                            rootState.CD.Account.AccountId = json.data.SearchAccountByServicingAgentResult[i].AccountID
                            rootState.AOD.OnBoardUTAccountNo  = json.data.SearchAccountByServicingAgentResult[i].AccountID
                            
                        } */
                    }
                }

            }
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(json)
            })
                       
            return true

        }) .catch(function (error) {
            
           var payload = "Method: getExistingInvestorUTAccount -> " + error.toString()

           dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            })  
            //console.log(error);
            return error
        });
    },
    async GETEmisToken({commit,state, rootState,dispatch},Obj){
        return await axios({
          method: "POST",
          url: apiconnectuat+'auth/oauth/emis/token',
          headers: {
            'Content-Type': 'application/json',
            "Ocp-Apim-Subscription-Key" : process.env.VUE_APP_OCP_APIM_SUBSCRIPTION_KEY
          },
          data: {
            // "api_key":tempApikey,
            "appId": Obj.ApplicationId
            //"appId": "2",
          }
        }).then(function(response){
          rootState.Login.AkamaiToken = response.data.access_token // assign Akamai bearer token to store
          if(response){
                return true
            }else{
                return 'Failure fetching token(s) from the authorization server.'
            }
          
        })
        .catch(function (error) {
            var payload = "Method: GETEmisToken -> " + error.toString()  
            dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{ typeid:'3',appid:'2', str:payload }) 
 
            return error
        });
    },
    //get CIF for UT Account
    async GetInvestorMobileCif({commit,state, rootState,dispatch},Obj){

      return this.$httpClient({
            method: "get",
            url: apiconnectuat+'cif/'+ Obj.UserId + '/enquiry/customerinformation',
          //  headers: { Authorization: "Bearer " +  CIFToken}
           //process.env.VUE_APP_CIF
        }).then(function(json){

            if((json.data.CIF.CustomerDetail.TelMobile!=undefined)||(json.data.CIF.CustomerDetail.TelMobile!="")){
                rootState.AOD.ContactInformation.MobileNo = json.data.CIF.CustomerDetail.TelMobile
               // rootState.AOD.ContactInformation.MobileNo ="0149638728"
            }
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(json)
            })
            return  rootState.AOD.ContactInformation.MobileNo

        }).catch(function (error) {
         var payload = "Method: GetInvestorMobileCif -> " + error.toString()
            dispatch('GenEmail',{payload: payload}) 
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 
          //  console.log(error);
            return "false"
        });
    },
    async retrieveIAccessUsername({commit,state, rootState,dispatch},Obj){

        var loginapipath = apipath_iaccess_security_info + '/loginsecurityinfo?customerid=' + Obj.appid;
        return this.$httpClient({
         method: "get",
         url: loginapipath,
        //  headers: {
        //    Authorization: "Bearer " + tokenkey_iaccess
        //  }
         //process.env.VUE_APP_IACCESSTOKEN
       })
       .then(function (json) {
       // console.log(json)
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(json)
            })
           if(json.data.isSuccessful == true){
                rootState.AOD.ResetUsername  = json.data.UserName
                return json.data.UserName                
           } else{
               return "Opps.. Unable to retrieve user info"
           }
           // commit('SetLoginDetails', response.data) : commit('SetLoginFail', response.data); 

       // return response.data.isSuccessful;
      })
      .catch(error => { 
       var payload = "Method: retrieveIAccessUsername -> " + error.toString()
       dispatch('GenEmail',{payload: payload}) 
        dispatch('Logging',{
          typeid:'3',
          appid:'2',
          str:payload
        }) 
        return error
      })
    },
    
    async UpdateIAccessUsernamePassword({commit,state, rootState,dispatch},Obj){
     
        var loginapipath = apipath_iaccess_security_info+"/" + rootState.AOD.loginUserName +'/reset?password=' + rootState.AOD.loginPassWord;
        return this.$httpClient({
         method: "get",
         url: loginapipath,
        //  headers: {
        //    Authorization: "Bearer " + state.IAccessAPIToken
        //  }
       })
       .then(function (json) {
        dispatch('Logging',{
            typeid:'3',
            appid:'2',
            str:JSON.stringify(json)
        })
           //console.log(json.data)
         if(json.data.Status == "1"){
            return true  
         }else{
             return json.data.Message + '. ' + iaccessAccountMSG
         }
           // commit('SetLoginDetails', response.data) : commit('SetLoginFail', response.data); 

       // return response.data.isSuccessful;
      })
      .catch(error => {
        var payload = "Method: UpdateIAccessUsernamePassword -> " + error.toString()
        dispatch('GenEmail',{payload: payload}) 
        dispatch('Logging',{
          typeid:'3',
          appid:'2',
          str:payload
        }) 
        return error.toString()
      })   
    },
    
    async TrnxCifCustomerInfo({state,rootState,dispatch},obj){ 
 
          return this.$httpClient({
               method: "get",
               url: apiconnectuat  + 'cif/' + rootState.AOD.PersonalInformation.NRIC  + '/enquiry/customerinformation',
              //  headers: { Authorization: "Bearer " + state.CIFAPIToken  }
           }).then(function(json){
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(json)
            })
            
            if(json.data.CIF !=undefined){
                if(json.data.CIF.CustomerDetail.IsQualifiedInvestor != undefined){
                    rootState.Transactions.IsQualifiedInvestor  = json.data.CIF.CustomerDetail.IsQualifiedInvestor
                }
            }
               return true;
           })
           .catch(function (error){ 

             var payload = "Method:  TrnxCifCustomerAccountInfo -> " + error.toString()


             dispatch('Logging',{
                 typeid:'3',
                 appid:'2',
                 str:payload
             })
               return error.toString()
           });
       },

    async GetCif({commit, state, rootState,dispatch} ,Obj){

        return this.$httpClient({
            method: "get",
            url: apiconnectuat+'cif/searchaccountbycustomer?pcustomerid='+ rootState.AOD.PersonalInformation.NRIC + '&paccounttype=1&pcustomerstatus=1,2',
            // headers: { Authorization: "Bearer " + state.CIFAPIToken  }
            //CIFToken
           //process.env.VUE_APP_BYSERVICING_AGENT
        }).then(function(json){
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(json)
            })
            var check = false;
            var msg  = ''
            if(json.data.SearchAccountByCustomerResult != undefined){
                if(json.data.SearchAccountByCustomerResult.length > 0){
                    for(var i=0; i < json.data.SearchAccountByCustomerResult.length; i++){
                        if((json.data.SearchAccountByCustomerResult[i].AccountStatus == "A") && (json.data.SearchAccountByCustomerResult[i].HoldingCategory=="S")&& (json.data.SearchAccountByCustomerResult[i].IsSubAccount==0)){ 
                          
                            //
                            if(json.data.SearchAccountByCustomerResult[i].CustomerName != undefined){
                                rootState.AOD.PersonalInformation.FullName =  json.data.SearchAccountByCustomerResult[i].CustomerName
                                rootState.CD.CustomerDetails.CustomerName =  json.data.SearchAccountByCustomerResult[i].CustomerName
                                check = true
                            }else{
                                check = false
                                msg= "Sorry, unable to retrieve Investor Name"
                            }

                            if(json.data.SearchAccountByCustomerResult[i].CustomerId != undefined){
                                rootState.CD.CustomerDetails.CustomerId = json.data.SearchAccountByCustomerResult[i].CustomerId
                                check = true
                            }else{
                                check = false
                                msg= "Sorry, unable to retrieve Investor ID number"
                            }

                            if(json.data.SearchAccountByCustomerResult[i].CustomerHandphoneNo != undefined){
                                rootState.AOD.ContactInformation.MobileNo = json.data.SearchAccountByCustomerResult[i].CustomerHandphoneNo
                                check = true
                            }else{
                                check = false
                                msg= "Sorry, unable to retrieve Investor Phone Number"
                            }

                            if(json.data.SearchAccountByCustomerResult[i].CustomerHandphoneNoCountryCode != undefined) {
                                rootState.AOD.ContactInformation.MobileNoCode = json.data.SearchAccountByCustomerResult[i].CustomerHandphoneNoCountryCode
                                check = true
                            }else{
                                check = false
                                msg= "Sorry, unable to retrieve Investor Mobile Country Code No"
                            }

                            if(json.data.SearchAccountByCustomerResult[i].CustomerEmail != undefined){
                                rootState.AOD.ContactInformation.EmailAddress = json.data.SearchAccountByCustomerResult[i].CustomerEmail
                                check = true
                            }else{
                                check = false
                                msg= "Sorry, unable to retrieve Investor Email Address"
                            }

                            if(json.data.SearchAccountByCustomerResult[i].AccountID != undefined){
                                rootState.CD.Account.AccountId = json.data.SearchAccountByCustomerResult[i].AccountID
                                rootState.AOD.OnBoardUTAccountNo  = json.data.SearchAccountByCustomerResult[i].AccountID
                                check = true
                            }else{
                                check = false
                                msg= "Sorry, unable to retrieve Investor Account Number"
                            }
                        }
                        /*  else if((json.data.SearchAccountByServicingAgentResult[i].AccountType=="UTF") && (json.data.SearchAccountByServicingAgentResult[i].AccountStatus == "A") && (json.data.SearchAccountByServicingAgentResult[i].JointCustomerId==null)){ 
                          
                            if(json.data.SearchAccountByServicingAgentResult[i].CustomerName != undefined){
                                rootState.AOD.PersonalInformation.FullName =  json.data.SearchAccountByServicingAgentResult[i].CustomerName
                                rootState.CD.CustomerDetails.CustomerName =  json.data.SearchAccountByServicingAgentResult[i].CustomerName
                                check = true
                            }else{
                                check = false
                                msg= "Sorry, unable to retrieve Investor Name"
                            }

                            if(json.data.SearchAccountByServicingAgentResult[i].CustomerID != undefined){
                                rootState.CD.CustomerDetails.CustomerId = json.data.SearchAccountByServicingAgentResult[i].CustomerID
                                check = true
                            }else{
                                check = false
                                msg= "Sorry, unable to retrieve Investor ID number"
                            }

                            if(json.data.SearchAccountByServicingAgentResult[i].CustomerHandphoneNo != undefined){
                                rootState.AOD.ContactInformation.MobileNo = json.data.SearchAccountByServicingAgentResult[i].CustomerHandphoneNo
                                check = true
                            }else{
                                check = false
                                msg= "Sorry, unable to retrieve Investor Phone Number"
                            }

                            if(json.data.SearchAccountByServicingAgentResult[i].CustomerEmail != undefined){
                                rootState.AOD.ContactInformation.EmailAddress = json.data.SearchAccountByServicingAgentResult[i].CustomerEmail
                                check = true
                            }else{
                                check = false
                                msg= "Sorry, unable to retrieve Investor Email Address"
                            }

                            if(json.data.SearchAccountByServicingAgentResult[i].AccountID != undefined){
                                rootState.CD.Account.AccountId = json.data.SearchAccountByServicingAgentResult[i].AccountID
                                rootState.AOD.OnBoardUTAccountNo  = json.data.SearchAccountByServicingAgentResult[i].AccountID
                                check = true 
                            }else{
                                check = false
                                msg= "Sorry, unable to retrieve Investor Account Number"
                            }
                        }  */
                    }
                }
                if(check == true){
                    return true
                }else{
                    return msg
                }
            } else{
                return "Sorry unable to retrieve Investor Account detail"
            }
           
                

            }) .catch(function (error) {
            var payload = "Method:  GetCif searchaccountbycustomer -> " + error.toString()
            dispatch('GenEmail',{payload: payload}) 
                dispatch('Logging',{
                  typeid:'3',
                  appid:'2',
                  str:payload
                })  
               // console.log(error);
                return error
            });


             /*
              method: "get",
            url: apiconnectuat+'/cif/'+ Obj.ApplicationId + '/enquiry/accounts?includejointholder=false',
           headers: { Authorization: "Bearer " + CIFUATToken }  
             
             
             rootState.AOD.PersonalInformation.FullName=json.data.CIF.CustomerDetail.Name
         
            rootState.CD.CustomerDetails.CustomerName = json.data.CIF.CustomerDetail.Name
            rootState.CD.CustomerDetails.CustomerId = json.data.CIF.CustomerID

            if((json.data.CIF.CustomerDetail.TelMobile!="")||(json.data.CIF.CustomerDetail.TelMobile!=undefined)){
                rootState.AOD.ContactInformation.MobileNo = json.data.CIF.CustomerDetail.TelMobile
            }

            if(json.data.CIF.Accounts!=undefined){
                if(json.data.CIF.Accounts.length>0){
                    for(var i=0; i<json.data.CIF.Accounts.length; i++){
                        if((json.data.CIF.Accounts[i].AccountType=='1')&&(json.data.CIF.Accounts[i].AccountStatus=="A") &&(json.data.CIF.Accounts[i].AccountCategoryID=="4")){
                            rootState.CD.Account.AccountId = json.data.CIF.Accounts[i].AccountID
                            rootState.AOD.OnBoardUTAccountNo  = json.data.CIF.Accounts[i].AccountID
                        }
                    }
                }
            } 
             if(json.data.Account != undefined){
                 if(json.data.Account.length > 0){
                     for(var i=0; i < json.data.Account.length; i++){
                         if((json.data.Account[i].AccountType=="1") && (json.data.Account[i].AccountStatus == "A") && (json.data.Account[i].AccountCategory=="4")){ 
                            rootState.AOD.PersonalInformation.FullName =  json.data.Account[i].AccountName
                            rootState.CD.CustomerDetails.CustomerName = json.data.Account[i].AccountName
                            rootState.CD.CustomerDetails.CustomerId = json.data.Account[i].CustomerID
                            rootState.AOD.ContactInformation.MobileNo = json.data.Account[i].TelMobile
                            rootState.AOD.ContactInformation.EmailAddress = json.data.Account[i].Email
                            rootState.CD.Account.AccountId = json.data.Account[i].AccountID
                            rootState.AOD.OnBoardUTAccountNo  = json.data.Account[i].AccountID
                         }
                     }
                 }
             }*/   
    },

    
            //rootState.AOD.OnBoardUTAccountNo

            
    async GetLastServicingAgent({commit, state, rootState,dispatch} ,Obj){

        return this.$httpClient({
            method: "get",
            url: apiconnectuat+'cif/getlatestservicingagentbyplan?paccountid='+rootState.AOD.OnBoardUTAccountNo+'&pplan=EPF',
            // headers: { Authorization: "Bearer " + state.CIFAPIToken  }
            //CIFToken
           //process.env.VUE_APP_BYSERVICING_AGENT
        }).then(function(json){
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(json)
            }) 
          

            if(json.data.getlatestservicingagentbyplanResult != undefined){
                if(json.data.getlatestservicingagentbyplanResult.length != 0){
                    for(var i = 0; i< json.data.getlatestservicingagentbyplanResult.length; i++){
                        console.log(json.data.getlatestservicingagentbyplanResult[i].AgentID)
                        rootState.Transactions.AgentDetails = json.data.getlatestservicingagentbyplanResult[i].AgentID
                    }
                }else{
                    rootState.Transactions.AgentDetails = ''
                }
            }else{
                rootState.Transactions.AgentDetails = ''
            }
           
            return true
            }) .catch(function (error) {

            var payload = "Method:  GetLastServicingAgent -> " + error.toString()
            dispatch('GenEmail',{payload: payload}) 
                dispatch('Logging',{
                  typeid:'3',
                  appid:'2',
                  str:payload
                })   
                return error
            });


    },
    async CIFAccountInformationUpdate({commit, state, rootState,dispatch} ,Obj){
      
        return this.$httpClient({
            method: "post",
            url: apiconnectuat+'cif/account/'+ rootState.CD.Account.AccountId ,
            // headers: { Authorization: "Bearer " +  state.CIFAPIToken},
            //CIFToken
            //process.env.VUE_APP_CIF
             data : {
                "Action": "U",
                "ActionBy": rootState.CD.CustomerDetails.CustomerId ,
                "Account": {
                  "TelMobile": rootState.AOD.ContactInformation.MobileNo,
                  "Email": rootState.AOD.ContactInformation.EmailAddress
                 }
              
              }
        }).then(function(json){
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(json)
            })
            if(json.data.isSuccessful==true){
                return true
            }else{
                return false
            }
        }) .catch(function (error) {
             var payload = "Method:  CIFAccountInformationUpdate -> " + error.toString()
             dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
              typeid:'3',
              appid:'2',
              str:payload
            }) 
           // console.log(error);
            return false
        });
    },
    /* 
    async GetCif({commit, state, rootState,dispatch} ,Obj){
      
        return axios({
            method: "get",
            url: apiconnectuat+'/cif/'+ Obj.ApplicationId + '/enquiry/customerinformation',
           headers: { Authorization: "Bearer " + CIFUATToken }
        }).then(function(json){
            console.log(json.data)
              rootState.AOD.PersonalInformation.FullName=json.data.CIF.CustomerDetail.Name
         
            rootState.CD.CustomerDetails.CustomerName = json.data.CIF.CustomerDetail.Name
            rootState.CD.CustomerDetails.CustomerId = json.data.CIF.CustomerID

            if((json.data.CIF.CustomerDetail.TelMobile!="")||(json.data.CIF.CustomerDetail.TelMobile!=undefined)){
                rootState.AOD.ContactInformation.MobileNo = json.data.CIF.CustomerDetail.TelMobile
            }

            if(json.data.CIF.Accounts!=undefined){
                if(json.data.CIF.Accounts.length>0){
                    for(var i=0; i<json.data.CIF.Accounts.length; i++){
                        if((json.data.CIF.Accounts[i].AccountType=='1')&&(json.data.CIF.Accounts[i].AccountStatus=="A") &&(json.data.CIF.Accounts[i].AccountCategoryID=="4")){
                            rootState.CD.Account.AccountId = json.data.CIF.Accounts[i].AccountID
                            rootState.AOD.OnBoardUTAccountNo  = json.data.CIF.Accounts[i].AccountID
                        }
                    }
                }
            }
            
            
            return true

        }) .catch(function (error) {
            console.log(error);
            return false
        });
    },
     */
    
    async GetApplicationAvailableUnitCheck({state,rootState ,dispatch}, Obj) {

        return this.$httpClient({
            method: 'GET',
            url: apiconnectuat +'transaction/application/'+Obj.applicationId+'/availableunitcheck?byagent=true',
            // headers: {
            //     Authorization: 'Bearer ' + state.TransactionAPIToken
            // }
            })
            .then(function (response) {
                dispatch('Logging',{
                    typeid:'3',
                    appid:'2',
                    str:JSON.stringify(response)
                })
                rootState.Transactions.fundUnitConfirm = [];
                var returnObj = response.data
                if(returnObj.SchemeList != undefined){
                    for(var i=0; i<returnObj.SchemeList.length; i++){
                        if(returnObj.SchemeList[i].SchemeUnitAvailableFlag === false){
                            rootState.Transactions.fundUnitConfirm.push({
                                Scheme : returnObj.SchemeList[i].Scheme,
                                SchemeName:'',
                                SchemeUnitAvailable : returnObj.SchemeList[i].SchemeUnitAvailable.toFixed(2),
                                TransactionUnit: returnObj.SchemeList[i].TotalUnit.toFixed(2)
                            })    
                        }
                    }

                    if(rootState.Transactions.fundUnitConfirm.length>0){
                        if(rootState.Lookup.Schemes_LK_2.length>0){
                            for(var i=0; i<rootState.Transactions.fundUnitConfirm.length; i++){
                                for(var j=0; j<rootState.Lookup.Schemes_LK_2.length; j++){
                                    if(rootState.Transactions.fundUnitConfirm[i].Scheme === rootState.Lookup.Schemes_LK_2[j].Scheme){
                                        rootState.Transactions.fundUnitConfirm[i].SchemeName = rootState.Lookup.Schemes_LK_2[j].SchemeName
                                    }
                                }
                            }
                        }
                    }
                }
                return '1'
            })
            .catch(function (error) {
                var payload = "Method:  GetApplicationAvailableUnitCheck -> " + error.toString()
                dispatch('GenEmail',{payload: payload}) 
   
                dispatch('Logging',{
                    typeid:'3',
                    appid:'2',
                    str:payload
                }) 
               return error.toString();
           });
    },
    //Onelook API
    async GetAccountHoldings({ AccountId,state,rootState ,dispatch}, Obj) {
     //   console.clear()
        AccountId = rootState.CD.Account.AccountId

        return this.$httpClient({
            method: 'GET',
            url: apiconnectuat +'onelook/getaccountholdingself',
            params: {

                pinvestorid: AccountId,
                pexcludechannelgroup: 'IUTA'
            },
            // headers: {
            //     Authorization: 'Bearer ' + state.OnelookAPIToken
            //     //token_AUM_ACCOUNTHOLDING
            //     //process.env.VUE_APP_AUM_ACCOUNTHOLDING
            // }
            })
        .then(function (response) {
            
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(response)
            })

            rootState.CD.Holdings = [];
            rootState.CD.NonEPFHoldings = [];
            var nonEpfHolding=[];
            var EpfHolding=[];
            var check = false;
            var msg = '';
            var AccountHolding = response.data.GetAccountHoldingSelfResult
            
            console.log(AccountHolding)
            //console.log(rootState.Transactions.IncomingEMISFUND)
            if(AccountHolding.length>0){
                 for(var i=0; i<AccountHolding.length; i++){
                    rootState.CD.Account.AccountId=AccountHolding[i].InvestorID
                    if((AccountHolding[i].Units!=0)&&(AccountHolding[i].Plan ==='EPF')){
                         for(var z=0; z <rootState.Transactions.IncomingEMISFUND.length; z++){
                            if((rootState.Transactions.IncomingEMISFUND[z].AhamSchemeCode==AccountHolding[i].Scheme)){
                                var tempUnits=0
                           //     console.log(AccountHolding[i].Scheme)
                                var tempFloatingUnitOut = 0;
                                var tempFloatingUnitIn = 0;

                                var tempSubmittedUnitOut = 0;
                                var tempSubmittedUnitIn = 0;
                                var FloatingUnit = 0;

                              //  console.log('---- + EMIS FUND START +---- ')
                                if(AccountHolding[i].Units == undefined){
                                    AccountHolding[i].Units = 0
                                }
                                tempUnits = AccountHolding[i].Units + tempUnits
                                //console.log("tempUnits - > " + tempUnits)


                                if(AccountHolding[i].FloatingUnitOut == undefined){
                                    AccountHolding[i].FloatingUnitOut = 0
                                }
                                tempFloatingUnitOut =  parseFloat(AccountHolding[i].FloatingUnitOut) + parseFloat(tempFloatingUnitOut)
                               // console.log("tempFloatingUnitOut -> " + parseFloat(tempFloatingUnitOut))

                                if(AccountHolding[i].FloatingUnitIn == undefined){
                                    AccountHolding[i].FloatingUnitIn = 0
                                }
                                tempFloatingUnitIn = parseFloat(AccountHolding[i].FloatingUnitIn) + parseFloat(tempFloatingUnitIn)
                              //  console.log(tempFloatingUnitIn)
                                
                                if(AccountHolding[i].SubmittedUnitOut == undefined){
                                    AccountHolding[i].SubmittedUnitOut = 0
                                }
                                tempSubmittedUnitOut =  parseFloat(AccountHolding[i].SubmittedUnitOut) +  parseFloat(tempSubmittedUnitOut)
                               // console.log("tempSubmittedUnitOut -> " + parseFloat(tempSubmittedUnitOut))


                                if(AccountHolding[i].SubmittedUnitIn == undefined){
                                    AccountHolding[i].SubmittedUnitIn = 0
                                }
                                tempSubmittedUnitIn = parseFloat(AccountHolding[i].SubmittedUnitIn) +  parseFloat(tempSubmittedUnitIn)
                                //console.log("tempSubmittedUnitIn -> " + parseFloat(tempSubmittedUnitIn))

                                var BalanceAvailableUnit=  parseFloat(tempUnits) - parseFloat(tempFloatingUnitOut) - parseFloat(tempSubmittedUnitOut)
                                var pendingRedemptionUnit =  parseFloat(tempFloatingUnitOut) + parseFloat(tempSubmittedUnitOut)
                                var pendingInvestmentUnit = parseFloat(tempFloatingUnitIn) + parseFloat(tempSubmittedUnitIn)
                                
                               // console.log("BalanceAvailableUnit -> " + parseFloat(BalanceAvailableUnit))
                               // console.log("pendingRedemptionUnit -> " + parseFloat(pendingRedemptionUnit))
                               // console.log("pendingInvestmentUnit -> " + parseFloat(pendingInvestmentUnit))
                                
                               /* console.log(tempNav.toFixed(4))
                               console.log('---- + EMIS FUND END +---- ') */

                                
                                EpfHolding.push({
                                    CustomerId: AccountHolding[i].CustomerId,
                                    AccountID: AccountHolding[i].InvestorID,
                                    Scheme: AccountHolding[i].Scheme,
                                    ProductName: AccountHolding[i].ProductName,
                                    Plan: AccountHolding[i].Plan,
                                    ProductType : AccountHolding[i].Plan,
                                    FloatingUnit : parseFloat(FloatingUnit),
                                    pendingRedemptionUnit : parseFloat(pendingRedemptionUnit),
                                    pendingInvestmentUnit : parseFloat(pendingInvestmentUnit),
                                    BalanceUnit: parseFloat(BalanceAvailableUnit),
                                    Amount: parseFloat(AccountHolding[i].AUM),
                                    NAV: AccountHolding[i].NAV.toFixed(4),
                                    Channel : 'EMIS',
                                    AgentID: AccountHolding[i].AgentID,
                                    Currency: AccountHolding[i].Currency,
                                    NAVDate: AccountHolding[i].AsOfDate,
                                })

                                //to remove funds that inserted in EMIS holding array
                                //AccountHolding.splice(i,1)

                             
                                //AccountHolding.splice(i,1)
                               // AhamSchemeCode
                            }
                        }
                    }
                        check = true
                } 


                let totalEPF = 0
                let FloatingUnitEPF = 0
                let pendingRedemptionUnitEPF= 0
                let pendingInvestmentUnitEPF = 0
                let BalanceUnitEPF = 0
                let CustomerIdEPF=''
                let AccountIDEPF=''
                let ProductNameEPF = ''
                let PlanEPF=''
                let ProductTypeEPF=''
                let NAVEPF =''
                let ChannelEPF= ''
                let CurrencyEPF=''
                let NAVDateEPF=''
                let AgentIDEPF=''

                let object = [] // {scheme:'',total:0}                    
                var Scheme = EpfHolding
                for(var i=0;i<Scheme.length;i++){
                    if(object.length>0){
                        if(object.find(x=>x.scheme===Scheme[i].Scheme)!==undefined){
                            var index = object.findIndex(x=>x.scheme===Scheme[i].Scheme)
                            object[index].totalEPF = object[index].totalEPF + Scheme[i].Amount
                            object[index].FloatingUnitEPF = object[index].FloatingUnitEPF + Scheme[i].FloatingUnit
                            object[index].pendingRedemptionUnitEPF = object[index].pendingRedemptionUnitEPF + Scheme[i].pendingRedemptionUnit
                            object[index].pendingInvestmentUnitEPF = object[index].pendingInvestmentUnitEPF + Scheme[i].pendingInvestmentUnit
                            object[index].BalanceUnitEPF = object[index].BalanceUnitEPF + Scheme[i].BalanceUnit
                            if(objectNon[index].NAVNon === "0.0000"){
                                objectNon[index].NAVNon =  NonScheme[i].NAV
                            }
                        }
                        else{
                            object.push({
                                scheme : Scheme[i].Scheme,
                                totalEPF : Scheme[i].Amount,
                                FloatingUnitEPF:Scheme[i].FloatingUnit,
                                pendingRedemptionUnitEPF:Scheme[i].pendingRedemptionUnit,
                                pendingInvestmentUnitEPF:Scheme[i].pendingInvestmentUnit,
                                BalanceUnitEPF:Scheme[i].BalanceUnit,
                                CustomerIdEPF:Scheme[i].CustomerId,
                                AccountIDEPF:Scheme[i].AccountID,
                                ProductNameEPF:Scheme[i].ProductName,
                                PlanEPF:Scheme[i].Plan,
                                ProductTypeEPF:Scheme[i].ProductType,
                                NAVEPF :Scheme[i].NAV,
                                ChannelEPF:Scheme[i].Channel,
                                CurrencyEPF:Scheme[i].Currency,
                                NAVDateEPF:Scheme[i].NAVDate,
                                AgentIDEPF:Scheme[i].AgentID
                            })
                        }
                    }else{
                        object.push({
                            scheme : Scheme[i].Scheme,
                            totalEPF : Scheme[i].Amount,
                            FloatingUnitEPF:Scheme[i].FloatingUnit,
                            pendingRedemptionUnitEPF:Scheme[i].pendingRedemptionUnit,
                            pendingInvestmentUnitEPF:Scheme[i].pendingInvestmentUnit,
                            BalanceUnitEPF:Scheme[i].BalanceUnit,
                            CustomerIdEPF:Scheme[i].CustomerId,
                            AccountIDEPF:Scheme[i].AccountID,
                            ProductNameEPF:Scheme[i].ProductName,
                            PlanEPF:Scheme[i].Plan,
                            ProductTypeEPF:Scheme[i].ProductType,
                            NAVEPF :Scheme[i].NAV,
                            ChannelEPF:Scheme[i].Channel,
                            CurrencyEPF:Scheme[i].Currency,
                            NAVDateEPF:Scheme[i].NAVDate,
                            AgentIDEPF:Scheme[i].AgentID
                        })
                    }     
                }      

                for(var objectSize=0; objectSize<object.length; objectSize++){
                     
                    rootState.CD.Holdings.push({
                        CustomerId: object[objectSize].CustomerIdEPF,                                    
                        AccountID: object[objectSize].AccountIDEPF,
                        Scheme: object[objectSize].scheme,
                        ProductName: object[objectSize].ProductNameEPF,
                        Plan: object[objectSize].PlanEPF,
                        ProductType : object[objectSize].ProductTypeEPF,
                        FloatingUnit : parseFloat(object[objectSize].FloatingUnitEPF).toFixed(2),
                        pendingRedemptionUnit : parseFloat(object[objectSize].pendingRedemptionUnitEPF).toFixed(2),
                        pendingInvestmentUnit : parseFloat(object[objectSize].pendingInvestmentUnitEPF).toFixed(2),
                        BalanceUnit: parseFloat(object[objectSize].BalanceUnitEPF).toFixed(2),
                        Amount: parseFloat(object[objectSize].totalEPF).toFixed(2),
                        NAV: object[objectSize].NAVEPF,
                        Channel : object[objectSize].ChannelEPF,
                        AgentID: object[objectSize].AgentIDEPF,
                        Currency: object[objectSize].CurrencyEPF,
                        NAVDate: object[objectSize].NAVDateEPF 
                    }) 
                }
                check = true
            }else{
                check = false
                msg= 'Sorry, unable to retrieve investor Fund'
            }
            
            //to remove funds already in aham epf array
            var b =rootState.Transactions.IncomingEMISFUND 
            const res = AccountHolding.filter(({Scheme:a, item:x}) => !b.some(({AhamSchemeCode:b, item:y}) => a === b && x === y));

            //console.table(res)
            //console.table(AccountHolding)

                AccountHolding = res
              if(AccountHolding.length>0){

                 for(var i=0; i<AccountHolding.length; i++){
                    rootState.CD.Account.AccountId=AccountHolding[i].InvestorID
                    if((AccountHolding[i].Units!=0)&&(AccountHolding[i].Plan ==='EPF')){
                                 
                         for(var z=0; z <rootState.Transactions.IncomingEMISFUND.length; z++){
                                var tempUnits=0
                                var tempFloatingUnitOut = 0;
                                var tempFloatingUnitIn = 0;

                                var tempSubmittedUnitOut = 0;
                                var tempSubmittedUnitIn = 0;
                                var FloatingUnit = 0;

                                //console.log('---- + AHAM FUND START +---- ')
                                if(AccountHolding[i].Units == undefined){
                                    AccountHolding[i].Units = 0
                                }
                                tempUnits = AccountHolding[i].Units + tempUnits


                                if(AccountHolding[i].FloatingUnitOut == undefined){
                                    AccountHolding[i].FloatingUnitOut = 0
                                }
                                tempFloatingUnitOut =  parseFloat(AccountHolding[i].FloatingUnitOut) + parseFloat(tempFloatingUnitOut)
                            //  console.log("tempFloatingUnitOut -> " + parseFloat(tempFloatingUnitOut))

                                if(AccountHolding[i].FloatingUnitIn == undefined){
                                    AccountHolding[i].FloatingUnitIn = 0
                                }
                                tempFloatingUnitIn = parseFloat(AccountHolding[i].FloatingUnitIn) + parseFloat(tempFloatingUnitIn)
                            //  console.log(tempFloatingUnitIn)
                                
                                if(AccountHolding[i].SubmittedUnitOut == undefined){
                                    AccountHolding[i].SubmittedUnitOut = 0
                                }
                                tempSubmittedUnitOut =  parseFloat(AccountHolding[i].SubmittedUnitOut) +  parseFloat(tempSubmittedUnitOut)
                            //   console.log("tempSubmittedUnitOut -> " + parseFloat(tempSubmittedUnitOut))


                                if(AccountHolding[i].SubmittedUnitIn == undefined){
                                    AccountHolding[i].SubmittedUnitIn = 0
                                }
                                tempSubmittedUnitIn = parseFloat(AccountHolding[i].SubmittedUnitIn) +  parseFloat(tempSubmittedUnitIn)
                            //  console.log("tempSubmittedUnitIn -> " + parseFloat(tempSubmittedUnitIn))



                            var BalanceAvailableUnit=  parseFloat(tempUnits) - parseFloat(tempFloatingUnitOut) - parseFloat(tempSubmittedUnitOut)
                            var pendingRedemptionUnit =  parseFloat(tempFloatingUnitOut) + parseFloat(tempSubmittedUnitOut)
                            var pendingInvestmentUnit = parseFloat(tempFloatingUnitIn) + parseFloat(tempSubmittedUnitIn)
                            
                               /* console.log(tempNav.toFixed(4))
                               console.log('---- + AHAM FUND END +---- ') */

                                    // rootState.CD.NonEPFHoldings.
                                     nonEpfHolding.push({
                                        CustomerId: AccountHolding[i].CustomerId,
                                        AccountID: AccountHolding[i].InvestorID,
                                        Scheme: AccountHolding[i].Scheme,
                                        ProductName: AccountHolding[i].ProductName,
                                        Plan: AccountHolding[i].Plan,
                                        ProductType : AccountHolding[i].Plan,
                                        FloatingUnit : parseFloat(FloatingUnit),
                                        pendingRedemptionUnit : parseFloat(pendingRedemptionUnit),
                                        pendingInvestmentUnit : parseFloat(pendingInvestmentUnit),
                                        BalanceUnit: parseFloat(BalanceAvailableUnit),
                                        Amount: parseFloat(AccountHolding[i].AUM),
                                        NAV: AccountHolding[i].NAV.toFixed(4),
                                        Channel : 'AHAM',
                                        AgentID: AccountHolding[i].AgentID,
                                        Currency: AccountHolding[i].Currency,
                                        NAVDate: AccountHolding[i].AsOfDate,
                                    }) 
   
               
                            }
                        }
                                     

                  //  console.log(rootState.CD.NonEPFHoldings)

                        check = true
                   
                } 

            // console.table(nonEpfHolding)
                    let total = 0
                    let FloatingUnitNon = 0
                    let pendingRedemptionUnitNon= 0
                    let pendingInvestmentUnitNon = 0
                    let BalanceUnitNon = 0
                    let CustomerIdNon=''
                    let AccountIDNon=''
                    let ProductNameNon = ''
                    let PlanNon=''
                    let ProductTypeNon=''
                    let NAVNon =''
                    let ChannelNon= ''
                    let CurrencyNon=''
                    let NAVDateNon=''
                    let AgentIDNon=''

                    let objectNon = [] // {scheme:'',total:0}                    
                    var NonScheme = nonEpfHolding
                    
                    for(var i=0;i<NonScheme.length;i++){
                        if(objectNon.length>0){
                            if(objectNon.find(x=>x.scheme===NonScheme[i].Scheme)!==undefined){
                                var index = objectNon.findIndex(x=>x.scheme===NonScheme[i].Scheme)
                                objectNon[index].total = objectNon[index].total + NonScheme[i].Amount
                                objectNon[index].FloatingUnitNon = objectNon[index].FloatingUnitNon + NonScheme[i].FloatingUnit
                                objectNon[index].pendingRedemptionUnitNon = objectNon[index].pendingRedemptionUnitNon + NonScheme[i].pendingRedemptionUnit
                                objectNon[index].pendingInvestmentUnitNon = objectNon[index].pendingInvestmentUnitNon + NonScheme[i].pendingInvestmentUnit
                                objectNon[index].BalanceUnitNon = objectNon[index].BalanceUnitNon + NonScheme[i].BalanceUnit

                                if(objectNon[index].NAVNon === "0.0000"){
                                    objectNon[index].NAVNon =  NonScheme[i].NAV
                                }
                            }
                            else{
                                objectNon.push({
                                    scheme : NonScheme[i].Scheme,
                                    total : NonScheme[i].Amount,
                                    FloatingUnitNon:NonScheme[i].FloatingUnit,
                                    pendingRedemptionUnitNon:NonScheme[i].pendingRedemptionUnit,
                                    pendingInvestmentUnitNon:NonScheme[i].pendingInvestmentUnit,
                                    BalanceUnitNon:NonScheme[i].BalanceUnit,
                                    CustomerIdNon:NonScheme[i].CustomerId,
                                    AccountIDNon:NonScheme[i].AccountID,
                                    ProductNameNon:NonScheme[i].ProductName,
                                    PlanNon:NonScheme[i].Plan,
                                    ProductTypeNon:NonScheme[i].ProductType,
                                    NAVNon :NonScheme[i].NAV,
                                    ChannelNon:NonScheme[i].Channel,
                                    CurrencyNon:NonScheme[i].Currency,
                                    NAVDateNon:NonScheme[i].NAVDate,
                                    AgentIDNon:NonScheme[i].AgentID
                                })
                            }
                        }else{
                            objectNon.push({
                                scheme : NonScheme[i].Scheme,
                                total : NonScheme[i].Amount,
                                FloatingUnitNon:NonScheme[i].FloatingUnit,
                                pendingRedemptionUnitNon:NonScheme[i].pendingRedemptionUnit,
                                pendingInvestmentUnitNon:NonScheme[i].pendingInvestmentUnit,
                                BalanceUnitNon:NonScheme[i].BalanceUnit,
                                CustomerIdNon:NonScheme[i].CustomerId,
                                AccountIDNon:NonScheme[i].AccountID,
                                ProductNameNon:NonScheme[i].ProductName,
                                PlanNon:NonScheme[i].Plan,
                                ProductTypeNon:NonScheme[i].ProductType,
                                NAVNon :NonScheme[i].NAV,
                                ChannelNon:NonScheme[i].Channel,
                                CurrencyNon:NonScheme[i].Currency,
                                NAVDateNon:NonScheme[i].NAVDate,
                                AgentIDNon:NonScheme[i].AgentID
                            })
                        }     
                    }                    
                  //  console.table(objectNon)

                    for(var objectSize=0; objectSize<objectNon.length; objectSize++){
                        
                        rootState.CD.NonEPFHoldings.push({
                            CustomerId: objectNon[objectSize].CustomerIdNon,                                    
                            AccountID: objectNon[objectSize].AccountIDNon,
                            Scheme: objectNon[objectSize].scheme,
                            ProductName: objectNon[objectSize].ProductNameNon,
                            Plan: objectNon[objectSize].PlanNon,
                            ProductType : objectNon[objectSize].ProductTypeNon,
                            FloatingUnit : parseFloat(objectNon[objectSize].FloatingUnitNon).toFixed(2),
                            pendingRedemptionUnit : parseFloat(objectNon[objectSize].pendingRedemptionUnitNon).toFixed(2),
                            pendingInvestmentUnit : parseFloat(objectNon[objectSize].pendingInvestmentUnitNon).toFixed(2),
                            BalanceUnit: parseFloat(objectNon[objectSize].BalanceUnitNon).toFixed(2),
                            Amount: parseFloat(objectNon[objectSize].total).toFixed(2),
                            NAV: objectNon[objectSize].NAVNon,
                            Channel : objectNon[objectSize].ChannelNon,
                            AgentID: objectNon[objectSize].AgentIDNon,
                            Currency: objectNon[objectSize].CurrencyNon,
                            NAVDate: objectNon[objectSize].NAVDateNon 
                        }) 
                    }
                check = true
            }   
           //return true;
           if(check === true){
               return true
           }else{
               return msg
           }
        })
        .catch(function (error) {
          var payload = "Method: GetAccountHoldings -> " + error.toString()

            dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
              typeid:'3',
              appid:'2',
              str:payload
            })   
            //console.log(error);
            return -1
        });
    },
    //ONBOARDING API
    async GetOnboardingSelf({ getters, rootState,state,dispatch }, Obj){
       
        return this.$httpClient({
            method: "get",
            url: apipath_onboarding_self + '/' + Obj.ApplicationId, 
            // headers: { Authorization: "Bearer " +  state.OnboardingAPIToken}
            //process.env.VUE_APP_ONBOARDING
        })
        .then(function (response) {
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(response)
            })
          //  console.log(response.data)
            if(response.data.Salutation!= undefined){
                for (var i =0; i<rootState.Lookup.Salutation_LK.length; i++){ 
                  //  console.log(response.data.Salutation)
                     if(response.data.Salutation== rootState.Lookup.Salutation_LK[i].value){
                     //    console.log(response.data.Salutation)
                        rootState.AOD.PersonalInformation.Salutation  =  rootState.Lookup.Salutation_LK[i].label
                     }
                 }
             }
            //rootState.AOD.PersonalInformation.Salutation 
            //= getters.GetSalutationNameByValue(response.data.Salutation)
           if(response.data.Status != undefined){

            rootState.CD.applicationStatus = response.data.Status 
           }else{
               
            rootState.CD.applicationStatus = ""
           }
            rootState.AOD.PersonalInformation.FullName = response.data.CustomerName
            rootState.AOD.PersonalInformation.NRIC = response.data.NRIC
            rootState.AOD.PersonalInformation.OldID = response.data.OldID
            if((response.data.NRIC != undefined)||(response.data.NRIC !="")){

                rootState.CD.CustomerDetails.CustomerId = response.data.NRIC
            }else{
                rootState.CD.CustomerDetails.CustomerId = response.data.OldID
            }

            if(response.data.Race!= undefined){
                for (var i =0; i<rootState.Lookup.Salutation_LK.length; i++){ 
                   // console.log(response.data.Rac)
                     //if(response.data.Race== rootState.Lookup.Race_LK[i].value){
                        // console.log(response.data.Salutation)
                      //  rootState.AOD.PersonalInformation.Race  =  rootState.Lookup.Race_LK[i].label
                    // }
                 }
             }

            rootState.AOD.PersonalInformation.Race = getters.GetRaceNameByValue(response.data.Race)
            rootState.AOD.PersonalInformation.DateOfBirth = response.data.DOB
            rootState.AOD.PersonalInformation.Gender = getters.GetGenderNameByValue(response.data.Gender)
            //rootState.AOD.PersonalInformation.CountryOfBirth = getters.GetCountryNameByValue(response.data.CountryOfBirth)
            
            rootState.AOD.PersonalInformation.Age=response.data.Age
            //rootState.AOD.PersonalInformation.Nationality = getters.GetNationalityNameByValue(response.data.Nationality)
            rootState.AOD.PersonalInformation.EPFNumber = response.data.EPFNo
            rootState.CD.CustomerDetails.EPFNo = response.data.EPFNo
            rootState.AOD.PersonalInformation.EPFAccountType= response.data.EPFAccountType
            rootState.AOD.PersonalInformation.EPFIEffectiveDate= response.data.EPFIEffectiveDate
            //rootState.AOD.PersonalInformation.HolderStatus = getters.GetHolderStatusNameByValue(response.data.HolderStatus)
            //rootState.AOD.PersonalInformation.MaritalStatus= getters.GetMaritalStatusNameByValue(response.data.MaritalStatus)
            if(response.data.MaritalStatus!= undefined){
                for (var i =0; i<rootState.Lookup.MaritalStatus_LK.length; i++){ 
                   // console.log(response.data.Rac)
                     if(response.data.MaritalStatus== rootState.Lookup.MaritalStatus_LK[i].value){
                        // console.log(response.data.Salutation)
                        rootState.AOD.PersonalInformation.MaritalStatus  =  rootState.Lookup.MaritalStatus_LK[i].label
                     }
                 }
             }

             if(response.data.HolderStatus!= undefined){
                for (var i =0; i<rootState.Lookup.HolderStatus_LK.length; i++){ 
                   // console.log(response.data.Rac)
                     if(response.data.HolderStatus== rootState.Lookup.HolderStatus_LK[i].value){
                        // console.log(response.data.Salutation)
                        rootState.AOD.PersonalInformation.HolderStatus  =  rootState.Lookup.HolderStatus_LK[i].label
                     }
                 }
             }

             if(response.data.Nationality!= undefined){
                for (var i =0; i<rootState.Lookup.Nationality_LK.length; i++){ 
                   // console.log(response.data.Rac)
                     if(response.data.Nationality== rootState.Lookup.Nationality_LK[i].value){
                        // console.log(response.data.Salutation)
                        rootState.AOD.PersonalInformation.Nationality  =  rootState.Lookup.Nationality_LK[i].label
                        
                     }
                 }
             }

             if(response.data.Nationality!= undefined){
                for (var i =0; i<rootState.Lookup.Nationality_LK.length; i++){ 
                   // console.log(response.data.Rac)
                     if(response.data.Nationality== rootState.Lookup.Nationality_LK[i].value){
                        // console.log(response.data.Salutation)
                        rootState.AOD.PersonalInformation.Nationality  =  rootState.Lookup.Nationality_LK[i].label
                        
                     }
                 }
             }
             
             if(response.data.CountryOfBirth!= undefined){
                for (var i =0; i<rootState.Lookup.Country_LK.length; i++){ 
                   // console.log(response.data.Rac)
                     if(response.data.CountryOfBirth=== rootState.Lookup.Country_LK[i].value){
                        // console.log(response.data.Salutation)
                        rootState.AOD.PersonalInformation.CountryOfBirth  =  rootState.Lookup.Country_LK[i].label
                        
                     }
                 }
             }


            rootState.AOD.MonthlyHouseholdIncome= response.data.MonthlyHouseholdIncome
            //.toFixed(2)
            rootState.AOD.PersonalInformation.SourceOfWealth=response.data.SourceOfWealth
                if((response.data.SourceOfWealth == undefined)||(response.data.SourceOfWealth =="")){
                    ":[]"
                
                    }
                    else {
                        rootState.AOD.PersonalInformation.SourceOfWealthNames= response.data.SourceOfWealth.join()
                    } 
            rootState.AOD.PersonalInformation.SourceOfWealthOther=response.data.SourceOfWealthOth
            rootState.AOD.PersonalInformation.InvestmentPurpose= response.data.InvestmentPurpose
             if((response.data.InvestmentPurpose == undefined)||(response.data.InvestmentPurpose =="")){
                ":[]"
            
                }
                else if((response.data.InvestmentPurpose != undefined)||(response.data.InvestmentPurpose !="")){
                    rootState.AOD.PersonalInformation.InvestmentPurposeNames= response.data.InvestmentPurpose.join()
                } 
            rootState.AOD.PersonalInformation.InvestmentPurposeOther=response.data.InvestmentPurposeOth
            rootState.AOD.ContactInformation.MobileNo = response.data.TelMobile
            rootState.AOD.ContactInformation.MobileNoCode=response.data.TelMobileCountryCode
            rootState.AOD.ContactInformation.EmailAddress = response.data.EmailAddress
            rootState.AOD.AddressInformation.PermanentAddress.Address1 = response.data.PermanentAddress.AddressLine1
            rootState.AOD.AddressInformation.PermanentAddress.Address2 = response.data.PermanentAddress.AddressLine2
            rootState.AOD.AddressInformation.PermanentAddress.Address3 = response.data.PermanentAddress.AddressLine3
            rootState.AOD.AddressInformation.PermanentAddress.City = response.data.PermanentAddress.City
            rootState.AOD.AddressInformation.PermanentAddress.Postcode = response.data.PermanentAddress.Postcode
            rootState.AOD.AddressInformation.PermanentAddress.State = getters.GetStateNameByValue(response.data.PermanentAddress.State)
            //rootState.AOD.AddressInformation.PermanentAddress.StateForeign = response.data.PermanentAddress.StateForeign
            rootState.AOD.AddressInformation.PermanentAddress.Country = getters.GetCountryNameByValue(response.data.PermanentAddress.Country)
            if(response.data.PermanentAddress.Country!= undefined){
                for (var i =0; i<rootState.Lookup.Nationality_LK.length; i++){ 
                   // console.log(response.data.Rac)
                     if(response.data.PermanentAddress.Country== rootState.Lookup.Nationality_LK[i].value){
                        // console.log(response.data.Salutation)
                        rootState.AOD.AddressInformation.PermanentAddress.Country  =  rootState.Lookup.Nationality_LK[i].label
                        
                     }
                 }
             }

            rootState.AOD.AddressInformation.CorrespondenceAddress.Address1 = response.data.CorrespondenceAddress.AddressLine1
            if(rootState.AOD.AddressInformation.CorrespondenceAddress.Address1==""){
                state.hideCorrespondenceAdd = true;
            }
            rootState.AOD.AddressInformation.CorrespondenceAddress.Address2 = response.data.CorrespondenceAddress.AddressLine2
            rootState.AOD.AddressInformation.CorrespondenceAddress.Address3 = response.data.CorrespondenceAddress.AddressLine3
            rootState.AOD.AddressInformation.CorrespondenceAddress.City = response.data.CorrespondenceAddress.City
            rootState.AOD.AddressInformation.CorrespondenceAddress.Postcode = response.data.CorrespondenceAddress.Postcode
            //rootState.AOD.AddressInformation.CorrespondenceAddress.State = getters.GetStateNameByValue(response.data.CorrespondenceAddress.State)
            rootState.AOD.AddressInformation.CorrespondenceAddress.StateForeign = response.data.CorrespondenceAddress.StateForeign
            //rootState.AOD.AddressInformation.CorrespondenceAddress.Country = getters.GetCountryNameByValue(response.data.CorrespondenceAddress.Country)
            
            if(response.data.EmployementStatus!= undefined){
                for (var i =0; i<rootState.Lookup.EmploymentStatus_LK.length; i++){ 
                     if(response.data.EmployementStatus== rootState.Lookup.EmploymentStatus_LK[i].value){
                        rootState.ED.EmploymentStatus  =  rootState.Lookup.EmploymentStatus_LK[i].label
                      }
                 }
             }

             if(response.data.NatureOfBusiness!= undefined){
                for (var i =0; i<rootState.Lookup.NatureofBusiness_LK.length; i++){ 
                   // console.log(response.data.Rac)
                     if(response.data.NatureOfBusiness== rootState.Lookup.NatureofBusiness_LK[i].value){
                        // console.log(response.data.Salutation)
                        rootState.ED.BusinessNature =  rootState.Lookup.NatureofBusiness_LK[i].label
                      }
                 }
             }
            //rootState.AOD.PersonalInformation.NoOfDependents=response.data.CNoOfDependents
            //rootState.AOD.EmploymentInformation.BusinessNature = response.data.NatureOfBusiness
            rootState.ED.BusinessNatureOther = response.data.NatureOfBusinessOth
            rootState.ED.Designation = response.data.Designation
            rootState.ED.EmployerName = response.data.EmployerName
            rootState.ED.EmployerAddress.Address1 = response.data.EmployerAddress.AddressLine1
            // rootState.ED.EmployerAddress.Address2 = response.data.EmployerAddress.AddressLine2
            // rootState.ED.EmployerAddress.Address3 = response.data.EmployerAddress.AddressLine3
            // rootState.ED.EmployerAddress.City = response.data.EmployerAddress.City
            // rootState.ED.EmployerAddress.Postcode = response.data.EmployerAddress.Postcode
            //rootState.ED.EmployerAddress.State = getters.GetStateNameByValue(response.data.EmployerAddress.State)
            rootState.ED.EmployerAddress.StateForeign = response.data.EmployerAddress.StateForeign
            //rootState.ED.EmployerAddress.Country = getters.GetCountryNameByValue(response.data.EmployerAddress.Country)

            rootState.FATCA.PersonalAssetNames=response.data.NetPersonalAsset
            rootState.FATCA.SophisticatedInvestor= response.data.isSophisticatedInvestor
            if(response.data.TaxResidency!= undefined){
                for (var i =0; i<rootState.Lookup.TaxResidency_LK.length; i++){ 
                    //console.log(response.data.TaxResidency)
                     if(response.data.TaxResidency== rootState.Lookup.TaxResidency_LK[i].value){
                      //   console.log( rootState.Lookup.TaxResidency_LK[i].label)
                        rootState.FATCA.TaxResidency  =  rootState.Lookup.TaxResidency_LK[i].label
                      }
                 }
             }
            rootState.FATCA.UsResident = getters.GetUSResidentNameByValue(response.data.USResidentStatus)
            
            rootState.AOD.OnboardId=response.data._id;
            rootState.AOD.OnboardChannel=response.data.Channel;
            rootState.AOD.OnboardApplicationFormID=response.data.ApplicationFormId;
            rootState.AOD.OnboardStatus=response.data.Status;
            rootState.AOD.OnboardSalutation=response.data.Salutation;
            rootState.AOD.OnboardCustomerName=response.data.CustomerName;
            rootState.AOD.OnboardIdType=response.data.IdType;
            rootState.AOD.OnboardIC=response.data.NRIC;
            rootState.AOD.OnboardOldId=response.data.OldID;
            rootState.AOD.OnboardGender= response.data.Gender;
            rootState.AOD.OnboardDOB=response.data.DOB;
            rootState.AOD.OnboardNationality=response.data.Nationality;
            rootState.AOD.OnboardCountryofBirth=response.data.CountryOfBirth;
            rootState.AOD.OnboardRace=response.data.Race;
            rootState.AOD.OnboardRaceOth=response.data.RaceOth;
            rootState.AOD.OnboardHolderStatus=response.data.HolderStatus
            rootState.AOD.OnboardMobileCountryCode=response.data.TelMobileCountryCode
            rootState.AOD.OnboardMobile = response.data.TelMobile
            // rootState.AOD.Onboardemail=rootState.AD.Creation_loginUserID
            rootState.AOD.Onboardemail = response.data.EmailAddress
            rootState.AD.Creation_loginUserID = response.data.EmailAddress
            //response.data.EmailAddress
            rootState.AOD.OnboardPermanentAddrLine1=response.data.PermanentAddress.AddressLine1
            rootState.AOD.OnboardPermanentAddrLine2=response.data.PermanentAddress.AddressLine2
            rootState.AOD.OnboardPermanentAddrLine3=response.data.PermanentAddress.AddressLine3
            rootState.AOD.OnboardPermanentAddrCity=response.data.PermanentAddress.City
            rootState.AOD.OnboardPermanentAddrCountry=response.data.PermanentAddress.Country
            rootState.AOD.OnboardPermanentAddrPostCode=response.data.PermanentAddress.Postcode
            rootState.AOD.OnboardPermanentAddrState=response.data.PermanentAddress.State
            rootState.AOD.OnboardCorrespondenceAddrLine1=response.data.CorrespondenceAddress.AddressLine1
            rootState.AOD.OnboardCorrespondenceAddrLine2=response.data.CorrespondenceAddress.AddressLine2
            rootState.AOD.OnboardCorrespondenceAddrLine3 = response.data.CorrespondenceAddress.AddressLine3
            rootState.AOD.OnboardCorrespondenceAddrCity = response.data.CorrespondenceAddress.City
            rootState.AOD.OnboardCorrespondenceAddrPostCode = response.data.CorrespondenceAddress.Postcode
            rootState.AOD.OnboardEmployemntStatus = response.data.EmployementStatus

            rootState.AOD.OnboardNatureOfBusiness = response.data.NatureOfBusiness
            rootState.AOD.OnboardNatureofBusinessOth = response.data.NatureOfBusinessOth
            rootState.AOD.OnboardDesignation = response.data.Designation
            rootState.AOD.OnboardEmployerName = response.data.EmployerName 
            rootState.AOD.OnboardEmployerAddressLine1  = response.data.EmployerAddress.AddressLine1 
            rootState.AOD.OnboardNetPersonalAsset = response.data.NetPersonalAsset 

            rootState.AOD.OnboardInvestmentPurpose=[]

            if(response.data.InvestmentPurpose != undefined){
                if(response.data.InvestmentPurpose.length>0){
                    // for(var i = 0; i<response.data.InvestmentPurpose.length; i++){
                         if(response.data.InvestmentPurpose.includes("Savings")){
                             rootState.AOD.OnboardInvestmentPurpose.push({
                                 InvestmentPurpose : "Savings"
                             })
                         }
     
                         if(response.data.InvestmentPurpose.includes("Retirement")){
                             rootState.AOD.OnboardInvestmentPurpose.push({
                                 InvestmentPurpose : "Retirement"
                             })
                         }
     
                         if(response.data.InvestmentPurpose.includes("Education Funding")){
                             rootState.AOD.OnboardInvestmentPurpose.push({
                                 InvestmentPurpose : "Education Funding"
                             })
                         }
     
                         if(response.data.InvestmentPurpose.includes("Enhance Returns")){
                             rootState.AOD.OnboardInvestmentPurpose.push({
                                 InvestmentPurpose : "Enhance Returns"
                             })
                         }
     
                         if(response.data.InvestmentPurpose.includes("Others")){
                             rootState.AOD.OnboardInvestmentPurpose.push({
                                 InvestmentPurpose : "Others"
                             })
                         }
                        
                    // }
                 }
            }
           
            rootState.AOD.OnboardInvestmentPurposeOther = response.data.InvestmentPurposeOth
            rootState.AOD.OnboardSourceOfWealth=[]
            if(response.data.SourceOfWealth != undefined){
                if(response.data.SourceOfWealth.length>0){
                    // for(var i = 0; i<response.data.SourceOfWealth.length; i++){
                        
                         if(response.data.SourceOfWealth.includes("Salary / Bonus")){
                             rootState.AOD.OnboardSourceOfWealth.push({
                                 SourceOfWealth : "Salary / Bonus"
                             })
                         }
         
                         if(response.data.SourceOfWealth.includes("Savings")){
                             rootState.AOD.OnboardSourceOfWealth.push({
                                 SourceOfWealth : "Savings"
                             })
                         }
         
                         if(response.data.SourceOfWealth.includes("Inheritance")){
                             rootState.AOD.OnboardSourceOfWealth.push({
                                 SourceOfWealth : "Inheritance"
                             })
                         }
     
                         if(response.data.SourceOfWealth.includes("Commission")){
                             rootState.AOD.OnboardSourceOfWealth.push({
                                 SourceOfWealth : "Commission"
                             })
                         }
     
                         if(response.data.SourceOfWealth.includes("Investment Proceeds")){
                             rootState.AOD.OnboardSourceOfWealth.push({
                                 SourceOfWealth : "Investment Proceeds"
                             })
                         }
     
     
                         if(response.data.SourceOfWealth.includes("Business Revenue")){
                             rootState.AOD.OnboardSourceOfWealth.push({
                                 SourceOfWealth : "Business Revenue"
                             })
                         }
     
                         if(response.data.SourceOfWealth.includes("Others")){
                             rootState.AOD.OnboardSourceOfWealth.push({
                                 SourceOfWealth : "Others"
                             })
                         }
                    // }
                 }
                 
            }
           
            rootState.AOD.OnboardSourceOfWealthOther =  response.data.SourceOfWealthOth
            rootState.AOD.OnboardNoOfDependents = response.data.NoOfDependents
            rootState.AOD.OnboardisSophisticatedInvestor = response.data.isSophisticatedInvestor
            rootState.AOD.OnboardPEP = response.data.PEP
            rootState.AOD.OnboardPEPPosition = response.data.PEP_Position
            rootState.AOD.OnboardPEPFamilyRelationShip = response.data.PEP_FamilyRelationship
            rootState.AOD.OnboardUSResidentStatus= response.data.USResidentStatus
            rootState.AOD.OnboardTaxResidency= response.data.TaxResidency
            rootState.AOD.OnboardEPFNO= response.data.EPFNo
            rootState.AOD.OnboardAccountType = response.data.EPFAccountType
            rootState.AOD.OnboardEPFEffectiveDate= response.data.EPFIEffectiveDate
            rootState.AOD.OnboardAge= response.data.Age
            rootState.AOD.OnboardMaritalStatus= response.data.MaritalStatus
            rootState.AOD.OnboardUserId= response.data.UserId
            rootState.AOD.OnboardFund = response.data.FundInvestment

             if((response.data.UTFAccountNo!='')||(response.data.UTFAccountNo !=undefined)){
                 
                rootState.AOD.OnBoardUTAccountNo = response.data.UTFAccountNo
            } 

           /*  if((response.data.PRSAccountNo!='')||(response.data.PRSAccountNo !=undefined)){
                rootState.AOD.OnBoardUTAccountNo = response.data.PRSAccountNo
            } */


            return true
        })
        .catch(function (error) {
            var payload = "Method:  GetOnboardingSelf -> " + error.toString()
            dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
              typeid:'3',
              appid:'2',
              str:payload
            }) 
          //  console.log(error);
            return error.toString()
        });
        
    },
    async TriggerAkamaiAccountCreation({rootState,state,dispatch},Obj){
        var tempuserid ='';
        var transactionData = '';
        if((Obj == 'undefined'||Obj == undefined)){
            if(rootState.AOD.PersonalInformation.IdType='NewIC'){
                tempuserid = rootState.AOD.PersonalInformation.NRIC
            }else{
                tempuserid = rootState.AOD.PersonalInformation.OldID
            }
        }else{
            tempuserid = Obj.ApplicationId;
            if(Obj.firstTimeLoginInfo != undefined){
                transactionData = Obj.firstTimeLoginInfo
            }
        }

        return new Promise((resolve, reject) => {
            return this.$httpClient({
                method: "post",
                url: apiconnectuat + 'iaccess/um/' +rootState.AD.Creation_loginUserID +'/create', 
                // headers: { Authorization: "Bearer " + state.IAccessAPIToken },
                //tokenkey_iaccess
                //process.env.VUE_APP_IACCESSTOKEN
                data : {
                    "password": rootState.AD.Creation_LoginPassword,
                    "name": rootState.AOD.PersonalInformation.FullName,
                    "email": rootState.AD.Creation_loginUserID,
                    "telmobile":rootState.AOD.ContactInformation.MobileNo,
                    "customerId": tempuserid
                }
            }).then(function (json) {
    
                dispatch('Logging',{
                    typeid:'3',
                    appid:'2',
                    str:JSON.stringify(json)
                })
    
              //  console.log('account creation',json)
                resolve(json.data)
            }).catch(function (error) {
    
                var payload = "Method:  TriggerAkamaiAccountCreation -> " + error.toString()
               // dispatch('GenEmail',{payload: payload}) 
   
                dispatch('Logging',{
                 typeid:'3',
                 appid:'2',
                 str:payload
               }) 
             //  console.log(error);
             
    
                reject(error)
            });
        })
    },


    async TriggerAkamaiLogin({rootState,state,dispatch},Obj){
        return new Promise((resolve, reject) => {
            return this.$httpClient({
                method: "GET",
                url: apiconnectuat + 'iaccess/um/' +rootState.AD.loginUserID +'/auth', 
                //url:apiconnectuat + 'iaccess/um/' +rootState.AD.loginUserID +'/auth?password='+rootState.AD.LoginPassword,
                // headers: { Authorization: "Bearer " + state.IAccessAPIToken },
                params: {
                    "password":rootState.AD.LoginPassword
                 }
                //tokenkey_iaccess
                //process.env.VUE_APP_IACCESSTOKEN
               /*  data : {
                    "password": rootState.AD.Creation_LoginPassword,
                    "name": rootState.AOD.PersonalInformation.FullName,
                    "email": rootState.AD.Creation_loginUserID,
                    "telmobile":rootState.AOD.ContactInformation.MobileNo,
                    "customerId": tempuserid
                } */
            }).then(function (json) {
    
                dispatch('Logging',{
                    typeid:'3',
                    appid:'2',
                    str:JSON.stringify(json)
                })
    
              //  console.log('account creation',json)
                resolve(json.data)
            }).catch(function (error) {
    
                var payload = "Method:  TriggerAkamaiLogin -> " + error.toString()
               // dispatch('GenEmail',{payload: payload}) 
   
                dispatch('Logging',{
                 typeid:'3',
                 appid:'2',
                 str:payload
               }) 
             //  console.log(error);
             
    
                reject(error)
            });
        })
    },


    async TriggerAccountCreation({rootState,state,dispatch},Obj){
        //apipath_iaccess_security_info
        var tempuserid ='';
        var transactionData = '';
        if((Obj == 'undefined'||Obj == undefined)){
            if(rootState.AOD.PersonalInformation.IdType='NewIC'){
                tempuserid = rootState.AOD.PersonalInformation.NRIC
            }else{
                tempuserid = rootState.AOD.PersonalInformation.OldID
            }
        }else{
            tempuserid = Obj.ApplicationId;
            if(Obj.firstTimeLoginInfo != undefined){
                transactionData = Obj.firstTimeLoginInfo
            }
        }
  /*      console.log("tempuserid :" + tempuserid)
        console.log("rootState.AOD.OnBoardUTAccountNo :" + rootState.AOD.O
        nBoardUTAccountNo)
        console.log("transactionData :" + transactionData) */
        return this.$httpClient({
            method: "post",
            url: apiconnectuat + 'iaccess/um/' +tempuserid +'/createtemp' , 
            // headers: { Authorization: "Bearer " + state.IAccessAPIToken },
            //tokenkey_iaccess
            //process.env.VUE_APP_IACCESSTOKEN
            data : {
                "password": "",
                "name": "",
                "email": "",
                "telmobile": "",
                "customerId": tempuserid,
                "accountId": rootState.AOD.OnBoardUTAccountNo,
                "firstTimeLoginInfo" : transactionData
            }
        })
        .then(function (response) {

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(response)
            })

            /* console.log('account creation')
            console.log(response) */
            if(response.data.Status == '1'){
                return true
            }else{
                return response.data.Message
            }
        })
        .catch(function (error) {
             var payload = "Method:  TriggerAccountCreation -> " + error.toString()
             dispatch('GenEmail',{payload: payload}) 

             dispatch('Logging',{
              typeid:'3',
              appid:'2',
              str:payload
            }) 
          //  console.log(error);
          
            return error.toString()
        });
    },
    async ResubmitPostOnboardingSelf({rootState, state,dispatch},Obj){
       
        var tempFund = [];

        for(var i=0; i<rootState.Transactions.Transaction.Investment.length;i++){
            for(var j= 0; j<rootState.AOD.Transaction.Investment.length; j++){
                if(rootState.Transactions.Transaction.Investment[i].Scheme == rootState.AOD.Transaction.Investment[j].SchemeCode ){
                    rootState.Transactions.Transaction.Investment[i].Amount=parseFloat((rootState.Transactions.Transaction.Investment[i].Amount.toString()).replace(",",""))
                    tempFund.push({
                        SchemeCurrency : rootState.AOD.Transaction.Investment[j].SchemeCurrency,
                        TypeOfProduct : rootState.AOD.Transaction.Investment[j].TypeOfProduct,
                        SchemeCode :  rootState.AOD.Transaction.Investment[j].SchemeCode,
                        Amount : rootState.Transactions.Transaction.Investment[i].Amount,
                        IndividualContribution : rootState.AOD.Transaction.Investment[j].IndividualContribution,
                        SalesCharge: rootState.AOD.Transaction.Investment[j].SalesCharge,
                        Plan : rootState.AOD.Transaction.Investment[j].Plan,
                        Id: rootState.AOD.Transaction.Investment[j].Id,
                    })
                }
            }
        }
        //console.log(tempFund)
        
        if(rootState.AOD.AddressInformation.SamePermanentAddress.value!=true){

            rootState.AOD.AddressInformation.CorrespondenceAddress.Address3 = rootState.AOD.AddressInformation.PermanentAddress.Address3 
            rootState.AOD.AddressInformation.CorrespondenceAddress.Address2 = rootState.AOD.AddressInformation.PermanentAddress.Address2 
            rootState.AOD.AddressInformation.CorrespondenceAddress.Address1 = rootState.AOD.AddressInformation.PermanentAddress.Address1 
            rootState.AOD.AddressInformation.CorrespondenceAddress.State = rootState.AOD.OnboardPermanentAddrState,
            rootState.AOD.AddressInformation.CorrespondenceAddress.Country =  rootState.AOD.OnboardPermanentAddrCountry
            rootState.AOD.AddressInformation.CorrespondenceAddress.City = rootState.AOD.AddressInformation.PermanentAddress.City 
            rootState.AOD.AddressInformation.CorrespondenceAddress.Postcode = rootState.AOD.AddressInformation.PermanentAddress.Postcode 

        }

        var tempHouseHold= 0;
            tempHouseHold = rootState.AOD.MonthlyHouseholdIncome
            //.replace(",","")
        //    tempHouseHold = tempHouseHold.replace(",","") //remove coma
            tempHouseHold = parseFloat(tempHouseHold).toFixed(2) 
            var tempTIN = [];
            for (var i = 0; i < rootState.FATCA.TaxResidencyTIN.length; i++) {
                tempTIN.push({
                    TINCountry: rootState.FATCA.TaxResidencyTIN[i].TaxResidency_Country,
                    TINUnavailable: rootState.FATCA.TaxResidencyTIN[i].TaxResidency_IsTINUnavailable,
                    TINReason: rootState.FATCA.TaxResidencyTIN[i].TaxResidency_UnavailableReason,
                    TINNo: rootState.FATCA.TaxResidencyTIN[i].TaxResidency_TIN,
                    TINReasonB: rootState.FATCA.TaxResidencyTIN[i].TaxResidency_ReasonB,
                    Id: rootState.FATCA.TaxResidencyTIN[i].Id
                })
            } 

        var epfAccountType='';
        var empStatus='';
        var busNature='';


            for (var j = 0 ; j<rootState.Lookup.EPFAccountType.length; j++ ){
                if(rootState.Lookup.EPFAccountType[j].label==rootState.AOD.PersonalInformation.EPFAccount){
                    epfAccountType = rootState.Lookup.EPFAccountType[j].value
                }
            }
            

            if((rootState.ED.EmploymentStatus.value==undefined)||(rootState.ED.EmploymentStatus.value=="")){
                for(var i=0; i< rootState.Lookup.EmploymentStatus_LK.length; i++){
                    if(rootState.ED.EmploymentStatus== rootState.Lookup.EmploymentStatus_LK[i].label){
                        empStatus =rootState.Lookup.EmploymentStatus_LK[i].value
                    }
                }

            }else{
                empStatus = rootState.ED.EmploymentStatus.value
            }

            if((rootState.ED.BusinessNature.value==undefined)||(rootState.ED.BusinessNature.value=="")){
                for(var i=0; i< rootState.Lookup.NatureofBusiness_LK.length; i++){
                    if(rootState.ED.BusinessN3ature== rootState.Lookup.NatureofBusiness_LK[i].label){
                        busNature =rootState.Lookup.NatureofBusiness_LK[i].value
                    }
                }

            }else{
                busNature = rootState.ED.BusinessNature.value
            }
            /* if((empStatus != "1")||(empStatus != "2")){
                
                busNature='';
                rootState.ED.BusinessNature = '';
                rootState.ED.BusinessNatureOther='';
                rootState.ED.Designation=''
                rootState.ED.EmployerName = ''
                rootState.ED.EmployerAddress.Address1 = ''
                
            }else  */
            if(empStatus == "1"){
                if(busNature!="A18"){
                    rootState.ED.BusinessNatureOther='';
                }

                rootState.ED.Designation=''
                rootState.ED.EmployerName = ''
                rootState.ED.EmployerAddress.Address1 = ''
            }else if(empStatus == "2"){
                if(busNature!="A18"){
                    rootState.ED.BusinessNatureOther='';
                }
            }else if (empStatus == '6') { // 6 == unemployed to pass in A18
              if(busNature!="A18"){
                busNature='A18';
                rootState.ED.BusinessNatureOther='Unemployed';
              }
            }else{
                
                busNature='';
                rootState.ED.BusinessNature = '';
                rootState.ED.BusinessNatureOther='';
                rootState.ED.Designation=''
                rootState.ED.EmployerName = ''
                rootState.ED.EmployerAddress.Address1 = ''
            }
          return this.$httpClient({
            method: "post",
            url: apipath_onboarding_self + '/' + rootState.AOD.OnboardId, 
            // headers: { Authorization: "Bearer " +  state.OnboardingAPIToken},
            //process.env.VUE_APP_ONBOARDING
            data : {
               "_id": rootState.AOD.OnboardId,
                "ApplicationFormId": rootState.AOD.OnboardApplicationFormID,
                "Channel": "EMIS",
                "Status": 'Submitted',
                "EmisReferenceNo" : rootState.Transactions.ApplicationFormId ,
                "Salutation": rootState.AOD.OnboardSalutation,
                "CustomerName": rootState.AOD.OnboardCustomerName,
                "IdType": rootState.AOD.OnboardIdType,
                "NRIC": rootState.AOD.OnboardIC,
                "OldID": rootState.AOD.OnboardOldId,
                "Gender": rootState.AOD.OnboardGender,
                "DOB": rootState.AOD.OnboardDOB,
                "Nationality": rootState.AOD.OnboardNationality,
                "CountryOfBirth": rootState.AOD.OnboardCountryofBirth,
                "Race": rootState.AOD.OnboardRace,
                "RaceOth": rootState.AOD.OnboardRaceOth,
                "HolderStatus": rootState.AOD.OnboardHolderStatus,
                "TelMobileCountryCode": rootState.AOD.OnboardMobileCountryCode,
                "TelMobile": rootState.AOD.OnboardMobile,
                "EmailAddress": rootState.AOD.Onboardemail,
                
                "PermanentAddress": {
                    "AddressLine3": rootState.AOD.OnboardPermanentAddrLine3,
                    "AddressLine2":rootState.AOD.OnboardPermanentAddrLine2,
                    "AddressLine1": rootState.AOD.OnboardPermanentAddrLine1,
                    "State":rootState.AOD.OnboardPermanentAddrState,
                    "Country": rootState.AOD.OnboardPermanentAddrCountry,
                    "City": rootState.AOD.OnboardPermanentAddrCity,
                    "Postcode":rootState.AOD.OnboardPermanentAddrPostCode
                },
                "SameAsPermanentAddress": rootState.AOD.AddressInformation.SameAsPermanentAddress,
                "CorrespondenceAddress": {
                    "AddressLine3": rootState.AOD.OnboardCorrespondenceAddrLine3,
                    "AddressLine2": rootState.AOD.OnboardCorrespondenceAddrLine2,
                    "AddressLine1": rootState.AOD.OnboardCorrespondenceAddrLine1,
                    "State": rootState.AOD.OnboardPermanentAddrState,
                    "Country": rootState.AOD.OnboardPermanentAddrCountry,
                    "City": rootState.AOD.OnboardCorrespondenceAddrCity,
                    "Postcode": rootState.AOD.OnboardCorrespondenceAddrPostCode
                },
                "EmployementStatus": rootState.AOD.OnboardEmployemntStatus,
                "EmployementOth": rootState.ED.EmployementStatusOth,
                "NatureOfBusiness":rootState.AOD.OnboardNatureOfBusiness,
                "NatureOfBusinessOth": rootState.ED.BusinessNatureOther,
                "Designation": rootState.AOD.OnboardDesignation,

                "EmployerName": rootState.AOD.OnboardEmployerName,
                "EmployerAddress": {
                    "AddressLine1":rootState.AOD.OnboardEmployerAddressLine1, 
                },
                "NetPersonalAsset": rootState.AOD.OnboardNetPersonalAsset,
                "InvestmentPurpose": rootState.AOD.PersonalInformation.InvestmentPurpose,
                "InvestmentPurposeOth": rootState.AOD.PersonalInformation.InvestmentPurposeOther,
                "SourceOfWealth": rootState.AOD.PersonalInformation.SourceOfWealth,
                "SourceOfWealthOth": rootState.AOD.PersonalInformation.SourceOfWealthOther,
                "NoOfDependents": rootState.AOD.PersonalInformation.NoOfDependents,
                "MonthlyHouseholdIncome": tempHouseHold,  
                "isSophisticatedInvestor": rootState.FATCA.SophisticatedInvestor,
                "PEP": rootState.FATCA.PEP,
                "PEP_Position": rootState.FATCA.PEPPosition,
                "PEP_FamilyRelationship": rootState.FATCA.PEPRelationship,
                "USResidentStatus": rootState.AOD.OnboardUSResidentStatus,
                "TypeOfUSIndicia": rootState.FATCA.UsResidentIndicia,
                "TaxResidency": rootState.AOD.OnboardTaxResidency,
                "TIN": tempTIN,
                "AgentUTCode":"RZ00000",
                "EPFNo": rootState.AOD.PersonalInformation.EPFNumber,
                "EPFAccountType": rootState.AOD.PersonalInformation.EPFAccountType,
                "EPFIEffectiveDate": rootState.AOD.PersonalInformation.EPFIEffectiveDate,
                "Age": rootState.AOD.PersonalInformation.Age,
                "MaritalStatus":rootState.AOD.OnboardMaritalStatus,
                "FundInvestment":tempFund,
                "UserId": rootState.AD.Creation_uuid   //uuid for akamai
                
            } 
            
        })
        .then(function (response) {        
                dispatch('Logging',{
                    typeid:'3',
                    appid:'2',
                    str:JSON.stringify(response)
                })

         //   console.log(response.data)
             if(response.data.isSuccessful===true){    
                           
                rootState.CD.ApplicantId = response.data.ApplicationId
                return true
            }else if (response.data.isSuccessful===false){
                //console.log(response.data.Message.toString())
                if(response.data.Message.toString() != "undefined"){ 
                    if(response.data.Message.toString() === "Post not successfull, application is not editable"){
                        return -1
                    }else{

                        rootState.AOD.onboardMessage= response.data.Message.toString()
                        
                        return false
                    }
                }else{
                    rootState.AOD.onboardMessage ='Unable to complete Onboard Process.'

                    return false
                }  
            }
            else{
                 rootState.AOD.onboardMessage ='Unable to complete Onboard Process.'

                return false
            } 
        })
        .catch(function (error) {
            console.log(error)
            var payload = "Method:  ResubmitPostOnboardingSelf -> " + error.toString()

            dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
              typeid:'3',
              appid:'2',
              str:payload
            }) 
          //  console.log(error);
            return error.toString()
        });   
    },
    async PostOnboardingSelf({ getters, rootState,state,dispatch }, Obj){
      
        //alert( rootState.AOD.PersonalInformation.MaritalStatus.value)
        var tempFund = [];
         var tempTIN = [];
        for (var i = 0; i < rootState.FATCA.TaxResidencyTIN.length; i++) {
            tempTIN.push({
                TINCountry: rootState.FATCA.TaxResidencyTIN[i].TaxResidency_Country,
                TINUnavailable: rootState.FATCA.TaxResidencyTIN[i].TaxResidency_IsTINUnavailable,
                TINReason: rootState.FATCA.TaxResidencyTIN[i].TaxResidency_UnavailableReason,
                TINNo: rootState.FATCA.TaxResidencyTIN[i].TaxResidency_TIN,
                TINReasonB: rootState.FATCA.TaxResidencyTIN[i].TaxResidency_ReasonB,
                Id: rootState.FATCA.TaxResidencyTIN[i].Id
            })
        } 

        if(rootState.AOD.Transaction.Investment.length > 0){
           for(var i=0; i< rootState.AOD.Transaction.Investment.length;i++){
               tempFund.push({
                    SchemeCurrency : rootState.AOD.Transaction.Investment[i].SchemeCurrency,
                    TypeOfProduct :  rootState.AOD.Transaction.Investment[i].TypeOfProduct,
                    SchemeCode :  rootState.AOD.Transaction.Investment[i].SchemeCode,
                    Amount : rootState.AOD.Transaction.Investment[i].Amount,
                    IndividualContribution : rootState.AOD.Transaction.Investment[i].IndividualContribution,
                    SalesCharge : rootState.AOD.Transaction.Investment[i].SalesCharge,
                    Id : rootState.AOD.Transaction.Investment[i].Id,
                    Plan : rootState.AOD.Transaction.Investment[i].Plan
               })
           }
        }
            
        var salutation ='';
        var race ='';
        var holdStatus = '';
        var maritalSts = '';
        var phoneCountryCode=''
        var nation = ''
        var nation2 = '';
        var empStatus='';
        var busNature='';
        var addCountry='';
        var statecode='';
        var permPostalCode='';  
        var CorPostalCode='';
            if((rootState.AOD.PersonalInformation.Salutation.value== undefined)||(rootState.AOD.PersonalInformation.Salutation.value== "")){
               for (var i =0; i<rootState.Lookup.Salutation_LK.length; i++){ 
                    if(rootState.AOD.PersonalInformation.Salutation== rootState.Lookup.Salutation_LK[i].label){
                        salutation =  rootState.Lookup.Salutation_LK[i].value
                    }
                }
            }else{
                salutation = rootState.AOD.PersonalInformation.Salutation.value
            }

            if((rootState.AOD.PersonalInformation.Race.value == undefined)||(rootState.AOD.PersonalInformation.Race.value== "")){
                for(var i=0; i<rootState.Lookup.Race_LK.length; i++){
                    if(rootState.AOD.PersonalInformation.Race == rootState.Lookup.Race_LK[i].label){
                        race = rootState.Lookup.Race_LK[i].value
                    }
                }
            }else{
                race = rootState.AOD.PersonalInformation.Race.value
            }

            
            if((rootState.AOD.PersonalInformation.HolderStatus.value==undefined)||(rootState.AOD.PersonalInformation.HolderStatus.value== "")){
                for(var i=0; i< rootState.Lookup.HolderStatus_LK.length; i++){
                    if(rootState.AOD.PersonalInformation.HolderStatus == rootState.Lookup.HolderStatus_LK[i].label){
                        holdStatus =rootState.Lookup.HolderStatus_LK[i].value
                    }
                }
            }else{
                holdStatus = rootState.AOD.PersonalInformation.HolderStatus.value
            }

            if((rootState.AOD.PersonalInformation.MaritalStatus.value== undefined)||(rootState.AOD.PersonalInformation.MaritalStatus.value== "")){
                for(var i=0; i< rootState.Lookup.MaritalStatus_LK.length; i++){
                    if(rootState.AOD.PersonalInformation.MaritalStatus == rootState.Lookup.MaritalStatus_LK[i].label){
                        maritalSts =rootState.Lookup.MaritalStatus_LK[i].value
                    }
                }
            }else{
                maritalSts = rootState.AOD.PersonalInformation.MaritalStatus.value
            }
           
            // if( rootState.AOD.ContactInformation.MobileNoCode.value== undefined){
            //     for(var i=0; i< rootState.Lookup.InternationalDialingCode_LK.length; i++){
            //         if(rootState.AOD.PersonalInformation.MobileNoCode == rootState.Lookup.InternationalDialingCode_LK[i].label){
            //             phoneCountryCode =rootState.Lookup.InternationalDialingCode_LK[i].value
            //         }
            //     }
            // }else{
            //     phoneCountryCode = rootState.AOD.ContactInformation.MobileNoCode
            // }

            if((rootState.AOD.PersonalInformation.Nationality.value== undefined)||( rootState.AOD.PersonalInformation.Nationality.value== "")){
                for(var i=0; i< rootState.Lookup.Nationality_LK.length; i++){
                    if(rootState.AOD.PersonalInformation.Nationality == rootState.Lookup.Nationality_LK[i].label){
                        nation =rootState.Lookup.Nationality_LK[i].value
                    }
                }
            }else{
                nation=rootState.AOD.PersonalInformation.Nationality.value
            }

            if((rootState.AOD.PersonalInformation.CountryOfBirth.value== undefined)||( rootState.AOD.PersonalInformation.CountryOfBirth.value== "")){
                for(var i=0; i< rootState.Lookup.Country_LK.length; i++){
                      if(rootState.AOD.PersonalInformation.CountryOfBirth == rootState.Lookup.Country_LK[i].label){

                        nation2 =rootState.Lookup.Country_LK[i].value
                    }
                }
            }else{
                nation2=rootState.AOD.PersonalInformation.CountryOfBirth.value
            }


            if((rootState.ED.EmploymentStatus.value==undefined)||(rootState.ED.EmploymentStatus.value=="")){
                for(var i=0; i< rootState.Lookup.EmploymentStatus_LK.length; i++){
                    if(rootState.ED.EmploymentStatus== rootState.Lookup.EmploymentStatus_LK[i].label){
                        empStatus =rootState.Lookup.EmploymentStatus_LK[i].value
                    }
                }

            }else{
                empStatus = rootState.ED.EmploymentStatus.value
            }

            if((rootState.ED.BusinessNature.value==undefined)||(rootState.ED.BusinessNature.value=="")){
                for(var i=0; i< rootState.Lookup.NatureofBusiness_LK.length; i++){
                    if(rootState.ED.BusinessNature== rootState.Lookup.NatureofBusiness_LK[i].label){
                        busNature =rootState.Lookup.NatureofBusiness_LK[i].value
                    }
                }

            }else{
                busNature = rootState.ED.BusinessNature.value
            }
           /*  if((empStatus != "1")||(empStatus != "2")){
                
                busNature='';
                rootState.ED.BusinessNature = '';
                rootState.ED.BusinessNatureOther='';
                rootState.ED.Designation=''
                rootState.ED.EmployerName = ''
                rootState.ED.EmployerAddress.Address1 = ''
                
            }else */

             if(empStatus == "1"){
                if(busNature!="A18"){
                    rootState.ED.BusinessNatureOther='';
                }

                rootState.ED.Designation=''
                rootState.ED.EmployerName = ''
                rootState.ED.EmployerAddress.Address1 = ''
            }else if(empStatus == "2"){
                if(busNature!="A18"){
                    rootState.ED.BusinessNatureOther='';
                }
            }else if (empStatus == '6') { // 6 == unemployed to pass in A18
              if(busNature!="A18"){
                busNature='A18';
                rootState.ED.BusinessNatureOther='Unemployed';
              }
            }else{
                
                busNature='';
                rootState.ED.BusinessNature = '';
                rootState.ED.BusinessNatureOther='';
                rootState.ED.Designation=''
                rootState.ED.EmployerName = ''
                rootState.ED.EmployerAddress.Address1 = ''
            }


            if((rootState.AOD.AddressInformation.PermanentAddress.Postcode.label==undefined)||(rootState.AOD.AddressInformation.PermanentAddress.Postcode.value=="")){
             
                permPostalCode = rootState.AOD.AddressInformation.PermanentAddress.Postcode
            }else{
                permPostalCode = rootState.AOD.AddressInformation.PermanentAddress.Postcode.value
               // statecode = rootState.AOD.AddressInformation.PermanentAddress.State.value
            }
            

            if((rootState.AOD.AddressInformation.PermanentAddress.Country.value==undefined)||(rootState.AOD.AddressInformation.PermanentAddress.Country.value=="")){
                for(var i=0; i< rootState.Lookup.Country_LK.length; i++){
                    if(rootState.AOD.AddressInformation.PermanentAddress.Country== rootState.Lookup.Country_LK[i].label){
                        addCountry =rootState.Lookup.Country_LK[i].value
                        //statecode =rootState.Lookup.State_LK[i].value
                    }
                }

            }else{
                addCountry = rootState.AOD.AddressInformation.PermanentAddress.Country.value
               // statecode = rootState.AOD.AddressInformation.PermanentAddress.State.value
            }

            if(addCountry ==='MY'){
                if((rootState.AOD.AddressInformation.PermanentAddress.State.value==undefined)||(rootState.AOD.AddressInformation.PermanentAddress.State.value=="")){
                    for(var i=0; i< rootState.Lookup.State_LK.length; i++){
            
                        if(rootState.AOD.AddressInformation.PermanentAddress.State== rootState.Lookup.State_LK[i].label){
                            statecode =rootState.Lookup.State_LK[i].value
                        }
                    }
    
                }else{
                    statecode = rootState.AOD.AddressInformation.PermanentAddress.State.value
                }
            }else{
                if((rootState.AOD.AddressInformation.PermanentAddress.StateForeign.value==undefined)||(rootState.AOD.AddressInformation.PermanentAddress.StateForeign.value=="")){
                    for(var i=0; i< rootState.Lookup.State_LK.length; i++){
            
                        if(rootState.AOD.AddressInformation.PermanentAddress.StateForeign== rootState.Lookup.State_LK[i].label){
                            statecode =rootState.Lookup.State_LK[i].value
                        }
                    }
    
                }else{
                    statecode = rootState.AOD.AddressInformation.PermanentAddress.StateForeign.value
                }
            }
           
            var tempHouseHold= 0;
            tempHouseHold = rootState.AOD.MonthlyHouseholdIncome.toString().replace(",","")
            tempHouseHold = tempHouseHold.replace(",","") //remove coma
            tempHouseHold = parseFloat(tempHouseHold).toFixed(2) 
            var tempInvestmentPurpose=[];
            var tempSourceOfWealth = [];


            if(rootState.FATCA.PEP == ''){                
                rootState.FATCA.PEP = false
            }
            if(rootState.FATCA.PersonalAsset == ''){
                
                rootState.FATCA.PersonalAsset = false
            }
            if(rootState.FATCA.SophisticatedInvestor == ''){
                
                rootState.FATCA.SophisticatedInvestor = false
            }

           

            if(rootState.AOD.PersonalInformation.InvestmentPurpose.length>0){
                // for(var i = 0; i<response.data.InvestmentPurpose.length; i++){

                if(!rootState.AOD.PersonalInformation.InvestmentPurpose.includes("1")||!rootState.AOD.PersonalInformation.InvestmentPurpose.includes("2")||!rootState.AOD.PersonalInformation.InvestmentPurpose.includes("3")||!rootState.AOD.PersonalInformation.InvestmentPurpose.includes("4")||!rootState.AOD.PersonalInformation.InvestmentPurpose.includes("5")){
                    if(rootState.AOD.PersonalInformation.InvestmentPurpose.includes("Savings")){
                        tempInvestmentPurpose.push('1')
                     }
                     if(rootState.AOD.PersonalInformation.InvestmentPurpose.includes("Retirement")){
                        tempInvestmentPurpose.push('2')
                     }
 
                     if(rootState.AOD.PersonalInformation.InvestmentPurpose.includes("Education Funding")){
                        tempInvestmentPurpose.push('3')
                     }
 
                     if(rootState.AOD.PersonalInformation.InvestmentPurpose.includes("Enhance Returns")){
                        tempInvestmentPurpose.push('4')
                     }
 
                     if(rootState.AOD.PersonalInformation.InvestmentPurpose.includes("Others")){
                        tempInvestmentPurpose.push('5')
                     }

                }
                else{
                    for(var j=0; j<rootState.AOD.PersonalInformation.InvestmentPurpose.length; j++){
                        tempInvestmentPurpose.push(rootState.AOD.PersonalInformation.InvestmentPurpose[i])
                    }

                }
             }



             if((!rootState.AOD.PersonalInformation.SourceOfWealth.includes('1'))||(!rootState.AOD.PersonalInformation.SourceOfWealth.includes('2'))||(!rootState.AOD.PersonalInformation.SourceOfWealth.includes('3'))||(!rootState.AOD.PersonalInformation.SourceOfWealth.includes('4'))||(!rootState.AOD.PersonalInformation.SourceOfWealth.includes('5'))||(!rootState.AOD.PersonalInformation.SourceOfWealth.includes('6'))||(!rootState.AOD.PersonalInformation.SourceOfWealth.includes('7'))){
                if(rootState.AOD.PersonalInformation.SourceOfWealth.includes("Salary / Bonus")){
                    tempSourceOfWealth.push('1')
                 }

                 if(rootState.AOD.PersonalInformation.SourceOfWealth.includes("Savings")){
                    tempSourceOfWealth.push('2')
                 }
                 
                 if(rootState.AOD.PersonalInformation.SourceOfWealth.includes("Inheritance")){
                    tempSourceOfWealth.push('3')
                 }

                 if(rootState.AOD.PersonalInformation.SourceOfWealth.includes("Commission")){
                    tempSourceOfWealth.push('4')
                 }

                 if(rootState.AOD.PersonalInformation.SourceOfWealth.includes("Investment Proceeds")){
                    tempSourceOfWealth.push('5')
                 }

                 if(rootState.AOD.PersonalInformation.SourceOfWealth.includes("Business Revenue")){
                    tempSourceOfWealth.push('6')
                 }

                 if(rootState.AOD.PersonalInformation.SourceOfWealth.includes("Others")){
                    tempSourceOfWealth.push('7')
                 }

             }else{
                for(var j=0; j<rootState.AOD.PersonalInformation.SourceOfWealth.length; j++){
                    tempSourceOfWealth.push(rootState.AOD.PersonalInformation.SourceOfWealth[i])
                }
            }

            var addCountry2 = ''
            var statecode2 = ''
            if(rootState.AOD.AddressInformation.SamePermanentAddress.value!=true){

                rootState.AOD.AddressInformation.CorrespondenceAddress.Address3 = rootState.AOD.AddressInformation.PermanentAddress.Address3 
                rootState.AOD.AddressInformation.CorrespondenceAddress.Address2 = rootState.AOD.AddressInformation.PermanentAddress.Address2 
                rootState.AOD.AddressInformation.CorrespondenceAddress.Address1 = rootState.AOD.AddressInformation.PermanentAddress.Address1 
                addCountry2 = statecode
                addCountry2 = addCountry
                rootState.AOD.AddressInformation.CorrespondenceAddress.City = rootState.AOD.AddressInformation.PermanentAddress.City 
                CorPostalCode = permPostalCode 

            }else{

                if((rootState.AOD.AddressInformation.CorrespondenceAddress.Country.value==undefined)||(rootState.AOD.AddressInformation.CorrespondenceAddress.Country.value=="")){
                    for(var i=0; i< rootState.Lookup.Country_LK.length; i++){
                        if(rootState.AOD.AddressInformation.CorrespondenceAddress.Country== rootState.Lookup.Country_LK[i].label){
                            addCountry2 =rootState.Lookup.Country_LK[i].value
                            //statecode =rootState.Lookup.State_LK[i].value
                        }
                    }
    
                }else{
                    addCountry2 = rootState.AOD.AddressInformation.CorrespondenceAddress.Country.value
                }

                if(addCountry2 ==='MY'){
                    if((rootState.AOD.AddressInformation.CorrespondenceAddress.State.value==undefined)||(rootState.AOD.AddressInformation.CorrespondenceAddress.State.value=="")){
                        for(var i=0; i< rootState.Lookup.State_LK.length; i++){
                
                            if(rootState.AOD.AddressInformation.CorrespondenceAddress.State== rootState.Lookup.State_LK[i].label){
                                statecode2 =rootState.Lookup.State_LK[i].value
                            }
                        }
        
                    }else{
                        statecode2 = rootState.AOD.AddressInformation.CorrespondenceAddress.State.value
                    }
                }else{
                    if((rootState.AOD.AddressInformation.CorrespondenceAddress.StateForeign.value==undefined)||(rootState.AOD.AddressInformation.CorrespondenceAddress.StateForeign.value=="")){
                        for(var i=0; i< rootState.Lookup.State_LK.length; i++){
                
                            if(rootState.AOD.AddressInformation.CorrespondenceAddress.StateForeign== rootState.Lookup.State_LK[i].label){
                                statecode2 =rootState.Lookup.State_LK[i].value
                            }
                        }
        
                    }else{
                        statecode2 = rootState.AOD.AddressInformation.CorrespondenceAddress.StateForeign.value
                    }
                }


                if(( rootState.AOD.AddressInformation.CorrespondenceAddress.Postcode.label==undefined)||( rootState.AOD.AddressInformation.CorrespondenceAddress.Postcode.value=="")){
             
                    CorPostalCode =  rootState.AOD.AddressInformation.CorrespondenceAddress.Postcode
                }else{
                    CorPostalCode =  rootState.AOD.AddressInformation.CorrespondenceAddress.Postcode.value
                   // statecode = rootState.AOD.AddressInformation.PermanentAddress.State.value
                }
            }  

            var epfAccountType=''
            for (var j = 0 ; j<rootState.Lookup.EPFAccountType.length; j++ ){
                if(rootState.Lookup.EPFAccountType[j].label==rootState.AOD.PersonalInformation.EPFAccount){
                    epfAccountType = rootState.Lookup.EPFAccountType[j].value
                }
            }
           
          
            if(rootState.FATCA.PEP == false){
                rootState.FATCA.PEPPosition = '';
                rootState.FATCA.PEPRelationship ='';
            }
            //rootState.AOD.PersonalInformation.EPFAccountType

           // rootState.AOD.MonthlyHouseholdIncome=parseFloat((rootState.AOD.MonthlyHouseholdIncome.toString()).replace(",",""))

         return this.$httpClient({
            method: "post",
            url: apipath_onboarding_self + '/' + Obj.ApplicationId, 
            // headers: { Authorization: "Bearer " + state.OnboardingAPIToken },
            //tokenkey_onboarding
            //process.env.VUE_APP_ONBOARDING
            data : {
                "_id": Obj.ApplicationId,
                "ApplicationFormId": rootState.AD.ApplicationFormID,
                "Channel": "EMIS",
                "EmisReferenceNo" : rootState.Transactions.ApplicationFormId ,
                "Status": Obj.Status,
                "Salutation": salutation,
                "CustomerName": rootState.AOD.PersonalInformation.FullName,
                "IdType": rootState.AOD.PersonalInformation.IdType,
                "NRIC": rootState.AOD.PersonalInformation.NRIC,
                "OldID": rootState.AOD.PersonalInformation.OldID,
                "EPFNo":rootState.AOD.PersonalInformation.EPFNumber,
                "EPFAccountType":epfAccountType,
                "EPFIEffectiveDate":rootState.AOD.PersonalInformation.EPFIEffectiveDate,
                "Gender": rootState.AOD.PersonalInformation.Gender,
                "DOB": rootState.AOD.PersonalInformation.DateOfBirth,
                "Nationality": nation,
                "CityOfBirth": rootState.AOD.PersonalInformation.CityOfBirth,
                "CountryOfBirth": nation2,
                "Race": race,
                "RaceOth": rootState.AOD.PersonalInformation.RaceOth,
                "HolderStatus": holdStatus,
                "TelMobileCountryCode": rootState.AOD.ContactInformation.MobileNoCode,
                "TelMobile": rootState.AOD.ContactInformation.MobileNo,
                "EmailAddress": rootState.AOD.ContactInformation.EmailAddress,
                
                "PermanentAddress": {
                    "AddressLine3": rootState.AOD.AddressInformation.PermanentAddress.Address3,
                    "AddressLine2": rootState.AOD.AddressInformation.PermanentAddress.Address2,
                    "AddressLine1": rootState.AOD.AddressInformation.PermanentAddress.Address1,

                    "State":statecode,
                    "Country": addCountry,
                    "City": rootState.AOD.AddressInformation.PermanentAddress.City,
                    "Postcode":permPostalCode
                },
                "SameAsPermanentAddress": rootState.AOD.AddressInformation.SameAsPermanentAddress,
                "CorrespondenceAddress": {
                    "AddressLine3":  rootState.AOD.AddressInformation.CorrespondenceAddress.Address3,
                    "AddressLine2": rootState.AOD.AddressInformation.CorrespondenceAddress.Address2,
                    "AddressLine1": rootState.AOD.AddressInformation.CorrespondenceAddress.Address1,
                    "State": statecode2,
                    "Country": addCountry2,
                    "City": rootState.AOD.AddressInformation.CorrespondenceAddress.City,
                    "Postcode":CorPostalCode
                },
                "EmployementStatus": empStatus,
                "EmployementOth": rootState.ED.EmployementStatusOth,
                "NatureOfBusiness":busNature,
                "NatureOfBusinessOth": rootState.ED.BusinessNatureOther,
                "Designation": rootState.ED.Designation,

                "EmployerName": rootState.ED.EmployerName,
                "EmployerAddress": {
                    "AddressLine1": rootState.ED.EmployerAddress.Address1,
                },
                "NetPersonalAsset": rootState.FATCA.PersonalAsset,
                "InvestmentPurpose": tempInvestmentPurpose,
                "InvestmentPurposeOth": rootState.AOD.PersonalInformation.InvestmentPurposeOther,
                "SourceOfWealth": tempSourceOfWealth,
                "SourceOfWealthOth": rootState.AOD.PersonalInformation.SourceOfWealthOther,
                "NoOfDependents": rootState.AOD.PersonalInformation.NoOfDependents,
                "MonthlyHouseholdIncome": tempHouseHold,  
                "isSophisticatedInvestor": rootState.FATCA.SophisticatedInvestor,
                "PEP": rootState.FATCA.PEP,
               
                "PEP_Position": rootState.FATCA.PEPPosition,
                "PEP_FamilyRelationship": rootState.FATCA.PEPRelationship,
                "USResidentStatus": rootState.FATCA.UsResident,
                "TypeOfUSIndicia": rootState.FATCA.UsResidentIndicia,
                "TaxResidency":  rootState.FATCA.TaxResidency,
                
                "TIN": tempTIN ,
                "Age": rootState.AOD.PersonalInformation.Age,
                "MaritalStatus":maritalSts,
                "FundInvestment":tempFund,
                //"UserId": Obj.UserId
            } 
        })
        .then(function (response) {
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(response)
            })

            if(response.data.isSuccessful===true){    
                rootState.CD.ApplicantId = response.data.ApplicationId
                return true
            }
            else{
                return response.data
            }  
        })
        .catch(function (error) {
            var payload = "Method:  PostOnboardingSelf -> " + error.toString()

            dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
              typeid:'3',
              appid:'2',
              str:payload
            }) 
           // console.log(error);
            return error.toString()
        });  
    },
    /* async PostLoggerAPI({ getters, rootState }, Obj){
        return axios({
            method: "get",
            url: apipath_transaction_emis + Obj.ApplicationId, 
            headers: { Authorization: "Bearer " + tokenkey_transaction }
        }).then(function(json){

        }).catch(function(error){
            console.log('---Logger---')
            console.log(error)
        })

    }, */
    async GetEmisApplication({ getters, rootState, state,dispatch }, Obj){
      
        rootState.AOD.OnboardingAppID = Obj.ApplicationId
        //alert(Obj.ApplicationId)
        return this.$httpClient({
            method: "get",
            url: apipath_transaction_emis + Obj.ApplicationId, 
            // headers: { Authorization: "Bearer " +  state.TransactionAPIToken}
            //process.env.VUE_APP_TRANSACTIONTOKEN
        })
        .then(function(json){
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(json)
            })

          //  console.log(json.data)
            if(json.data.eMISApplication.ApplicationId != undefined){
                if(json.data.eMISApplication.SelfOnboardApplicationId ===undefined){
                   /*  var createdDateTime =  json.data.eMISApplication.DateCreated
                  
                     var date1 = new Date(createdDateTime);
                     var date2 = new Date();
                     var diffDays = parseInt((date2 - date1) / (1000 * 60 * 60 * 24), 10); 
                     //alert(diffDays)
                     if(diffDays<=1){
     
                        var dt1 = new Date(createdDateTime);
                        var dt2 = new Date();
                        var diff =(dt2.getTime() - dt1.getTime()) / 1000;
                         diff = diff/60;
                     
                         if((Math.abs(Math.round(diff)) <= 30)&&(Math.abs(Math.round(diff)) >= 0)){
                             rootState.AOD.LandingPageTimer = 30 - Math.abs(Math.round(diff));
                         }else{
                             rootState.AOD.LandingPageTimer =  0
                         }
                        
     
                     }else{
                         rootState.AOD.LandingPageTimer = 0;
                     } */

                     var createdDateTime =  json.data.eMISApplication.DateCreated

                     dayjs.extend(timeZone)

                     var tempd1 = dayjs(createdDateTime).format('YYYY-MM-DD')
                     var tempd1_1 = dayjs(tempd1)

                     var tempd2 = dayjs().format('YYYY-MM-DD', { timeZone: 'Asia/Kuala_Lumpur' })
                     
                     var tempd2_1 = dayjs(tempd2)


                     var diffDays =tempd1_1.diff(tempd2_1, 'day')
                    
                     if(diffDays<=1){
                        let fromTime =  dayjs(createdDateTime)
                            
                         
                        let currentTime = dayjs().format('YYYY-MM-DD HH:mm:ss',{ timeZone: 'Asia/Kuala_Lumpur' })

                        let currentTime2 = dayjs(currentTime)

                        var diff =currentTime2.diff(fromTime, 'minute')

                        if((Math.abs(Math.round(diff)) <= 30)&&(Math.abs(Math.round(diff)) >= 0)){
                            rootState.AOD.LandingPageTimer = 30 - Math.abs(Math.round(diff));
                        }else{
                            rootState.AOD.LandingPageTimer =  0
                        }
                         
                         
                     }else{
                         rootState.AOD.LandingPageTimer = 0;
                     } 

                   
                  // rootState.AOD.LandingPageTimer =  parseFloat(rootState.AOD.InitTime)  - parseFloat(minute)
                     
                     rootState.AOD.PersonalInformation.FullName=json.data.eMISApplication.eMISAccountOpeningInfo.memberName 
     
                     rootState.AOD.OnboardFundJson = json.data.eMISApplication.funds;
                     state.emisJson = json.data
           
                     //console.log(rootState.AOD.OnboardFundJson)
                   
                     var tempval = 0; 
                     for(var i =0; i< json.data.eMISApplication.funds.length; i++){
                         tempval = json.data.eMISApplication.funds[i].investmentAmount + tempval
                     }
                     rootState.Transactions.Transaction.TotalInvestment = tempval
                     /* json.data.eMISApplication.newNric=''
                     
                     console.log("json.data.eMISApplication.newNric ->" + json.data.eMISApplication.newNric)
                     console.log("json.data.eMISApplication.oldNric ->" + json.data.eMISApplication.oldNric)
                     console.log("json.data.eMISApplication.otherId ->" + json.data.eMISApplication.otherId) */
                     if(json.data.eMISApplication.newNric!=""){
                         rootState.AOD.PersonalInformation.IdType='NewIC'
                        /*  rootState.AOD.PersonalInformation.NRIC ="621213046821"
                         var customer_ic = "621213046821" */

                         rootState.AOD.PersonalInformation.NRIC = json.data.eMISApplication.newNric
                         var customer_ic = json.data.eMISApplication.newNric
                         //DOB

                        var Year = customer_ic.substring(0, 2);
                        var Month = customer_ic.substring(2, 4)
                        var Day = customer_ic.substring(4, 6)
                        
                        var cutoff = (new Date()).getFullYear() - 2000

                        var date = (Year > cutoff ? '19' : '20') + Year + '-' + Month + '-' + Day;
                            
                        rootState.AOD.PersonalInformation.DateOfBirth = date;
         
                        // var Age;
                        
                        var birthyear = dayjs(date).year()

                        var dateNow = new Date();   
                        var dateNowYear = dateNow.getFullYear();

                         rootState.AOD.PersonalInformation.Age = dateNowYear - birthyear;
                        //Gender
                             var str = customer_ic.substr(customer_ic.length - 1);
                             if (str % 2 === 0) {
                                 state.Gender = 'F'
                             } else
                             if (str % 2 !== 0) {
                                 state.Gender = 'M'
                             }
                             rootState.AOD.PersonalInformation.Gender = state.Gender
         
                     }else if(json.data.eMISApplication.newNric===""){
     
                    
     
                         if(json.data.eMISApplication.oldNric !=""){
                            
                             rootState.AOD.PersonalInformation.OldID = json.data.eMISApplication.oldNric
                             rootState.AOD.PersonalInformation.IdType='OldID'
                         }else{
                             rootState.AOD.PersonalInformation.OldID = json.data.eMISApplication.otherId
                             rootState.AOD.PersonalInformation.IdType='OldID'
                             //  
                         }
                        
                         rootState.AOD.PersonalInformation.DateOfBirth = json.data.eMISApplication.eMISAccountOpeningInfo.memberBirthDate
                         var year = rootState.AOD.PersonalInformation.DateOfBirth.substring(0, 4)
                         var dateNow = new Date();
                         var dateNowYear = dateNow.getFullYear();
                         rootState.AOD.PersonalInformation.Age = dateNowYear - parseFloat(year);
                         // var customer_ic = json.data.eMISApplication.oldNric
                     }
     
                     rootState.Transactions.ApplicationFormId = json.data.eMISApplication.ApplicationFormId
                     
         
                     rootState.Transactions.referenceid = json.data.eMISApplication.referenceId
                     rootState.AOD.ContactInformation.MobileNo = json.data.eMISApplication.eMISAccountOpeningInfo.memberMobileNo
                     rootState.AOD.ContactInformation.EmailAddress = json.data.eMISApplication.eMISAccountOpeningInfo.memberEmail
                    //  rootState.AD.Creation_loginUserID = json.data.eMISApplication.eMISAccountOpeningInfo.memberEmail
                     rootState.CD.CustomerDetails.EPFNo= json.data.eMISApplication.ePFNo
                     rootState.AOD.PersonalInformation.EPFNumber = json.data.eMISApplication.ePFNo
                     rootState.AOD.PersonalInformation.EPFIEffectiveDate = json.data.eMISApplication.shariahEffectiveDate

            

                    var flag = json.data.eMISApplication.shariahFlag 
                    if(flag== true){
                        rootState.AOD.PersonalInformation.EPFAccount = "Islamic"
                    }else{
                        rootState.AOD.PersonalInformation.EPFAccount = "Conventional"
                    }
         
                     rootState.AOD.AddressInformation.PermanentAddress.Address1=json.data.AhamMapInfo.CorrAddress1
                     rootState.AOD.AddressInformation.PermanentAddress.Address2=json.data.AhamMapInfo.CorrAddress2
                     rootState.AOD.AddressInformation.PermanentAddress.Address3=json.data.AhamMapInfo.CorrAddress3 
                     
                     rootState.AOD.AddressInformation.PermanentAddress.Postcode =json.data.AhamMapInfo.CorrPostCode 
         
                     rootState.AOD.AddressInformation.PermanentAddress.City=json.data.eMISApplication.eMISAccountOpeningInfo.correspondenceCity
                     for(var i = 0; i< rootState.Lookup.Country_LK.length; i++){
                         if(rootState.Lookup.Country_LK[i].value == json.data.AhamMapInfo.CorrCountry){
                             rootState.AOD.AddressInformation.PermanentAddress.Country = rootState.Lookup.Country_LK[i].label
                         }
                     }
                                   
                     //console.log('i > ' + json.data.AhamMapInfo.CorrState)
                     if(json.data.AhamMapInfo.CorrCountry == "MY"){
                         for(var j= 0; j<rootState.Lookup.State_LK.length; j++){                      
                             if(rootState.Lookup.State_LK[j].value == json.data.AhamMapInfo.CorrState){
                                // console.log(rootState.Lookup.State_LK[j].label)
                                 rootState.AOD.AddressInformation.PermanentAddress.State = rootState.Lookup.State_LK[j].label
                             }
                             
                         }
                         
                     }else{
                         rootState.AOD.AddressInformation.PermanentAddress.StateForeign=json.data.AhamMapInfo.CorrState
                     }
                     return true
                 }else{
                    return -1
                }          
            }else{
                return 'Sorry, Looks like your Application ID is wrong! Unable to locate your transaction data from our system'
            } 
        })
        .catch(function (error) {
           var payload = "Method:  GetEmisApplication -> " + error.toString()

           dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
              typeid:'3',
              appid:'2',
              str:payload
            }) 

           // console.log(error)
           // console.log(error.response);
            return error.toString()
        });
    },
    async GetEmisTransApp({ getters, rootState,state ,dispatch}, Obj){
         
        //alert(Obj.ApplicationId)
            return this.$httpClient({
                method: "get",
                url: apipath_transaction_emis + Obj.ApplicationId, 
                // headers: { Authorization: "Bearer " + state.TransactionAPIToken }

                //tokenkey_transaction
                //process.env.VUE_APP_TRANSACTIONTOKEN
            })
            .then(function(json){
                dispatch('Logging',{
                    typeid:'3',
                    appid:'2',
                    str:JSON.stringify(json)
                })
             //   console.log('GetEmisTransApp')
              //  console.log(json.data)
                if(json.data.eMISApplication != undefined){
                    if(json.data.eMISApplication.ApplicationId != undefined){
                      
                    if(json.data.eMISApplication.eMISAccountOpeningInfo != undefined) {
                        if(json.data.eMISApplication.eMISAccountOpeningInfo.memberName != undefined){

                            rootState.AOD.PersonalInformation.FullName = json.data.eMISApplication.eMISAccountOpeningInfo.memberName
                        }
                    }
                    

                    if(json.data.eMISApplication.ePFNo != undefined){

                        rootState.AOD.PersonalInformation.EPFNumber = json.data.eMISApplication.ePFNo
                    }

                    if(json.data.eMISApplication.referenceId != undefined){

                        rootState.Transactions.referenceid = json.data.eMISApplication.referenceId
                    }


                    var flag = true
                    if(json.data.eMISApplication.shariahFlag != undefined){
                        flag = json.data.eMISApplication.shariahFlag 
                    }
                    

                    if(flag=== true){
                        rootState.AOD.PersonalInformation.EPFAccount = "Islamic"
                    }else{
                        rootState.AOD.PersonalInformation.EPFAccount = "Conventional"
                    }
                    

                    if(json.data.eMISApplication.transactionStatusCode != undefined){
                        rootState.AD.EpfEmisTrxCode=json.data.eMISApplication.transactionStatusCode
                    }else{
                        rootState.AD.EpfEmisTrxCode= 'T201'
                    }

               
                    
                    if(json.data.eMISApplication.DigitalTransactionApplicationId !="" ){
                        if(json.data.eMISApplication.DigitalTransactionApplicationId != undefined){

                            rootState.CD.FormDetails.ApplicationId = json.data.eMISApplication.DigitalTransactionApplicationId
                        }else{
                            
                            rootState.CD.FormDetails.ApplicationId = ''
                        }
                    }

                 /*    if(json.data.eMISApplication.SelfOnboardApplicationId !="" ){
                        if(json.data.eMISApplication.SelfOnboardApplicationId != undefined){

                            rootState.CD.ApplicantId = json.data.eMISApplication.SelfOnboardApplicationId
                        }else{
                            
                            rootState.CD.ApplicantId = ''
                        }
                    } */



                    if(json.data.eMISApplication.AccountNo !="" ){
                        if(json.data.eMISApplication.AccountNo  !=undefined){

                            rootState.AOD.OnBoardUTAccountNo = json.data.eMISApplication.AccountNo
                        }else{
                            
                            rootState.AOD.OnBoardUTAccountNo = ''
                        }
                    }

                    return true
                 }else{
                     
                    return 'Unable to retrieve data from system. By Clicking "OK", you will be routed to I-AKAUN Page'
                 }
                }else{
                    return 'Unable to retrieve data from system. By Clicking "OK", you will be routed to I-AKAUN Page'
                }
           
            }) .catch(function (error) {
               var payload = "Method:  GetEmisTransApp -> " + error.toString()
               dispatch('GenEmail',{payload: payload}) 

                dispatch('Logging',{
                  typeid:'3',
                  appid:'2',
                  str:payload
                }) 
               //console.log('GetEmisTransApp')
            //   console.log(error)
            // console.log(error)
            // console.log(error.response);
                return error.toString()
            });
        
    },
    async GetEmisBuyApplication({ getters, rootState,state,dispatch }, Obj){
        
        rootState.AOD.OnboardingAppID = Obj.ApplicationId

        return this.$httpClient({
            method: "get",
            url: apipath_transaction_emis + Obj.ApplicationId, 
            // headers: { Authorization: "Bearer " + state.TransactionAPIToken  }
            //tokenkey_transaction
            //process.env.VUE_APP_TRANSACTIONTOKEN
        })
        .then(function(json){
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(json)
            })
           // console.log("GetEmisBuyApplication")
           //console.log(json.data)
            if(json.data.eMISApplication.ApplicationId != undefined){

                if(json.data.eMISApplication.DigitalTransactionApplicationId === undefined){
                    /* if(json.data.eMISApplication.eMISAccountOpeningInfo.memberName != undefined){

                            rootState.AOD.PersonalInformation.FullName=json.data.eMISApplication.eMISAccountOpeningInfo.memberName
                        }  */
                        //rootState.AOD.AddressInformation.state=json.data.eMISApplication.eMISAccountOpeningInfo.correspondenceState 
                        if(json.data.eMISApplication.funds.length> 0){

                            state.EmisBuyFund = json.data.eMISApplication.funds;
                        }
					

                         var createdDateTime =  json.data.eMISApplication.DateCreated

                         dayjs.extend(timeZone)

                         var tempd1 = dayjs(createdDateTime).format('YYYY-MM-DD')
                         var tempd1_1 = dayjs(tempd1)

                         var tempd2 = dayjs().format('YYYY-MM-DD', { timeZone: 'Asia/Kuala_Lumpur' })
                         
                         var tempd2_1 = dayjs(tempd2)


                         var diffDays =tempd1_1.diff(tempd2_1, 'day')
                                        
                         if(diffDays<=1){
                            let fromTime =  dayjs(createdDateTime)
                            
                         
                            let currentTime = dayjs().format('YYYY-MM-DD HH:mm:ss',{ timeZone: 'Asia/Kuala_Lumpur' })
                            let currentTime2 = dayjs(currentTime)

                            var diff =currentTime2.diff(fromTime, 'minute')

                            if((Math.abs(Math.round(diff)) <= 30)&&(Math.abs(Math.round(diff)) >= 0)){
                                rootState.AOD.LandingPageTimer = 30 - Math.abs(Math.round(diff));
                            }else{
                                rootState.AOD.LandingPageTimer =  0
                            }
                             
                             
                         }else{
                             rootState.AOD.LandingPageTimer = 0;
                         }  

                        rootState.Lookup.Schemes_LK = [];
                        rootState.Transactions.Transaction.Investment = [];

                        var tempval = 0; 
                        if(json.data.eMISApplication.funds.length>0){
                            for(var i =0; i< json.data.eMISApplication.funds.length; i++){
                                tempval = json.data.eMISApplication.funds[i].investmentAmount + tempval
                            }
                        }
                        
                        rootState.Transactions.Transaction.TotalInvestment = tempval
                        if(json.data.eMISApplication.funds.length> 0){
                            for(var i=0;i<rootState.AD.FundList.length;i++){
                                for(var j= 0; j < state.EmisBuyFund.length; j++){
                                // console.log(state.EmisOnboardFund[j].AhamSchemeCode)
                                    var salesCharge = 0  
                                    if(rootState.AD.FundList[i].Scheme == state.EmisBuyFund[j].AhamSchemeCode){
                                    var tempMinAmount = 0;
                                        if((rootState.AD.FundList[i].MinimumInitialInvestment =="")||(rootState.AD.FundList[i].MinimumInitialInvestment =="undefined")||(rootState.AD.FundList[i].MinimumInitialInvestment ==undefined)){
                                            tempMinAmount = 0;
                                        }else{
                                            tempMinAmount = rootState.AD.FundList[i].MinimumInitialInvestment
                                        }
                                        salesCharge = (parseFloat(state.EmisBuyFund[j].salesCharge)* 100)

                                        rootState.Transactions.Transaction.Investment.push({
                                            count :j,
                                            SchemeName :rootState.AD.FundList[i].SchemeName,
                                            Scheme : state.EmisBuyFund[j].AhamSchemeCode,
                                            Amount : parseFloat(state.EmisBuyFund[j].investmentAmount).toFixed(2),
                                            SalesCharge:salesCharge,
                                            MinimumInitialInvestment : tempMinAmount,
                                            productCode :rootState.AD.FundList[i].FundCode,
                                            ProspectusLink:'',
                                            BrochureLink:'',
                                            PrdtHighlightLink:'',
                                            FundFactLink:'',
                                        })
                                    }
                                    salesCharge=0;
                                    //console.log(state.EmisFund[j].AhamSchemeCode)
                                } 
                            }
                        }else{
                            return "Sorry, unable to retrieve fund details from E-Mis to begin your transaction."
                        }

                        if((json.data.eMISApplication.newNric!=undefined)||(json.data.eMISApplication.newNric!="")){
                            rootState.AOD.PersonalInformation.IdType='NewIC'
                            rootState.AOD.PersonalInformation.NRIC = json.data.eMISApplication.newNric
                        
                        }else{
                            if((json.data.eMISApplication.oldNric!=undefined)||(json.data.eMISApplication.oldNric!="")){
                                rootState.AOD.PersonalInformation.DateOfBirth = json.data.eMISApplication.eMISAccountOpeningInfo.memberBirthDate
                                rootState.AOD.PersonalInformation.IdType='OldID'
                                rootState.AOD.PersonalInformation.OldID = json.data.eMISApplication.oldNric
                
                            }else{
                                rootState.AOD.PersonalInformation.DateOfBirth = json.data.eMISApplication.eMISAccountOpeningInfo.memberBirthDate
                                rootState.AOD.PersonalInformation.IdType='OldID'
                                rootState.AOD.PersonalInformation.OldID = json.data.eMISApplication.otherId
                            }
                        } 

                        if(json.data.eMISApplication.ePFNo != undefined){

                            rootState.CD.CustomerDetails.EPFNo= json.data.eMISApplication.ePFNo
                            rootState.AOD.PersonalInformation.EPFNumber = json.data.eMISApplication.ePFNo
                        }else{
                            return "Sorry, unable to retrieve Investor EPF NO from E-Mis to begin your transaction."
                        }

                        if(json.data.eMISApplication.ApplicationFormId != undefined){
                            rootState.Transactions.ApplicationFormId = json.data.eMISApplication.ApplicationFormId
                        }else{
                            return "Sorry, Unable to retrieve EmisReferenceNo"
                        }

                        if(json.data.eMISApplication.shariahEffectiveDate != undefined){

                            rootState.AOD.PersonalInformation.EPFIEffectiveDate = json.data.eMISApplication.shariahEffectiveDate
                        }else{
                            return "Sorry, unable to retrieve Investor EPF Syariah Effective from E-Mis to begin your transaction."
                        }

                        if(json.data.eMISApplication.referenceId != undefined){

                            rootState.Transactions.referenceid = json.data.eMISApplication.referenceId
                        }else{
                            return "Sorry, unable to retrieve Investor EPF Reference ID to begin your transaction."
                        }
                        if(json.data.eMISApplication.shariahFlag != undefined){

                            var flag = json.data.eMISApplication.shariahFlag 
                            if(flag=== true){
                                rootState.AOD.PersonalInformation.EPFAccount = "Islamic"
                            }else{
                                rootState.AOD.PersonalInformation.EPFAccount = "Conventional"
                            }                    
                    
                        }else{
                            return "Sorry, unable to retrieve Investor EPF Reference ID to begin your transaction."
                        }

                        if(rootState.AOD.PersonalInformation.OldID!=""){
                            if(rootState.AOD.PersonalInformation.OldID== rootState.Login.UserIC){
                                return true
                            }else{
                                return "Sorry, the User NRIC from EPF and our login NRIC doesn't match."
                            }
                        }else if( rootState.AOD.PersonalInformation.NRIC!=""){
                            if(json.data.eMISApplication.newNric == rootState.Login.UserIC){
                                return true
                            }else{
                                return "Sorry, the User NRIC from EPF and our login NRIC doesn't match."
                            }
                        }
                 }else{
                    return 'Sorry, Looks like your Transaction is complete. Please restart your transaction from I-Akaun.'
                } 
                
             }else{
                return 'Sorry, Looks like your Application ID is wrong! Unable to locate your transaction data from our system'
            }          
        })
        .catch(function (error) {
            var payload = "Method:  GetEmisBuyApplication -> " + error.toString()

             dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            })  
            return false
        });
    },
    async getEmisDocumentDownloadLink({state,rootState,dispatch},Obj){
        
        //   AsOfDate:today,
        //FundCode:FundCode

        var today = new Date();
        var dd = today.getDate();

        var mm = today.getMonth()+1; 
        var yyyy = today.getFullYear();
        if(dd<10) 
        {
            dd='0'+dd;
        } 

        if(mm<10) 
        {
            mm='0'+mm;
        } 

        today = yyyy+'-'+mm+'-'+dd
        //console.log(apiconnectuat + 'fund/documents?pasofdate='+today+'&pproductcode='+Obj.FundCode)
        return this.$httpClient({
            method: "get",
            url: apiconnectuat + 'fund/documents?pproductcode='+Obj.FundCode,
            // headers: { Authorization: "Bearer " +  state.FundAPIToken}
            //tokenkey_fund
            //process.env.VUE_APP_FUND
        }).then(function (json) { 
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(json)
            })

             //   console.log(json)
               var ProspectusLink=''
               var BrochureLink=''
               var PrdtHighlightLink=''
               var FundFactLink=''
                var secondaryLanguage = ''

                if(rootState.Login.LanguageToLoad==="EN"){
                    secondaryLanguage = 'MS'
                }else{
                    secondaryLanguage = 'EN'
                }
                if(json.data.documentsResult.length > 0){
                    for(var i=0; i<json.data.documentsResult.length; i++){
                        if((json.data.documentsResult[i].DocType==='PS')&&(json.data.documentsResult[i].Language===rootState.Login.LanguageToLoad)){
                            ProspectusLink = json.data.documentsResult[i].DocUrl
                        }
                        if((json.data.documentsResult[i].DocType==='BRO')&&(json.data.documentsResult[i].Language===rootState.Login.LanguageToLoad)){
                            BrochureLink = json.data.documentsResult[i].DocUrl
                        }
                        if((json.data.documentsResult[i].DocType==='PHS')&&(json.data.documentsResult[i].Language===rootState.Login.LanguageToLoad)){
                            PrdtHighlightLink = json.data.documentsResult[i].DocUrl
                        }
                        if((json.data.documentsResult[i].DocType==='FFS')&&(json.data.documentsResult[i].Language === rootState.Login.LanguageToLoad)){
                            FundFactLink = json.data.documentsResult[i].DocUrl
                        }

                    }

                    if(ProspectusLink===''){
                        for(var i=0; i<json.data.documentsResult.length; i++){
                            if((json.data.documentsResult[i].DocType==='PS')&&(json.data.documentsResult[i].Language===secondaryLanguage)){
                                ProspectusLink = json.data.documentsResult[i].DocUrl
                            } 
                        }
                    }

                    if(BrochureLink===''){
                        for(var i=0; i<json.data.documentsResult.length; i++){
                            if((json.data.documentsResult[i].DocType==='BRO')&&(json.data.documentsResult[i].Language===secondaryLanguage)){
                                BrochureLink = json.data.documentsResult[i].DocUrl
                            } 
                        }
                    }

                    if(PrdtHighlightLink===''){
                        for(var i=0; i<json.data.documentsResult.length; i++){
                            if((json.data.documentsResult[i].DocType==='PHS')&&(json.data.documentsResult[i].Language===secondaryLanguage)){
                                PrdtHighlightLink = json.data.documentsResult[i].DocUrl
                            } 
                        }
                    }

                    if(FundFactLink===''){
                        for(var i=0; i<json.data.documentsResult.length; i++){
                            if((json.data.documentsResult[i].DocType==='FFS')&&(json.data.documentsResult[i].Language===secondaryLanguage)){
                                FundFactLink = json.data.documentsResult[i].DocUrl
                            } 
                        }
                    }

                    for(var i=0; i<rootState.Transactions.Transaction.Investment.length; i++){
                        if(rootState.Transactions.Transaction.Investment[i].productCode === Obj.FundCode){
                            rootState.Transactions.Transaction.Investment[i].ProspectusLink = ProspectusLink
                            rootState.Transactions.Transaction.Investment[i].BrochureLink = BrochureLink
                            rootState.Transactions.Transaction.Investment[i].PrdtHighlightLink = PrdtHighlightLink
                            rootState.Transactions.Transaction.Investment[i].FundFactLink = FundFactLink
                        }
                    }

                }    
                

        }).catch(function (error) {
           var payload = "Method:  getEmisDocumentDownloadLink -> " + error.toString()

           dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            })
            return false
        }); 
    },
    async  GetListOfFundBuy({state,rootState,dispatch}, Obj){
        
   
        return this.$httpClient({
            method: "get",
            url: apipath_fund,
            // headers: { Authorization: "Bearer " + state.FundAPIToken }
            //tokenkey_fund
            //process.env.VUE_APP_FUND
        })
        .then(function (response) {
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(response)
            })

           // console.log('GetListOfFundBuy')
           // console.log(response.data)
           if(response.data.Schemes.length>0){

            rootState.AD.FundList = response.data.Schemes
           }
           
            return true
            //return true
           /*  for(var i=0;i<response.data.Schemes.length;i++){
                for(var j= 0; j < state.EmisOnboardFund.length; j++){
                   // console.log(state.EmisOnboardFund[j].AhamSchemeCode)
                    var salesCharge = 0  
                    if(response.data.Schemes[i].Scheme == state.EmisOnboardFund[j].AhamSchemeCode){
                                  
                       salesCharge = (parseFloat(state.EmisOnboardFund[j].salesCharge)* 100)
                        rootState.Transactions.Transaction.Investment.push({
                            SchemeName : response.data.Schemes[i].SchemeName,
                            Scheme : state.EmisOnboardFund[j].AhamSchemeCode,
                            Amount : state.EmisOnboardFund[j].investmentAmount,
                            SalesCharge:salesCharge,
                        })
                    }
                    salesCharge=0;
                    //console.log(state.EmisFund[j].AhamSchemeCode)
                }
            } */
        })
        .catch(function (error){
           var payload = "Method:  GetListOfFundBuy -> " + error.toString()

           dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 
            //console.log('GetListOfFundBuy')
           // console.log(error)
           // console.log(error.response);
           // console.log(error)
            return 'error'
        });
    },

    async  FundList({state,rootState,dispatch}, Obj){

       
        return this.$httpClient({
            method: "get",
            url: apipath_fund,
            // headers: { Authorization: "Bearer " +  tokenkey_fund}
            //process.env.VUE_APP_FUND
        })
        .then(function (response) {
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(response)
            })
            //console.log(response.data)
           // rootState.AD.FundList = response.data.Schemes
           
            return response.data.Schemes
        })
        .catch(function (error){
            var payload = "Method:  FundList -> " + error.toString()

            dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 
           // console.log(error.response);
           // console.log(error)
            return false
        });
    },
    async GetEmisSwitchRedeemApplication({ getters, rootState,state,dispatch }, Obj){
       
    
        rootState.AOD.OnboardingAppID = Obj.ApplicationId
        //alert(Obj.ApplicationId)
        return this.$httpClient({
            method: "get",
            url: apipath_transaction_emis + Obj.ApplicationId, 
            //tokenkey_transaction
            // headers: { Authorization: "Bearer " +  state.TransactionAPIToken}
            //process.env.VUE_APP_TRANSACTIONTOKEN
        })
        .then(function(json){
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(json)
            })
        //    console.log(json)
            if(json.data.eMISApplication.ApplicationId != undefined){
             ///   console.log(json.data.eMISApplication.DigitalTransactionApplicationId)
             //uncomment this
                if(json.data.eMISApplication.DigitalTransactionApplicationId ===undefined){

                   
                    //rootState.AOD.PersonalInformation.FullName=json.data.eMISApplication.eMISAccountOpeningInfo.memberName 
                    state.EmisFund = json.data.eMISApplication.funds;
                    rootState.Transactions.IncomingEMISFUND = json.data.eMISApplication.funds;
                    state.emisJson = json.data

                /*   if((json.data.eMISApplication.referenceId !=undefined)||(json.data.eMISApplication.referenceId !="")){
                        
                    rootState.Transactions.referenceid = json.data.eMISApplication.referenceId
                    }else{
                        return "Sorry, Unable to retrieve Transaction Reference ID."
                    } */
                // rootState.Transactions.Transaction.TotalInvestment = json.data.eMISApplication.TotalAmount;

                    if(json.data.eMISApplication.ApplicationFormId != undefined){
                        rootState.Transactions.ApplicationFormId = json.data.eMISApplication.ApplicationFormId
                    }else{
                        return "Sorry, Unable to retrieve EmisReferenceNo"
                    }
                    
                    if((json.data.eMISApplication.newNric!=undefined)||(json.data.eMISApplication.newNric!="")){
                        rootState.AOD.PersonalInformation.IdType='NewIC'
                        rootState.AOD.PersonalInformation.NRIC = json.data.eMISApplication.newNric
                    
                    }else{
                        if((json.data.eMISApplication.oldNric!=undefined)||(json.data.eMISApplication.oldNric!="")){
                            rootState.AOD.PersonalInformation.DateOfBirth = json.data.eMISApplication.eMISAccountOpeningInfo.memberBirthDate
                            rootState.AOD.PersonalInformation.IdType='OldID'
                            rootState.AOD.PersonalInformation.OldID = json.data.eMISApplication.oldNric
            
                        }else{
                            rootState.AOD.PersonalInformation.DateOfBirth = json.data.eMISApplication.eMISAccountOpeningInfo.memberBirthDate
                            rootState.AOD.PersonalInformation.IdType='OldID'
                            rootState.AOD.PersonalInformation.OldID = json.data.eMISApplication.otherId
                        }
                    }

                // rootState.AOD.ContactInformation.MobileNo = json.data.eMISApplication.eMISAccountOpeningInfo.memberMobileNo
                    //rootState.AOD.ContactInformation.EmailAddress = json.data.eMISApplication.eMISAccountOpeningInfo.memberEmail
                
                    if((json.data.eMISApplication.ePFNo !=undefined)||(json.data.eMISApplication.ePFNo !="")){
                        
                        rootState.CD.CustomerDetails.EPFNo= json.data.eMISApplication.ePFNo
                        rootState.AOD.PersonalInformation.EPFNumber = json.data.eMISApplication.ePFNo
                    }else{
                        return "Sorry, Unable to retrieve Customer's EPF Number."
                    }

                    if(json.data.eMISApplication.shariahEffectiveDate != undefined){

                        rootState.AOD.PersonalInformation.EPFIEffectiveDate = json.data.eMISApplication.shariahEffectiveDate
                    }else{
                        return "Sorry, Unable to retrieve Customer's EPF Shariah Effective Date"
                    }
                    
                // console.log('flag --> ' + json.data.eMISApplication.shariahFlag )
                if(json.data.eMISApplication.shariahFlag != undefined){

                        var flag = json.data.eMISApplication.shariahFlag 
                        if(flag=== true){
                            rootState.AOD.PersonalInformation.EPFAccount = "Islamic"
                        }else{
                            rootState.AOD.PersonalInformation.EPFAccount = "Conventional"
                        }
                    }else{
                        return "Sorry, unable to retrieve Investor EPF Reference ID to begin your transaction."
                    }

                    if(rootState.AOD.PersonalInformation.OldID !=""){
                        if(rootState.AOD.PersonalInformation.OldID == rootState.Login.UserIC){
                            return true
                        }else{
                            return "Sorry, the User NRIC from EPF and our login NRIC doesn't match."
                        }
                    }else if(rootState.AOD.PersonalInformation.NRIC !=""){
                        if(json.data.eMISApplication.newNric == rootState.Login.UserIC){
                            return true
                        }else{
                            return "Sorry, the User NRIC from EPF and our login NRIC doesn't match."
                        }
                    }
                }else{
                    
                    return 'Sorry, Looks like your Transaction is complete. Please restart your transaction from I-Akaun.'
                }  

               // return true
               //uncomment this
            }else{
             return 'Sorry, Looks like your Application ID is wrong! Unable to locate your transaction data from our system'
            }
        })
        .catch(function (error) {
           var payload = "Method:  GetEmisSwitchRedeemApplication -> " + error.toString()

           dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 
         // console.log(error)
            return false 
        });
    },
    async eMISTransactionConfirm({state,rootState,dispatch},obj){
       
     //   var currentDateTime = new Date().toLocaleString()

/* 
     var today = new Date();
     var dd = String(today.getDate()).padStart(2, '0');
     var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
     var yyyy = today.getFullYear();


     var seconds = today.getSeconds()
     if(seconds < 10){
         seconds = '0'+seconds
     }
     var minutes =  today.getMinutes()
     if(minutes < 10){
        minutes = '0'+minutes
     }
     var hours =  today.getHours()
     if(hours < 10){
        hours = '0'+hours
     }

     var currentTime = hours + ":" + minutes + ":" +  seconds;

    var currentDateTime =yyyy  + '-' + mm + '-' + dd + ' ' + currentTime; */
    // console.log( ' -- > ' + currentDateTime)

    dayjs.extend(timeZone)
                         
    var tempd2 =dayjs().format('YYYY-MM-DD',{ timeZone: 'Asia/Kuala_Lumpur' })
    
    var tempd2_1 =dayjs().format('HH:mm:ss',{ timeZone: 'Asia/Kuala_Lumpur' })
    
    var currentDateTime = tempd2 + ' '+ tempd2_1

    var tempInvest = []
      /*  rootState.Transactions.Transaction.Investment.push({
            SchemeName : response.data.Schemes[i].SchemeName,
            Scheme : state.EmisFund[j].AhamSchemeCode,
            Amount : state.EmisFund[j].investmentAmount,
            SalesCharge:salesCharge,
        })*/
        var invRoot = rootState.Transactions.Transaction.Investment
        var salesChrg =0
        var totalInvestmentAmount = 0;
        for(var i = 0; i <invRoot.length; i++ ){
            salesChrg =  ((invRoot[i].SalesCharge) /100)
            var tempValu = invRoot[i].Amount.toString();
            
            if(tempValu.includes(',')){
                tempValu = invRoot[i].Amount.replace(',','')
             //   tempValu = tempValu.replace(',','')
                tempValu = parseFloat(tempValu).toFixed(2)
            }else{
                tempValu = invRoot[i].Amount
                tempValu = parseFloat(tempValu).toFixed(2)
            }
           
            totalInvestmentAmount = parseFloat(tempValu) +  parseFloat(totalInvestmentAmount)
            tempInvest.push({
                investmentAmount : tempValu,
                salesCharge: parseFloat(salesChrg),
                AhamSchemeCode : invRoot[i].Scheme
            })
            salesChrg = 0
        }

       return this.$httpClient({
            method: "post",
            url: apipath_transaction_emis_confirmation,
            // headers: { Authorization: "Bearer " +  state.TransactionAPIToken},
            //tokenkey_transaction
            //process.env.VUE_APP_TRANSACTIONTOKEN
            data : 
                {
                    "ApplicationId": rootState.AOD.OnboardingAppID,
                    "AccountNo": rootState.AOD.OnBoardUTAccountNo,
                    "TransactionDateTime": currentDateTime ,
                    "TotalAmount": totalInvestmentAmount,
                    //rootState.Transactions.Transaction.TotalInvestment,
                    "FundsConfirm": tempInvest,
                    "DigitalTransactionApplicationId":obj.DigitalID,
                    "SelfOnboardApplicationId" : rootState.AOD.OnboardId
                }
             
        }).then(function (response) {
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(response)
            })
            //console.log('eMISTransactionConfirm')
           // console.log(response)
                if(response.data.StatusCode == 200){
                    return true
                }else{
                    return response.data.Message
                }

        }).catch(function (error) {
          var payload = "Method:  eMISTransactionConfirm -> " + error.toString()

          dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 
         //   console.log('eMISTransactionConfirm')
          //  console.log(error)
        //    console.log(error)
          //  console.log(error.response);
            return error.toString()
        });
    },

    async eMISTransactionConfirmSwitchRedeem({state,rootState,dispatch},obj){
     
        //   var currentDateTime = new Date().toLocaleString()   
   
        /* var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
   
        var seconds = today.getSeconds()
        if(seconds < 10){
            seconds = '0'+seconds
        }
        var minutes =  today.getMinutes()
        if(minutes < 10){
           minutes = '0'+minutes
        }
        var hours =  today.getHours()
        if(hours < 10){
           hours = '0'+hours
        }
   
        var currentTime = hours + ":" + minutes + ":" +  seconds;
   
       var currentDateTime =yyyy  + '-' + mm + '-' + dd + ' ' + currentTime;    */

       dayjs.extend(timeZone)
                         
       var tempd2 =dayjs().format('YYYY-MM-DD',{ timeZone: 'Asia/Kuala_Lumpur' })
       
       var tempd2_1 =dayjs().format('HH:mm:ss',{ timeZone: 'Asia/Kuala_Lumpur' })
       
       var currentDateTime = tempd2 + ' '+ tempd2_1;

          return this.$httpClient({
               method: "post",
               url: apipath_transaction_emis_confirmation,
              //  headers: { Authorization: "Bearer " + state.TransactionAPIToken},
               //state.TransactionAPIToken
               //tokenkey_transaction
               //process.env.VUE_APP_TRANSACTIONTOKEN
               data : 
                {
                    "ApplicationId": rootState.AOD.OnboardingAppID,
                    "AccountNo": rootState.AOD.OnBoardUTAccountNo,
                    "TransactionDateTime": currentDateTime ,
                    "DigitalTransactionApplicationId":obj.DigitalID,
                }                
           }).then(function (response) {
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(response)
            })
           //    console.log('eMISTransactionConfirmSwitchRedeem')

             //  console.log(response)
                   if(response.data.StatusCode == 200){
                       return true
                   }else{
                       return response.data.Message
                   }
   
           }).catch(function (error) {
           var payload = "Method:  eMISTransactionConfirmSwitchRedeem -> " + error.toString()

           dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 
          //  console.log('eMISTransactionConfirmSwitchRedeem')
            //   console.log(error)
              // console.log(error.response);
               return error.toString()
           });
       },
   


    async CIFInfo  ({ getters, rootState,state,dispatch }, Obj){
       

        rootState.FATCA.PersonalAsset = false;
        rootState.ED.EmploymentStatus =''
        rootState.ED.BusinessNature = ''
        rootState.ED.BusinessNature2=''

        return this.$httpClient({
            method: "get",
            url: apiconnectuat+'cif/'+ Obj.UserId + '/enquiry/customerinformation',
            //'/enquiry/cifinformation',
          //  headers: { Authorization: "Bearer " +  state.CIFAPIToken}
           // process.env.VUE_APP_CIF
        })
        .then(function(json){
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(json)
            })

           // console.log(json.data)
           rootState.AOD.ContactInformation.MobileNoCode = "+ 60"
         // alert(json.data.CustomerID)
           // if((json.data.CIF.CustomerID != undefined)||(json.data.CIF.CustomerID !='')){
                //rootState.AOD.PersonalInformation.Salutation = 
               // json.data.CIF.CustomerDetail.SalutationName
               if(json.data.IsSuccessful!=false){ 
                        if(json.data.CIF.CustomerDetail.SalutationName != undefined){
                                for(var i =0; i< rootState.Lookup.Salutation_LK.length; i++){
                                    if(json.data.CIF.CustomerDetail.SalutationName==rootState.Lookup.Salutation_LK[i].label){
                                        rootState.AOD.PersonalInformation.Salutation = rootState.Lookup.Salutation_LK[i].label
                                    }
                                }
                            }


                        if(json.data.CIF.CustomerDetail.Race != undefined){
                        for(var i=0; i < rootState.Lookup.Race_LK.length; i++){
                            if(rootState.Lookup.Race_LK[i].value== json.data.CIF.CustomerDetail.Race){
                                rootState.AOD.PersonalInformation.Race = rootState.Lookup.Race_LK[i].label
                                rootState.AOD.PersonalInformation.RaceOth =json.data.CIF.CustomerDetail.RaceOther
                            }
                                
                            }
                        }

                        if( json.data.CIF.CustomerDetail.HolderStatus != undefined){
                        for(var i=0; i< rootState.Lookup.HolderStatus_LK.length; i++){
                            if(rootState.Lookup.HolderStatus_LK[i].value==json.data.CIF.CustomerDetail.HolderStatus){
                                
                                rootState.AOD.PersonalInformation.HolderStatus = rootState.Lookup.HolderStatus_LK[i].label
                            }
                        }
                        }


                        if( json.data.CIF.CustomerDetail.MaritalStatusName != undefined){
                            for(var i=0; i< rootState.Lookup.MaritalStatus_LK.length; i++){
                                if(rootState.Lookup.MaritalStatus_LK[i].value==json.data.CIF.CustomerDetail.MaritalStatus){
                                    
                                    rootState.AOD.PersonalInformation.MaritalStatus = rootState.Lookup.MaritalStatus_LK[i].label
                                }
                            } 
                        }

                        if(json.data.CIF.CustomerDetail.NoOfDependents != undefined){
                        if(json.data.CIF.CustomerDetail.NoOfDependents>0){
                            rootState.AOD.PersonalInformation.IsDependents = true
                            rootState.AOD.PersonalInformation.NoOfDependents = json.data.CIF.CustomerDetail.NoOfDependents
                        }else{
                            rootState.AOD.PersonalInformation.IsDependents = false
                        }

                        }else{
                            rootState.AOD.PersonalInformation.IsDependents = false
                        }

                       rootState.AOD.ContactInformation.MobileNoCode = "+ 60"
                       rootState.AOD.PersonalInformation.CountryOfBirth= "MALAYSIA"
                       if(json.data.CIF.CustomerDetail.NationalityName != undefined){
                        for(var i=0; i< rootState.Lookup.Nationality_LK.length; i++){
                           if(rootState.Lookup.Nationality_LK[i].value==json.data.CIF.CustomerDetail.Nationality){
                                rootState.AOD.PersonalInformation.nationality = rootState.Lookup.Nationality_LK[i].label
                            }
                        } 
                       //rootState.AOD.PersonalInformation.Nationality = json.data.CIF.CustomerDetail.NationalityName
                       }

                       if(json.data.CIF.CustomerDetail.SourceOfIncome != undefined){
                        for(var i = 0; i<json.data.CIF.CustomerDetail.SourceOfIncome.length; i++){
                            rootState.AOD.PersonalInformation.SourceOfWealth.push(json.data.CIF.CustomerDetail.SourceOfIncome[i].Name) 
                            if( json.data.CIF.CustomerDetail.SourceOfIncome[i].ID=="7"){
                                rootState.AOD.PersonalInformation.SourceOfWealthOther = json.data.CIF.CustomerDetail.SourceOfIncomeOther 
                            }
                        }
                    }

                    if(json.data.CIF.CustomerDetail.InvestmentPurpose != undefined){
                        for(var i = 0; i<json.data.CIF.CustomerDetail.InvestmentPurpose.length; i++){
                            rootState.AOD.PersonalInformation.InvestmentPurpose.push(json.data.CIF.CustomerDetail.InvestmentPurpose[i].Name) 
                            if( json.data.CIF.CustomerDetail.InvestmentPurpose[i].ID=="5"){
                                rootState.AOD.PersonalInformation.InvestmentPurposeOther = json.data.CIF.CustomerDetail.InvestmentPurposeOther 
                            }
                        }
                    }

                   if(json.data.CIF.CustomerDetail.OccupationName != undefined){
                    for(var i=0; i< rootState.Lookup.EmploymentStatus_LK.length; i++){
                        if(rootState.Lookup.EmploymentStatus_LK[i].value==json.data.CIF.CustomerDetail.Occupation){  
                                rootState.AOD.PersonalInformation.EmploymentStatus = rootState.Lookup.EmploymentStatus_LK[i].label
                                rootState.ED.EmploymentStatus = rootState.Lookup.EmploymentStatus_LK[i].label
                            }
                        } 
                   }else{
                    rootState.ED.EmploymentStatus =''
                   }

                   if(json.data.CIF.CustomerDetail.BusinessNature != undefined && json.data.CIF.CustomerDetail.BusinessNatureName != undefined){
                    //rootState.ED.BusinessNature = json.data.CIF.CustomerDetail.BusinessNature  +" - "+json.data.CIF.CustomerDetail.BusinessNatureName
                   
                    for(var i=0; i< rootState.Lookup.NatureofBusiness_LK.length; i++){
                        if(rootState.Lookup.NatureofBusiness_LK[i].value==json.data.CIF.CustomerDetail.BusinessNature){
                            
                            rootState.ED.BusinessNature = rootState.Lookup.NatureofBusiness_LK[i].label
                        }
                    } 
                }

                //    if(json.data.CIF.CustomerDetail.BusinessNatureName != undefined){
                //     rootState.ED.BusinessNatureName = json.data.CIF.CustomerDetail.BusinessNatureName // +" - "+json.data.CIF.CustomerDetail.BusinessNatureName
                //     }

                   if(json.data.CIF.CustomerDetail.BusinessNature != undefined){
                        rootState.ED.BusinessNature2 = json.data.CIF.CustomerDetail.BusinessNature
                    }

                    if(json.data.CIF.CustomerDetail.EmployerName != undefined){
                   rootState.ED.BusinessNatureOther =json.data.CIF.CustomerDetail.BusinessNatureOther
                    }

                    if(json.data.CIF.CustomerDetail.EmployerName != undefined){
                   rootState.ED.Designation=json.data.CIF.CustomerDetail.OccupationDesignation
                   }

                   if(json.data.CIF.CustomerDetail.EmployerName != undefined){
                   rootState.ED.EmployerName=json.data.CIF.CustomerDetail.EmployerName
                   }

                   if(json.data.CIF.CustomerDetail.EmployerAddress != undefined){
                   var fields = json.data.CIF.CustomerDetail.EmployerAddress.split(/\n/);
                   var add1 = fields[0];
                   rootState.ED.EmployerAddress.Address1 =add1
                   }

                   if(json.data.CIF.CustomerDetail.IsFamilyPoliticallyExposedPerson != undefined){
                   rootState.FATCA.PEP =  json.data.CIF.CustomerDetail.IsFamilyPoliticallyExposedPerson;
                   }
                   if(json.data.CIF.CustomerDetail.PoliticallyExposedPersonPosition != undefined){
                   rootState.FATCA.PEPPosition = json.data.CIF.CustomerDetail.PoliticallyExposedPersonPosition;
                   }

                   if(json.data.CIF.CustomerDetail.PoliticallyExposedPersonFamilyRelation != undefined){
                   rootState.FATCA.PEPRelationship = json.data.CIF.CustomerDetail.PoliticallyExposedPersonFamilyRelation;
                   }

                   if(json.data.CIF.CustomerDetail.IsQualifiedInvestor != undefined){
                   rootState.FATCA.SophisticatedInvestor = json.data.CIF.CustomerDetail.IsQualifiedInvestor;
                   }

                   if(json.data.CIF.CustomerDetail.NetPersonalAsset != undefined){
                       if((json.data.CIF.CustomerDetail.NetPersonalAsset === "false")||(json.data.CIF.CustomerDetail.NetPersonalAsset === false)){
                        rootState.FATCA.PersonalAsset =false
                       }else{
                        rootState.FATCA.PersonalAsset = true
                       }
                    //json.data.CIF.CustomerDetail.NetPersonalAsset;
                   }else{
                    rootState.FATCA.PersonalAsset = false
                   }
                
                   if(json.data.CIF.FATCA.USResidentStatus != undefined){
                   rootState.FATCA.UsResident = json.data.CIF.FATCA.USResidentStatus;
                   }

                   if(json.data.CIF.FATCA.TypeOfUSIndicia != undefined){
                    for(var i = 0; i<json.data.CIF.FATCA.TypeOfUSIndicia.length; i++){
                       rootState.FATCA.UsResidentIndicia.push(json.data.CIF.FATCA.TypeOfUSIndicia[i].ID) 
                        if(json.data.CIF.FATCA.TypeOfUSIndicia[i].ID =="03"){
                           rootState.FATCA.UsResidentIndicia = json.data.CIF.FATCA.TypeOfUSIndicia 
                        }
                     }
                   } 

                    if(json.data.CIF.FATCA.TaxResidency!==undefined){
                    rootState.FATCA.TaxResidency = json.data.CIF.FATCA.TaxResidency;
                    }


                    if(json.data.CIF.FATCA.TIN!==undefined){
                        for(var i=0;i<json.data.CIF.FATCA.TIN.length;i++){
                            var TId;
                            if (rootState.FATCA.TaxResidencyTIN.length == 0){
                                TId = 1001;
                            }
                            else{
                                TId = Number(rootState.FATCA.TaxResidencyTIN[rootState.FATCA.TaxResidencyTIN.length-1].Id) + 1;
                            }
                            for(var j=0;j<rootState.FATCA.TaxResidencyTIN.length;j++){
                                if (TId == rootState.FATCA.TaxResidencyTIN[i].Id)
                                TId = Number(rootState.FATCA.TaxResidencyTIN[i].Id) + 1;
                            }
                            rootState.FATCA.TaxResidencyTIN.push({
                                Id :TId,
                                TaxResidency_Country : json.data.CIF.FATCA.TIN[i].Country,
                                TaxResidency_CountryName : json.data.CIF.FATCA.TIN[i].CountryName,
                                TaxResidency_TIN : json.data.CIF.FATCA.TIN[i].TINNo,
                                TaxResidency_IsTINUnavailable : json.data.CIF.FATCA.TIN[i].IsUnavailable,
                                TaxResidency_UnavailableReason : json.data.CIF.FATCA.TIN[i].UnavailableReason,
                                TaxResidency_ReasonB : json.data.CIF.FATCA.TIN[i].ReasonBRemark,
                            });
                        }
                    }
             
                  // rootState.ED.EmployerAddress.Address2 =add2
                   //rootState.ED.EmployerAddress.Postcode ='50200'
                  // rootState.ED.EmployerAddress.City = "Kuala Lumpur"
                   
                  // rootState.ED.EmployerAddress.Country= "Malaysia"
                  // rootState.ED.EmployerAddress.State= "WILAYAH PERSEKUTUAN"
                  
                   //.push({
                   //    label: json.data.CIF.CustomerDetail.Occupation,
                   ////    value: json.data.CIF.CustomerDetail.OccupationName
                  // }) 

                    //   var indiciaValue = ''
               /*  for(var i =0; i< rootState.Lookup.USResident_LK.length; i++){
                   //console.log(rootState.Lookup.USResident_LK[i])

                   if(rootState.Lookup.USResident_LK[i].label==json.data.CIF.FATCA.USResidentStatus){
                       indiciaValue =rootState.Lookup.USResident_LK[i].value
                       rootState.FATCA.UsResident = rootState.Lookup.USResident_LK[i].value
                   }
   
               }
               if(indiciaValue == '03'){
                   for(var j = 0; j< json.data.FATCA.TypeOfUSIndicia.length; j++){
                       for(var i = 0; i < rootState.Lookup.TypeOfUSIndicia_LK.length; i++){
                           if(json.data.FATCA.TypeOfUSIndicia[j].Description == rootState.Lookup.TypeOfUSIndicia_LK[i].label ){
                               rootState.FATCA.UsResidentIndicia.push(rootState.Lookup.TypeOfUSIndicia_LK[i].value)
                           }
                       }
                   } 
               }
               var taxResidencyValu = '';
               for(var i=0; i<rootState.Lookup.TaxResidency_LK.length;i++){
                   //console.log(rootState.Lookup.TaxResidency_LK[i])
                  if(rootState.Lookup.TaxResidency_LK[i].label ==json.data.FATCA.TaxResidency){
                   taxResidencyValu = rootState.Lookup.TaxResidency_LK[i].value 
                   rootState.FATCA.TaxResidency = rootState.Lookup.TaxResidency_LK[i].value 
                  }
               } */
            //    if(json.data.FATCA.TaxResidency != undefined){
            //        rootState.FATCA.TaxResidencyTIN = [];
            //        rootState.FATCA.TaxResidency = json.data.FATCA.TaxResidency
            //        if((taxResidencyValu== "2")||(taxResidencyValu=="3")){
            //           // if(json.data.TIN != undefined){
            //                //var TINRoot = json.data.TIN
            //                var TINCountry = '';
            //                //for(var i = 0; i < TINRoot.length; i++){
            //                  //  for(var j=0;j<rootState.Lookup.Country_LK.length;j++){
            //                     //   if(TINRoot[i].TINCountry===rootState.Lookup.Country_LK[j].value){
            //                      //      TINCountry = rootState.Lookup.Country_LK[j].label;
            //                       // }
            //                   // }
            //                 /*    rootState.FATCA.TaxResidencyTIN.push({
            //                       Id : TINRoot[i].Id,
            //                        TaxResidency_Country : json.data.FATCA.TINCountry1,
            //                        TaxResidency_CountryName : json.data.FATCA.TINCountry1,
            //                        TaxResidency_TIN : json.data.FATCA.TINNo1,
            //                        TaxResidency_IsTINUnavailable : json.data.FATCA.TINUnavailable1,
            //                        TaxResidency_UnavailableReason : json.data.FATCA.TINUnavailableReason1,
            //                        TaxResidency_ReasonB : json.data.FATCA.ReasonRemark1,
            //                    });*/
            //                //}
            //          //  }
            //        }
            //    }
   
            }else{
                rootState.FATCA.PersonalAsset = false;
                rootState.ED.EmploymentStatus =''
                rootState.ED.BusinessNature = ''
                rootState.ED.BusinessNature2=''
                rootState.AOD.ContactInformation.MobileNoCode = "+ 60"
                rootState.AOD.PersonalInformation.CountryOfBirth= "MALAYSIA"
            }
            
            return true
        }).catch(function (error) {
            //console.log(error.response);
           // console.log(error)
            var payload = "Method:  CIFInfo -> " + error.toString()

            dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 
            return error.toString()
        });
    },
    async  GetListOfFundForOnboarding({state,rootState,dispatch}, Obj){
        
        return this.$httpClient({
            method: "get",
            url: apipath_fund,
            // headers: { Authorization: "Bearer " +  state.FundAPIToken}
            //process.env.VUE_APP_FUND
        })
        .then(function (response) {
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(response)
            })

            rootState.Lookup.Schemes_LK = [];
            rootState.Transactions.Transaction.Investment = [];
            rootState.AOD.Transaction.Investment = [];
//
         //  console.log(response.data)
           // fundList= state.emisJson.eMISApplication.funds;
          //  console.log(rootState.AOD.OnboardFundJson.length)
           
            for(var i=0;i<response.data.Schemes.length;i++){
                for(var j= 0; j < rootState.AOD.OnboardFundJson.length; j++){
                   // console.log(state.EmisOnboardFund[j].AhamSchemeCode)
                    var salesCharge = 0  
                    if(response.data.Schemes[i].Scheme == rootState.AOD.OnboardFundJson[j].AhamSchemeCode){
                        var tempAmount = parseFloat( rootState.AOD.OnboardFundJson[j].investmentAmount).toFixed(2)
                       salesCharge = (parseFloat(rootState.AOD.OnboardFundJson[j].salesCharge)* 100)
                       var tempMinAmount = 0;
                       if((response.data.Schemes[i].MinimumInitialInvestment =="")||(response.data.Schemes[i].MinimumInitialInvestment =="undefined")||(response.data.Schemes[i].MinimumInitialInvestment ==undefined)){
                           tempMinAmount = 0;
                       }else{
                           tempMinAmount = response.data.Schemes[i].MinimumInitialInvestment
                       }
                        rootState.Transactions.Transaction.Investment.push({
                            SchemeName : response.data.Schemes[i].SchemeName,
                            Scheme : rootState.AOD.OnboardFundJson[j].AhamSchemeCode,
                            Amount :tempAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                            SalesCharge:salesCharge,
                            MinimumInitialInvestment : tempMinAmount,
                            productCode :response.data.Schemes[i].FundCode,
                            ProspectusLink:'',
                            BrochureLink:'',
                            PrdtHighlightLink:'',
                            FundFactLink:'',
                        })


                        rootState.AOD.Transaction.Investment.push({
                            SchemeCurrency : 'MYR',
                            TypeOfProduct :  'UTF',
                            SchemeCode :  rootState.AOD.OnboardFundJson[j].AhamSchemeCode,
                            Amount : rootState.AOD.OnboardFundJson[j].investmentAmount,
                            IndividualContribution : true,
                            SalesCharge : salesCharge,
                            Id : j + 1,
                            Plan : 'EPF',
                            MinimumInitialInvestment : tempMinAmount
                        })
                    }
                    salesCharge=0;
                    //console.log(state.EmisFund[j].AhamSchemeCode)
                }
            }
        })
        .catch(function (error){
            var payload = "Method:  GetListOfFundForOnboarding -> " + error.toString()
            dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 

           // console.log(error.response);
          //  console.log(error)
            return 'error'
        });
    },
    async GetLookup({ rootState,state,dispatch }) {
       
        return this.$httpClient({
            method: "get",
            url: apipath_onboarding_formlookup,
            // headers: { Authorization: "Bearer " + state.OnboardingAPIToken}
            //process.env.VUE_APP_ONBOARDING 
        })
        .then(function (response) {

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(response)
            })

            rootState.Lookup.Salutation_LK = [];
            for(var i=0;i<response.data.Salutation.length;i++){
                rootState.Lookup.Salutation_LK.push({
                    label:response.data.Salutation[i].Name,
                    value:response.data.Salutation[i].Value
                });
            }
            rootState.Lookup.Race_LK = [];
            for(var i=0;i<response.data.Race.length;i++){
                if(rootState.Login.LanguageToLoad === 'bm'){
                    rootState.Lookup.Race_LK.push({
                        label:response.data.Race[i].NameBM,
                        value:response.data.Race[i].Value
                    });
                }else{
                    rootState.Lookup.Race_LK.push({
                        label:response.data.Race[i].Name,
                        value:response.data.Race[i].Value
                    });
                }
                
            }
            rootState.Lookup.Gender_LK = [];
            for(var i=0;i<response.data.Gender.length;i++){
                rootState.Lookup.Gender_LK.push({
                    label:response.data.Gender[i].Name,
                    value:response.data.Gender[i].Value
                });
            }
            rootState.Lookup.Nationality_LK = [];
            for(var i=0;i<response.data.Nationality.length;i++){
                rootState.Lookup.Nationality_LK.push({
                    label:response.data.Nationality[i].Name,
                    value:response.data.Nationality[i].Value
                });
            }
            rootState.Lookup.HolderStatus_LK = [];
            for(var i=0;i<response.data.HolderStatus.length;i++){
                if(rootState.Login.LanguageToLoad === 'bm'){
                    rootState.Lookup.HolderStatus_LK.push({
                        label:response.data.HolderStatus[i].NameBM,
                        value:response.data.HolderStatus[i].Value
                    });
                }else{
                    rootState.Lookup.HolderStatus_LK.push({
                        label:response.data.HolderStatus[i].Name,
                        value:response.data.HolderStatus[i].Value
                    });
                }
              
            }
            // rootState.Lookup.State_LK = [];
            // for(var i=0;i<response.data.State.length;i++){
            //     rootState.Lookup.State_LK.push({
            //         label:response.data.State[i].Name,
            //         value:response.data.State[i].Value
            //     });
            // }
            rootState.Lookup.Country_LK = [];
            for(var i=0;i<response.data.Country.length;i++){
                rootState.Lookup.Country_LK.push({
                    label:response.data.Country[i].Name,
                    value:response.data.Country[i].Value
                });
            }

            rootState.Lookup.EPFAccountType=[];
            for(var i=0;i<response.data.EPFAccountType.length;i++){
                rootState.Lookup.EPFAccountType.push({
                    label:response.data.EPFAccountType[i].Name,
                    value:response.data.EPFAccountType[i].Value
                });
            }

            rootState.Lookup.EmploymentStatus_LK = [];
            for(var i=0;i<response.data.EmploymentStatus.length;i++){
                if(rootState.Login.LanguageToLoad === 'bm'){
                    rootState.Lookup.EmploymentStatus_LK.push({
                        label:response.data.EmploymentStatus[i].NameBM,
                        value:response.data.EmploymentStatus[i].Value
                    });
                }else{
                    rootState.Lookup.EmploymentStatus_LK.push({
                        label:response.data.EmploymentStatus[i].Name,
                        value:response.data.EmploymentStatus[i].Value
                    });
                }
              
            }
            rootState.Lookup.TaxResidency_LK = [];
            for(var i=0;i<response.data.TaxResidency.length;i++){
                if(rootState.Login.LanguageToLoad === 'bm'){
                    rootState.Lookup.TaxResidency_LK.push({
                        label:response.data.TaxResidency[i].NameBM,
                        value:response.data.TaxResidency[i].Value
                    });
                }else{
                    rootState.Lookup.TaxResidency_LK.push({
                        label:response.data.TaxResidency[i].Name,
                        value:response.data.TaxResidency[i].Value
                    });

                }
                
            }
            rootState.Lookup.UnavailableTINReason_LK = [];
            for(var i=0;i<response.data.TINReason.length;i++){
                if(rootState.Login.LanguageToLoad === 'bm'){
                    rootState.Lookup.UnavailableTINReason_LK.push({
                        label:response.data.TINReason[i].NameBM,
                        value:response.data.TINReason[i].Value
                    });
                }else{
                    rootState.Lookup.UnavailableTINReason_LK.push({
                        label:response.data.TINReason[i].Name,
                        value:response.data.TINReason[i].Value
                    });
                }
              
            }
            rootState.Lookup.USResident_LK = [];
            for(var i=0;i<response.data.USResidentStatus.length;i++){
                if(rootState.Login.LanguageToLoad === 'bm'){
                    rootState.Lookup.USResident_LK.push({
                        label:response.data.USResidentStatus[i].NameBM,
                        value:response.data.USResidentStatus[i].Value
                    });
                }else{
                    rootState.Lookup.USResident_LK.push({
                        label:response.data.USResidentStatus[i].Name,
                        value:response.data.USResidentStatus[i].Value
                    });
                }
                
            }
            rootState.Lookup.UsResidentIndicia_LK = [];
            for(var i=0;i<response.data.TypeOfUSIndicia.length;i++){
                if(rootState.Login.LanguageToLoad === 'bm'){
                    rootState.Lookup.UsResidentIndicia_LK.push({
                        label:response.data.TypeOfUSIndicia[i].NameBM,
                        value:response.data.TypeOfUSIndicia[i].Value
                    });
                }else{
                    rootState.Lookup.UsResidentIndicia_LK.push({
                        label:response.data.TypeOfUSIndicia[i].Name,
                        value:response.data.TypeOfUSIndicia[i].Value
                    });
                }
               // console.log(response.data.TypeOfUSIndicia[i])
             
            }

            rootState.Lookup.NatureofBusiness_LK = [];
                for(var i=0;i<response.data.NatureofBusiness.length ;i++){
                    if(rootState.Login.LanguageToLoad === 'bm'){
                        rootState.Lookup.NatureofBusiness_LK.push({
                            label:response.data.NatureofBusiness[i].Value + ' - ' + response.data.NatureofBusiness[i].NameBM,
                            value:response.data.NatureofBusiness[i].Value
                        });
                    }else{
                        rootState.Lookup.NatureofBusiness_LK.push({
                            label:response.data.NatureofBusiness[i].Value + ' - ' + response.data.NatureofBusiness[i].Name,
                            value:response.data.NatureofBusiness[i].Value
                        });
                    }
                  
                }

                rootState.Lookup.TypeOfUSIndicia_LK = [];
                for(var i=0;i<response.data.TypeOfUSIndicia.length ;i++){
                    rootState.Lookup.TypeOfUSIndicia_LK.push({
                        label:response.data.TypeOfUSIndicia[i].Name,
                        value:response.data.TypeOfUSIndicia[i].Value
                    });
                }
              //  console.log('here - > ' + response.data.PurposeOfInvestment.length)
                
                //console.log('here - > ' + response.data.PurposeOfInvestment)
                
               rootState.Lookup.InvestmentPurpose_LK = [];
                for(var i=0;i<response.data.PurposeOfInvestment.length ;i++){
                    if(rootState.Login.LanguageToLoad === 'bm'){
                        rootState.Lookup.InvestmentPurpose_LK.push({
                            label:response.data.PurposeOfInvestment[i].NameBM,
                            value:response.data.PurposeOfInvestment[i].Name
                        });
                    }else{
                        rootState.Lookup.InvestmentPurpose_LK.push({
                            label:response.data.PurposeOfInvestment[i].Name,
                            value:response.data.PurposeOfInvestment[i].Name
                        });
                    }
                  
                }
                 rootState.Lookup.SourceOfWealth_LK = [];
                for(var i=0;i<response.data.SourceIncome.length ;i++){
                    if(rootState.Login.LanguageToLoad === 'bm'){
                        rootState.Lookup.SourceOfWealth_LK.push({
                            label:response.data.SourceIncome[i].NameBM,
                            value:response.data.SourceIncome[i].Name
                        });
                    }else{
                        rootState.Lookup.SourceOfWealth_LK.push({
                            label:response.data.SourceIncome[i].Name,
                            value:response.data.SourceIncome[i].Name
                        });
                    }
                  
                }
                var PRSWithdrawalReasonAL = response.data.PRSWithdrawalReason.length;
                rootState.Lookup.Form.PRSWithdrawalReason = [];
                for(var i=0;i<PRSWithdrawalReasonAL ;i++){
                    if((response.data.PRSWithdrawalReason[i].Value ==='R001')||(response.data.PRSWithdrawalReason[i].Value ==='R003')||(response.data.PRSWithdrawalReason[i].Value ==='R004')){
                        //console.log(response.data.PRSWithdrawalReason[i].Value )
                        rootState.Lookup.Form.PRSWithdrawalReason.push({
                            label:response.data.PRSWithdrawalReason[i].Name + '-' + response.data.PRSWithdrawalReason[i].Value,
                            value:response.data.PRSWithdrawalReason[i].Value
                        });
                    }
                }
                
            //var IdTypeAL = response.data.IdType.length;
            rootState.Lookup.InternationalDialingCode_LK = [];
            
            //
            for(var i=0;i<response.data.InternationalDialingCode.length;i++){
                
                rootState.Lookup.InternationalDialingCode_LK.push({
                    label:response.data.InternationalDialingCode[i].Country,
                    //value:response.data.InternationalDialingCod[i].CountryCode,
                    value:response.data.InternationalDialingCode[i].DialingCode
                });
            }


            rootState.Lookup.IdType_LK = [];
                for(var i=0;i<response.data.IdType.length ;i++){
                    rootState.Lookup.IdType_LK.push({
                        label:response.data.IdType[i].Name,
                        value:response.data.IdType[i].Value
                    });
                }
                rootState.AOD.PersonalInformation.IdType = "NewIC"

            rootState.Lookup.MaritalStatus_LK = [];
            for(var i=0;i<response.data.MaritalStatus.length;i++){
                if(rootState.Login.LanguageToLoad === 'bm'){
                    rootState.Lookup.MaritalStatus_LK.push({
                        label:response.data.MaritalStatus[i].NameBM,
                        value:response.data.MaritalStatus[i].Value
                    });
                }else{
                    rootState.Lookup.MaritalStatus_LK.push({
                        label:response.data.MaritalStatus[i].Name,
                        value:response.data.MaritalStatus[i].Value
                    });
                }
               
            }
            
            return true
           
        })
        .catch(function (error) {
            var payload = "Method:  GetLookup -> " + error.toString()

            dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 
         //   console.log(error.response);
            return error.toString()
        });
    },

    async GeteMisLookup({ rootState,state,dispatch }) { //emis lookup
       
        return this.$httpClient({
            method: "get",
            url: apiconnectuat+'transaction/emis/lookup',
            //process.env.VUE_APP_TRANSACTIONTOKEN
            // headers: { Authorization: "Bearer " + state.TransactionAPIToken}
            //process.env.VUE_APP_TRANSACTIONTOKEN 
        })
        .then(function (response) {
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(response)
            })

            //alert(response)
            //console.log(response.data.PostCode)
            rootState.Lookup.EmisPostCode = [];
            if(response.data.PostCode != undefined){
                for(var i=0; i<response.data.PostCode.length;i++){
                    rootState.Lookup.EmisPostCode.push({
                        label :response.data.PostCode[i].PostCode,
                        value : response.data.PostCode[i].PostCode
                       /*  City: response.data.PostCode[i].City,
                        State: response.data.PostCode[i].State */
                    })
                }

                rootState.AOD.OnboardAddressPopulate = [];
                for(var i=0; i<response.data.PostCode.length;i++){
                    rootState.AOD.OnboardAddressPopulate.push({
                        PostCode: response.data.PostCode[i].PostCode,
                        City:response.data.PostCode[i].City,
                        State: response.data.PostCode[i].State
                    })
                }
            }
            
            rootState.Lookup.State_LK = [];
            if(response.data.State != undefined){
                for(var i=0;i<response.data.State.length;i++){
                //  alert(" - > " + response.data.State)
                    rootState.Lookup.State_LK.push({
                        label:response.data.State[i].Name,
                        value:response.data.State[i].Value,
                        EMISValue:response.data.State[i].EMISValue, 
                    });
                }
            }
            return true
        })
        .catch(function (error) {
            var payload = "Method:  GeteMisLookup -> " + error.toString()

            dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 
            ///console.log(error)
           // console.log(error.response);
            return error.toString()
        });
    },

      async GeteMisStatusCode({ rootState ,state, dispatch}) { //emis lookup

            return this.$httpClient({
                method: "get",
                url: apiconnectuat+'transaction/emis/lookup/',
                // headers: { Authorization: "Bearer " +  state.TransactionAPIToken}
                //process.env.VUE_APP_TRANSACTIONTOKEN
            })
            .then(function (response) {
                dispatch('Logging',{
                    typeid:'3',
                    appid:'2',
                    str:JSON.stringify(response)
                })

              //  console.log('GeteMisStatusCode')
               // console.log(response)
                for(var i=0;i<response.data.EMISStatusCode.length;i++){
                        
                        //console.log( "rootState.AD.TC_TransactionStatus --> "+ rootState.AD.TC_TransactionStatus)
                   if( response.data.EMISStatusCode[i].Value == rootState.AD.TC_TransactionStatus){
                    rootState.AD.FailReason = response.data.EMISStatusCode[i].Value
    
                    if(rootState.Login.LanguageToLoad == 'en'){
                        rootState.AD.FailReasonTitle = response.data.EMISStatusCode[i].EN
                    }else{    
                        rootState.AD.FailReasonTitle = response.data.EMISStatusCode[i].MS
                    }
                    
                    rootState.AD.FailReasonBody =  response.data.EMISStatusCode[i].Name
                }
                   // alert(" - > " + response.data.EMISStatusCode)
                    // rootState.Lookup.EMISStatusCode_LK.push({
                    //     label:response.data.EMISStatusCode[i].Name,
                    //     value:response.data.EMISStatusCode[i].Value
                    // });
                }
                  
                return true
            })
            .catch(function (error) {
                var payload = "Method:  GeteMisStatusCode -> " + error.toString()

                dispatch('GenEmail',{payload: payload}) 

                dispatch('Logging',{
                    typeid:'3',
                    appid:'2',
                    str:payload
                }) 
              //  console.log('GeteMisStatusCode')
              //  console.log(error)
               // console.log(error);
                return error.toString()
            });
    },



    async CheckInvestorStatus({commit, state, rootState,dispatch} ,Item){
       

        state.UserID = Item.UserID
        state.route = Item.route
        return this.$httpClient({
            method: "get",
            url: apiconnectuat+'cif/'+ state.UserID + '/enquiry/cifinformation',
            // headers: { Authorization: "Bearer " + CIFToken}
            //process.env.VUE_APP_CIF 
        }).then(function(response){
            if ((response.data.CustomerID != "") || (response.data.CustomerID == undefined)) {
               router.push({ path: '/LandingPage' })
               
            }
            /*else{
                if(state.route == 'buy'){
                    router.push({ path: '/emis/buy' })
                }else if (state.route == 'switch'){
                    
                    router.push({ path: '/emis/switch' })
                }else if(state.route == 'redeem'){
                    
                    router.push({ path: '/emis/redeem' })
                }
               // alert('need to reroute to login page')
            }*/
        }) .catch(function (error) {
           var payload = "Method:  CheckInvestorStatus -> " + error.toString()

           dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 
           // console.log(error);
        });
    },
    // NOTIFICATION API
    async RequestTAC({state, rootState,dispatch}, Obj) {

        //   CountryCode	 TelMobile
        //      60			 0175555060		#scenario1
        //      60			 175555060		#scenario2 correct cif table
        //  				 60175555060    #scenario3
        
        let CustomerMobile;
        
        // check CountryCode
        if (Obj.MobileNoCode) {

            if(Obj.MobileNoCode !== '') {

                let mobile = Obj.CustomerTelMobile
                let checkTelMobile = mobile.charAt(0)
    
                if (checkTelMobile === "0") {
                    // Scenario 1 - if TelMobile start with 0, need to remove the 0, and append countrycode
                    let mobile = Obj.CustomerTelMobile
                    let removeFirstCharMobile = mobile.substring(1)
                    CustomerMobile =  Obj.MobileNoCode + removeFirstCharMobile
                } else {
                    // Scenario 2 - else, concat countrycode + telmobile
                    CustomerMobile = Obj.MobileNoCode + Obj.CustomerTelMobile
    
                }
                
            } else {
                // Scenario 3 - else already in correct format, just take telmobile
                CustomerMobile = Obj.CustomerTelMobile
            }

        } else {
            // Scenario 4 - for onboard, skip countrycode checking as epf passed the correct format
            // take telmobile
            CustomerMobile = Obj.CustomerTelMobile
        }

        return this.$httpClient({
            method: "post",
            url: apipath_notification_requesttac,
            // headers: { Authorization: "Bearer " +  state.NotificationAPIToken},
            //process.env.VUE_APP_NOTIFICATIONTOKEN
            data : {
                    // "MobileNo": Obj.CustomerTelMobile,
                    "MobileNo": CustomerMobile,
                    "ValidityInMinute": 3,
                    "Purpose": Obj.Purpose,
                    "RequestorID": Obj.CustomerId,
                    "RequestorIDType": Obj.IdType
            }
        })
        .then(function (response) {

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(response)
            })

          //  console.log(response)
            if(response.data.isSuccessful === true){
                return true
            }else{
                return 'Unable to send send TAC .' + response.data.toString()
            }
        })
        .catch(function (error) {
             var payload = "Method:  RequestTAC -> " + error.toString()

             dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            })  
          //  console.log(error);
            return error.toString()
        });   
    },
    async TACVerification({state,rootState,dispatch}, Obj){

        return this.$httpClient({
            method: "post",
            url: apipath_notification_verifytac,
            // headers: { Authorization: "Bearer " + state.NotificationAPIToken  },
            //tokenkey_notification
            //process.env.VUE_APP_NOTIFICATIONTOKEN
            data : {
                "RequestorID": Obj.CustomerId,
                "TACNo": Obj.TAC,
                "Purpose": Obj.Purpose
            }
        })
        .then(function (response) {
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(response)
            })

            //console.log(response)
            if(response.data.Message==='tac valid'){
                return true
            }
            else{
                return response.data.Message.toUpperCase();
            }
        })
        .catch(function (error) {
            var payload = "Method:  TACVerification -> " + error.toString()

            dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 
        //    console.log(error)
            return false
        });
    },

     async GenEmail({state,rootState,dispatch}, Obj){

         var emailDetail = Obj.payload

         var today = new Date();
         var dd = String(today.getDate()).padStart(2, '0');
         var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
         var yyyy = today.getFullYear();
    
         var seconds = today.getSeconds()
         if(seconds < 10){
             seconds = '0'+seconds
         }
         var minutes =  today.getMinutes()
         if(minutes < 10){
            minutes = '0'+minutes
         }
         var hours =  today.getHours()
         if(hours < 10){
            hours = '0'+hours
         }

        var currentDateTime =  dd +'/'+mm+'/'+yyyy +'  ' + hours + ":" + minutes + ":" +  seconds;
         

        var body ='';
            body += '<h2>EMIS LOGGER - '+rootState.Login.incomingAppID+' - '+currentDateTime+' -- IS INTERNAL PURPOSE</h2>'
            body += '<p style="font-size: 1.5em;">Investor has encountered this in Transaction. Details as following:</p>'
            body += '<table style="width: 745px; border-collapse: collapse; border-style: solid; border-color: #000000; height: 58px;" border="1">'
            body += '<tbody>'
            body += '<tr>'
            body += '<td style="width: 184px;">&nbsp;TYPE</td>'
            body += '<td style="width: 262px;">&nbsp;Message</td>'
            body += '<td style="width: 289px;">Time Stamp</td>'
            body += ' </tr>'
            body += '<tr>'
            body += '<td style="width: 184px;">&nbsp;ERROR</td>'
            body += '<td style="width: 262px;"> '+emailDetail+' </td>'
            body += '<td style="width: 289px;">'+ currentDateTime+'</td>'
            body += '</tr>'
            body += '</tbody>'
            body += '</table>'

            this.$httpClient({
            method: "post",
            url: apiconnectuat+'notification',
            // headers: { Authorization: "Bearer " + tokenkey_notification  },
            //sex2qp7ssmvzpb27xghuxskn
            data : {
                "Application": "EMIS",
                "NotificationType": "email",
                    "email": {
                    "serviceId": "1",
                    "toAddress": "mohan.daramakoday@affinhwangam.com;weichin.ng@affinhwangam.com;hariz.farid@affinhwangam.com;akmal.abuhassan@affinhwangam.com;teikkheng.teoh@affinhwangam.com;leefern.ng@affinhwangam.com;kaijun.koh@affinhwangam.com",                        
                    "subject": "EMIS LOGGER - "+rootState.Login.incomingAppID+" - "+currentDateTime+" -- IS INTERNAL PURPOSE",
                    "body": body,
                    "attachments": []
                }
            }
        })
        .then(function(res){
            console.log(res)
        })
        .catch(function (error) {
            var payload = "Method:  GenEmail -> " + error.toString()
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 
            console.log(error.toString())
        }); 
    }, 

    async getTransaction({state,rootState,dispatch} ){
      
        //rootState.CD.FormDetails.ApplicationId = Obj.ApplicationId
        return this.$httpClient({
            method: "get",
            url: apiconnectuat + 'transaction/application/' + rootState.CD.FormDetails.ApplicationId ,
            // headers: { Authorization: "Bearer " + state.TransactionAPIToken}
            //tokenkey_transaction
            //process.env.VUE_APP_TRANSACTIONTOKEN 
        }).then(function (json) {
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(json)
            })

        //    console.log('getTransaction')
         //   console.log(json.data)
            if(json.data != undefined){
                if(json.data.ApplicationFormId != undefined){
                    rootState.Transactions.referenceid = json.data.ApplicationFormId
                    rootState.Transactions.Investment = []
                    rootState.Transactions.Redemption = []
                    rootState.Transactions.Switching = []
                    
                    if(json.data.TransactionCart.Switching != undefined){
                        for(var i=0; i<json.data.TransactionCart.Switching.length; i++){
                            if(rootState.Transactions.Switching.length>0){
                                if(rootState.Transactions.Switching.find(x => x.FromScheme===json.data.TransactionCart.Switching[i].FromScheme)!==undefined){
                                    var index = rootState.Transactions.Switching.findIndex(x=>x.FromScheme===json.data.TransactionCart.Switching[i].FromScheme)
                                    rootState.Transactions.Switching[index].Units = rootState.Transactions.Switching[index].Units + json.data.TransactionCart.Switching[i].Units
                                }else{
                                 rootState.Transactions.Switching.push({
                                     FromScheme:  json.data.TransactionCart.Switching[i].FromScheme,
                                     SchemeName:'',
                                     Units:  parseFloat(json.data.TransactionCart.Switching[i].Units.toFixed(2)),
                                     MinimumAccountBalance: 0,
                                     MinimumSwitchUnits:0,
                                     AvailableUnits:0,
                                     Balance:0
                                 })
                                }
                            }else{
                                rootState.Transactions.Switching.push({
                                    FromScheme:  json.data.TransactionCart.Switching[i].FromScheme,
                                    SchemeName:'',
                                    Units:  parseFloat(json.data.TransactionCart.Switching[i].Units.toFixed(2)),
                                    MinimumAccountBalance: 0,
                                    MinimumSwitchUnits:0,
                                    AvailableUnits:0,
                                    Balance:0
                                })
                            }
                        } 
                    }


                    if(json.data.TransactionCart.Redemption != undefined){
                        for(var i=0; i<json.data.TransactionCart.Redemption.length; i++){
                            if(rootState.Transactions.Redemption.length>0){
                                if(rootState.Transactions.Redemption.find(x => x.Scheme===json.data.TransactionCart.Redemption[i].Scheme)!==undefined){
                                    var index = rootState.Transactions.Redemption.findIndex(x=>x.Scheme===json.data.TransactionCart.Redemption[i].Scheme)
                                    rootState.Transactions.Redemption[index].Units = rootState.Transactions.Redemption[index].Units + json.data.TransactionCart.Redemption[i].Units
                                }else{
                                 rootState.Transactions.Redemption.push({
                                    Scheme:  json.data.TransactionCart.Redemption[i].Scheme,
                                     SchemeName:'',
                                     Units:  parseFloat(json.data.TransactionCart.Redemption[i].Units.toFixed(2)),
                                     MinimumAccountBalance: 0,
                                     MinimumRepurchaseUnits:0,
                                     AvailableUnits:0,
                                     Balance:0
                                 })
                                }
                            }else{
                                rootState.Transactions.Redemption.push({
                                    Scheme:  json.data.TransactionCart.Redemption[i].Scheme,
                                    SchemeName:'',
                                    Units:  parseFloat(json.data.TransactionCart.Redemption[i].Units.toFixed(2)),
                                    MinimumAccountBalance: 0,
                                    MinimumRepurchaseUnits:0,
                                    AvailableUnits:0,
                                    Balance:0
                                })
                            }
                        } 
                        
                    }

                    if(rootState.Transactions.Redemption.length>0){
                        for(var i=0; i<rootState.Lookup.Schemes_LK.length;i++){
                            for(var j =0; j<rootState.Transactions.Redemption.length; j++){
                                if(rootState.Lookup.Schemes_LK[i].Scheme === rootState.Transactions.Redemption[j].Scheme){
                                    rootState.Transactions.Redemption[j].SchemeName= rootState.Lookup.Schemes_LK[i].SchemeName
                                    rootState.Transactions.Redemption[j].MinimumAccountBalance = parseFloat(rootState.Lookup.Schemes_LK[i].minaccountbalance)
                                    rootState.Transactions.Redemption[j].MinimumRepurchaseUnits = parseFloat(rootState.Lookup.Schemes_LK[i].minredeemunits)
                                }
                            }
                        }

                        if(rootState.CD.NonEPFHoldings.length < 0 ){
                            for(var i=0; i<rootState.CD.Holdings.length; i++){
                                for(var j =0; j<rootState.Transactions.Redemption.length; j++){
                                    if(rootState.CD.Holdings[i].Scheme === rootState.Transactions.Redemption[j].Scheme){
                                        
                                        var unit = parseFloat(rootState.CD.Holdings[i].BalanceUnit)
                                            //.replace(",","").replace(",",""));
                                        rootState.Transactions.Redemption[j].AvailableUnits = unit.toFixed(2)
                                        //rootState.CD.Holdings[i].BalanceUnit     
                                     }
                                }
                            }
                        }else{
                            for(var i=0; i<rootState.CD.Holdings.length; i++){
                                for(var j =0; j<rootState.Transactions.Redemption.length; j++){
                                    if(rootState.CD.Holdings[i].Scheme === rootState.Transactions.Redemption[j].Scheme){
                                        var unit = parseFloat(rootState.CD.Holdings[i].BalanceUnit)
                                            //.replace(",","").replace(",",""));
                                        rootState.Transactions.Redemption[j].AvailableUnits = unit.toFixed(2)
                                        //rootState.CD.Holdings[i].BalanceUnit     
                                     }
                                }
                            }


                            for(var i=0; i<rootState.CD.NonEPFHoldings.length; i++){
                                for(var j =0; j<rootState.Transactions.Redemption.length; j++){
                                    if(rootState.CD.NonEPFHoldings[i].Scheme === rootState.Transactions.Redemption[j].FromScheme){
                                        var unit = parseFloat(rootState.CD.NonEPFHoldings[i].BalanceUnit)
                                            //.replace(",","").replace(",",""));
                                   
                                        //    console.log( parseFloat(rootState.CD.Holdings[i].BalanceUnit))
                                        rootState.Transactions.Redemption[j].AvailableUnits = unit.toFixed(2)
                                        //rootState.CD.Holdings[i].BalanceUnit     
                                     }
                                }
                            }
                        }

                    }



                    if(rootState.Transactions.Switching.length>0){
                        for(var i=0; i<rootState.Lookup.Schemes_LK.length;i++){
                            for(var j =0; j<rootState.Transactions.Switching.length; j++){
                                if(rootState.Lookup.Schemes_LK[i].Scheme === rootState.Transactions.Switching[j].FromScheme){
                                    rootState.Transactions.Switching[j].SchemeName= rootState.Lookup.Schemes_LK[i].SchemeName
                                    rootState.Transactions.Switching[j].MinimumAccountBalance = parseFloat(rootState.Lookup.Schemes_LK[i].minaccountbalance)
                                    rootState.Transactions.Switching[j].MinimumSwitchUnits = parseFloat(rootState.Lookup.Schemes_LK[i].minswitchunits)
                                }
                            }
                        }


                        if(rootState.CD.NonEPFHoldings.length < 0 ){
                            for(var i=0; i<rootState.CD.Holdings.length; i++){
                                for(var j =0; j<rootState.Transactions.Switching.length; j++){
                                    if(rootState.CD.Holdings[i].Scheme === rootState.Transactions.Switching[j].FromScheme){
                                        
                                        var unit = parseFloat(rootState.CD.Holdings[i].BalanceUnit)
                                            //.replace(",","").replace(",",""));
                                        rootState.Transactions.Switching[j].AvailableUnits = unit.toFixed(2)
                                        //rootState.CD.Holdings[i].BalanceUnit     
                                     }
                                }
                            }
                        }else{
                            for(var i=0; i<rootState.CD.Holdings.length; i++){
                                for(var j =0; j<rootState.Transactions.Switching.length; j++){
                                    if(rootState.CD.Holdings[i].Scheme === rootState.Transactions.Switching[j].FromScheme){
                                        var unit = parseFloat(rootState.CD.Holdings[i].BalanceUnit)
                                            //.replace(",","").replace(",",""));
                                        rootState.Transactions.Switching[j].AvailableUnits = unit.toFixed(2)
                                        //rootState.CD.Holdings[i].BalanceUnit     
                                     }
                                }
                            }


                            for(var i=0; i<rootState.CD.NonEPFHoldings.length; i++){
                                for(var j =0; j<rootState.Transactions.Switching.length; j++){
                                    if(rootState.CD.NonEPFHoldings[i].Scheme === rootState.Transactions.Switching[j].FromScheme){
                                        var unit = parseFloat(rootState.CD.NonEPFHoldings[i].BalanceUnit)
                                            //.replace(",","").replace(",",""));
                                   
                                          //  console.log( parseFloat(rootState.CD.Holdings[i].BalanceUnit))
                                        rootState.Transactions.Switching[j].AvailableUnits = unit.toFixed(2)
                                        //rootState.CD.Holdings[i].BalanceUnit     
                                     }
                                }
                            }
                        }
                        

                    }

                }
            }
            return true
        }).catch(function (error) {
           var payload = "Method:  getTransaction -> " + error.toString()

           dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 
         //   console.log('getTransaction')
            return 'Error.Unable to read response from Transaction Cart Response'
         });  
    },

    // TRANSACTION API
    async PostTransaction({rootState, state,dispatch}, Obj) {

     
        var TempInvest = [];
        var selectedAgent = ""
        for(var i=0; i<rootState.CD.Transaction.Investment.length;i++){
         /*    console.log('investment')
            console.log(rootState.Transactions.AgentDetails) */
                //if(TempInvest.length > 0){
                   /*  if(rootState.Transactions.AgentDetails !=""){
                        selectedAgent = rootState.Transactions.AgentDetails
                    }else{
                        selectedAgent =  ""
                    } 
                    console.log('rootState.Transactions.SelectedAgent', rootState.Transactions.SelectedAgent)*/
                    console.log('rootState.Transactions.AgentDetails_onboard',rootState.Transactions.AgentDetails_onboard)
                    console.log('rootState.Transactions.AgentDetails ',rootState.Transactions.AgentDetails )
                    if(rootState.Transactions.showAgent){
                        if(rootState.Transactions.SelectedAgent!=''){
                       
                            selectedAgent = ""
                            //rootState.Transactions.SelectedAgent.value
                        }else{
                            if(rootState.Transactions.AgentDetails_onboard !=''){
                                if(rootState.Transactions.AgentDetails !=''){
                                   
                                    selectedAgent = ""
                                    //rootState.Transactions.AgentDetails
                                }else{
                                    
                                    selectedAgent = rootState.Transactions.AgentDetails_onboard 
                                }
                            }else{
                                
                                if(rootState.Transactions.AgentDetails !=''){
                                    selectedAgent = rootState.Transactions.AgentDetails
                                }else{
                                    selectedAgent = ""
                                }                    
                            }
                        } 
                    }else{
                        if(rootState.Transactions.AgentDetails_onboard !=''){
                            if(rootState.Transactions.AgentDetails !=''){
                                selectedAgent =""
                                // rootState.Transactions.AgentDetails
                            }else{
                                selectedAgent = rootState.Transactions.AgentDetails_onboard 
                            }
                        }else{
                            if(rootState.Transactions.AgentDetails !=''){
                                selectedAgent = ""
                                //rootState.Transactions.AgentDetails
                            }else{
                                selectedAgent = ""
                            }                    
                        }
                    }
                   



                    
               /*  }else{
                    selectedAgent = ""
                } */

            rootState.CD.Transaction.Investment[i].Amount=parseFloat((rootState.CD.Transaction.Investment[i].Amount.toString()).replace(",",""))
            TempInvest.push({
                TypeOfProduct: "UTF",
                //rootState.CD.Transaction.Investment[i].TypeOfProduct,
                Amount: rootState.CD.Transaction.Investment[i].Amount,
                Plan: rootState.CD.Transaction.Investment[i].Plan,
                Scheme: rootState.CD.Transaction.Investment[i].FundID,
                SalesCharge: rootState.CD.Transaction.Investment[i].SalesCharge,
                Id: rootState.CD.Transaction.Investment[i].Id,
                SchemeCurrency: rootState.CD.Transaction.Investment[i].FundCurrency
            })
           // console.log(selectedAgent)
        }

        var TempRedeem = [];
        for(var i=0; i<rootState.CD.Transaction.Redemption.length;i++){
      
            if(rootState.Transactions.AgentDetails !=""){
                //'-1000'
                selectedAgent = ""
                //rootState.Transactions.AgentDetails
            }else{
                selectedAgent =  ""
            }
            rootState.CD.Transaction.Redemption[i].Units=parseFloat((rootState.CD.Transaction.Redemption[i].Units.toString()).replace(",",""))
            TempRedeem.push({
                AmountOrUnit: rootState.CD.Transaction.Redemption[i].AmountOrUnit,
                TypeOfProduct: "UTF", 
                //rootState.CD.Transaction.Redemption[i].TypeOfProduct,
                Scheme: rootState.CD.Transaction.Redemption[i].FundID,
                Amount:rootState.CD.Transaction.Redemption[i].Amount ,
                PaymentInstruction: rootState.CD.Transaction.Redemption[i].PaymentInstruction,
                Id: rootState.CD.Transaction.Redemption[i].Id,
                Plan: rootState.CD.Transaction.Redemption[i].Plan,
                Units: rootState.CD.Transaction.Redemption[i].Units,
                SchemeCurrency: rootState.CD.Transaction.Redemption[i].FundCurrency,
                RedeemAll : rootState.CD.Transaction.Redemption[i].RedeemAll,
                WithdrawalReason : rootState.CD.Transaction.Redemption[i].PRSWithdrawalReason,
                BankAccountNumber : rootState.CD.Transaction.Redemption[i].BankAccountNumber,
               // BalanceUnits : rootState.CD.Transaction.Redemption[i].BalanceUnits,
            })
        }

        var TempSwitch = [];
        for(var i=0; i<rootState.CD.Transaction.Switching.length;i++){
            if(rootState.Transactions.AgentDetails !=""){
                //'-1000'
                selectedAgent = ""
                //rootState.Transactions.AgentDetails
            }else{
                selectedAgent =  ""
            }

             rootState.CD.Transaction.Switching[i].Units=parseFloat((rootState.CD.Transaction.Switching[i].Units.toString()).replace(",",""))
            
            TempSwitch.push({
                FromScheme: rootState.CD.Transaction.Switching[i].FromFundID,
                Percentage: parseFloat(rootState.CD.Transaction.Switching[i].Percentage),
                ToScheme: rootState.CD.Transaction.Switching[i].ToFundID,
                TypeOfProduct: "UTF",
               // TypeOfProduct: rootState.CD.Transaction.Switching[i].TypeOfProduct,
                SalesCharge: rootState.CD.Transaction.Switching[i].SalesCharge,
                Id: rootState.CD.Transaction.Switching[i].Id,
                UnitsOrPercentage: rootState.CD.Transaction.Switching[i].UnitsOrPercentage,
                Plan: rootState.CD.Transaction.Switching[i].Plan,
                Units: parseFloat(rootState.CD.Transaction.Switching[i].Units),
                FromSchemeCurrency: rootState.CD.Transaction.Switching[i].FundCurrency,
                ToSchemeCurrency: rootState.CD.Transaction.Switching[i].FundCurrency,
            })
        }

        var isSophisticatedInvestorTemp= false
        if(rootState.AOD.OnboardisSophisticatedInvestor !=''){
            isSophisticatedInvestorTemp = rootState.AOD.OnboardisSophisticatedInvestor 
        }else{
            isSophisticatedInvestorTemp = rootState.Transactions.IsQualifiedInvestor
        }
        /* if((rootState.CD.Account.AccountId =='')||(rootState.CD.Account.AccountId ==undefined)||(rootState.CD.Account.AccountId =='undefined')){
            rootState.CD.Account.AccountId = '0013607'
        } */

        return this.$httpClient({
            method: "post",
            url: apipath_transaction_selfdraft + '/' + Obj.ApplicationId + '/draft',
            // headers: { Authorization: "Bearer " + state.TransactionAPIToken },
            //tokenkey_transaction
            //process.env.VUE_APP_TRANSACTIONTOKEN
            data : {

               //rootState.Transactions.ApplicationFormId
                "_id": Obj.ApplicationId,
                "Channel": "EMIS",
                "AccountId": rootState.CD.Account.AccountId,
                "AccountType": "UTF",
                "CustomerID": rootState.CD.CustomerDetails.CustomerId,
                "isSophisticatedInvestor": isSophisticatedInvestorTemp,
                "EPFNo": rootState.CD.CustomerDetails.EPFNo,
                "AgentCode": selectedAgent,                
                "UserId":rootState.AD.Creation_uuid, 
                "EmisReferenceNo" : rootState.Transactions.ApplicationFormId,
                "TransactionCart": {
                    "InvestmentSelf": TempInvest,
                    "SwitchingSelf":TempSwitch ,
                    "RedemptionSelf": TempRedeem
                }
            }
        })
        .then(function (response) {
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(response)
            })

           /// console.log('PostTransaction')
           // console.log(response.data)
            if((response.data.StatusCode === "200")||(response.data.StatusCode === 200)){
                if((rootState.Transactions.referenceid=='')||(rootState.Transactions.referenceid== undefined)){
                    var textArray = response.data.ApplicationId.split('-')
                    rootState.Transactions.referenceid = textArray.slice(4).join('-').trim()
                }
                rootState.CD.FormDetails.ApplicationId = response.data.ApplicationId
                return true
            }
            else{
                response.data.Message
            }
        })
        .catch(function (error) {
            var payload = "Method:  PostTransaction -> " + error.toString()

            dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 
          //  console.log('PostTransaction')
          //  console.log(error);
            return error.toString()
        });   
    },

    async Logging({state, rootState,dispatch},Obj){
        var typeid  = Obj.typeid
        var appid  = Obj.appid
        var str = Obj.str

        return true // Force OK return due to logger disablement

        // Disabled logging until further notice
        // return this.$httpClient({
        //     method: "post",
        //     url: apiconnectuat + 'logger/apploginternal' ,
        //     // headers: { Authorization: "Bearer " + tokenkey_logger },
        //     //process.env.VUE_APP_LOGGER
        //     data : {
        //         "request_typeid": typeid,
        //         "request_appid": appid,
        //         "request_payload": str
        //      }
        // })
        // .then(function (response) {
            
        //   //  console.log('Loggging API -> '+ response)
        //   //  console.log(url)
        //     /* console.log(response.data.StatusCode)

        //     if(response.data.StatusCode == "200"){
        //        // rootState.CD.FormDetails.ApplicationId = response.data.ApplicationId
        //         return true
        //     }
        //     else{

        //         return response.data.Message
        //     } */
        // })
        // .catch(function (error){
        //  //   console.log(error);
        //     return false
        // });

    },
    // Fund API
    async  GetListOfFund({state,rootState,dispatch}, Obj){   
       
        var IslamicConventional ='';
        if(rootState.AOD.PersonalInformation.EPFAccount === "Islamic"){
            IslamicConventional = 'Islamic'
        }else{
            IslamicConventional = 'Conventional'
        }
        return this.$httpClient({
            method: "get",
            url: apipath_fund,
            // headers: { Authorization: "Bearer " + state.FundAPIToken}
            //tokenkey_fund
            // process.env.VUE_APP_FUND
        })
        .then(function (response) {
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(response)
            })

            //console.log(response)
            rootState.Lookup.Schemes_LK = [];
            rootState.Lookup.Schemes_LK_2=[];
            //console.log(response.data.Schemes)
          //  console.log('IslamicConventional ->' + IslamicConventional)
           // console.log('before - > ' + response.data.Schemes.length)
            for(var i=0;i<response.data.Schemes.length;i++){
                var minredeem =0;
                var minswitch = 0;
                var minadd = 0;

                if((response.data.Schemes[i].MinimumInitialInvestment!= 'undefined')||(response.data.Schemes[i].MinimumInitialInvestment!= undefined)){
                    minadd = response.data.Schemes[i].MinimumInitialInvestment
                }else{
                    minadd = 0
                }

                if((response.data.Schemes[i].MinimumSwitchUnits!= 'undefined')||(response.data.Schemes[i].MinimumSwitchUnits!= undefined)){
                    minswitch = response.data.Schemes[i].MinimumSwitchUnits
                }else{
                    minswitch = 0
                }

                if((response.data.Schemes[i].MinimumRepurchaseUnits!= 'undefined')||(response.data.Schemes[i].MinimumRepurchaseUnits!= undefined)){
                    minredeem = response.data.Schemes[i].MinimumRepurchaseUnits
                }else{
                    minredeem = 0
                }
                rootState.Lookup.Schemes_LK_2.push({ 
                    label:response.data.Schemes[i].SchemeName,
                    value:response.data.Schemes[i].Scheme,
                    Scheme:response.data.Schemes[i].Scheme,
                    SchemeName:response.data.Schemes[i].SchemeName,
                    currency:response.data.Schemes[i].Currency,
                    minintamount:minadd,
                    minaddamount:response.data.Schemes[i].MinimumAdditionalInvestment,
                    minswitchunits:minswitch,
                    minredeemunits : minredeem,
                    PRSAgeLowerBound:response.data.Schemes[i].PRSAgeLowerBound,
                    minaccountbalance: response.data.Schemes[i].MinimumAccountBalance,
                    PRSAgeUpperBound:response.data.Schemes[i].PRSAgeUpperBound,
                    FeeCharges:response.data.Schemes[i].FeeCharges,
                    producttype:response.data.Schemes[i].ProductType,
                    ProductAssetClass : response.data.Schemes[i].ProductAssetClass,
                    RiskProfile : response.data.Schemes[i].RiskProfile,
                    FundStructure: response.data.Schemes[i].FundStructure,
                    EPFStatus : response.data.Schemes[i].EPFStatus,
                    RequestCutoffTime: response.data.Schemes[i].RequestCutoffTime,
                    IslamicConventional:response.data.Schemes[i].IslamicConventional,
                    ProductManagerMaster: response.data.Schemes[i].ProductManagerMaster,
                }); 

            }
                for(var i=0;i<response.data.Schemes.length;i++){                   
                    if(IslamicConventional === 'Islamic'){
                        if(response.data.Schemes[i].IslamicConventional==IslamicConventional){
                            if((response.data.Schemes[i].EPFStatus=="Approved")&&((response.data.Schemes[i].Currency=="MYR")||(response.data.Schemes[i].Currency=="RM"))){
                                var minredeem =0;
                                var minswitch = 0;
                                var minadd = 0;
        
                                if((response.data.Schemes[i].MinimumInitialInvestment!= 'undefined')||(response.data.Schemes[i].MinimumInitialInvestment!= undefined)){
                                    minadd = response.data.Schemes[i].MinimumInitialInvestment
                                }else{
                                    minadd = 0
                                }
        
                                if((response.data.Schemes[i].MinimumSwitchUnits!= 'undefined')||(response.data.Schemes[i].MinimumSwitchUnits!= undefined)){
                                    minswitch = response.data.Schemes[i].MinimumSwitchUnits
                                }else{
                                    minswitch = 0
                                }
        
                                if((response.data.Schemes[i].MinimumRepurchaseUnits!= 'undefined')||(response.data.Schemes[i].MinimumRepurchaseUnits!= undefined)){
                                    minredeem = response.data.Schemes[i].MinimumRepurchaseUnits
                                }else{
                                    minredeem = 0
                                }
                           
                                rootState.Lookup.Schemes_LK.push({ 
                                    label:response.data.Schemes[i].SchemeName,
                                    value:response.data.Schemes[i].Scheme,
                                    Scheme:response.data.Schemes[i].Scheme,
                                    SchemeName:response.data.Schemes[i].SchemeName,
                                    currency:response.data.Schemes[i].Currency,
                                    minintamount:minadd,
                                    minaddamount:response.data.Schemes[i].MinimumAdditionalInvestment,
                                    minswitchunits:minswitch,
                                    minredeemunits : minredeem,
                                    PRSAgeLowerBound:response.data.Schemes[i].PRSAgeLowerBound,
                                    minaccountbalance: response.data.Schemes[i].MinimumAccountBalance,
                                    PRSAgeUpperBound:response.data.Schemes[i].PRSAgeUpperBound,
                                    FeeCharges:response.data.Schemes[i].FeeCharges,
                                    producttype:response.data.Schemes[i].ProductType,
                                    ProductAssetClass : response.data.Schemes[i].ProductAssetClass,
                                    RiskProfile : response.data.Schemes[i].RiskProfile,
                                    FundStructure: response.data.Schemes[i].FundStructure,
                                    EPFStatus : response.data.Schemes[i].EPFStatus,
                                    RequestCutoffTime: response.data.Schemes[i].RequestCutoffTime,
                                    IslamicConventional:response.data.Schemes[i].IslamicConventional,
                                    ProductManagerMaster: response.data.Schemes[i].ProductManagerMaster,
                                }); 
                            }
                        }
                    }else{
                        if((response.data.Schemes[i].EPFStatus=="Approved")&&((response.data.Schemes[i].Currency=="MYR")||(response.data.Schemes[i].Currency=="RM"))){
                            var minredeem =0;
                            var minswitch = 0;
                            var minadd = 0;
    
                            if((response.data.Schemes[i].MinimumInitialInvestment!= 'undefined')||(response.data.Schemes[i].MinimumInitialInvestment!= undefined)){
                                minadd = response.data.Schemes[i].MinimumInitialInvestment
                            }else{
                                minadd = 0
                            }
    
                            if((response.data.Schemes[i].MinimumSwitchUnits!= 'undefined')||(response.data.Schemes[i].MinimumSwitchUnits!= undefined)){
                                minswitch = response.data.Schemes[i].MinimumSwitchUnits
                            }else{
                                minswitch = 0
                            }
    
                            if((response.data.Schemes[i].MinimumRepurchaseUnits!= 'undefined')||(response.data.Schemes[i].MinimumRepurchaseUnits!= undefined)){
                                minredeem = response.data.Schemes[i].MinimumRepurchaseUnits
                            }else{
                                minredeem = 0
                            }
                        
                            rootState.Lookup.Schemes_LK.push({ 
                                label:response.data.Schemes[i].SchemeName,
                                value:response.data.Schemes[i].Scheme,
                                Scheme:response.data.Schemes[i].Scheme,
                                SchemeName:response.data.Schemes[i].SchemeName,
                                currency:response.data.Schemes[i].Currency,
                                minintamount:minadd,
                                minaddamount:response.data.Schemes[i].MinimumAdditionalInvestment,
                                minswitchunits:minswitch,
                                minredeemunits : minredeem,
                                PRSAgeLowerBound:response.data.Schemes[i].PRSAgeLowerBound,
                                minaccountbalance: response.data.Schemes[i].MinimumAccountBalance,
                                PRSAgeUpperBound:response.data.Schemes[i].PRSAgeUpperBound,
                                FeeCharges:response.data.Schemes[i].FeeCharges,
                                producttype:response.data.Schemes[i].ProductType,
                                ProductAssetClass : response.data.Schemes[i].ProductAssetClass,
                                RiskProfile : response.data.Schemes[i].RiskProfile,
                                FundStructure: response.data.Schemes[i].FundStructure,
                                EPFStatus : response.data.Schemes[i].EPFStatus,
                                RequestCutoffTime: response.data.Schemes[i].RequestCutoffTime,
                                IslamicConventional:response.data.Schemes[i].IslamicConventional,
                                ProductManagerMaster: response.data.Schemes[i].ProductManagerMaster,
                            }); 
                        }
                    }
                    
                    
                   // &&(response.data.Schemes[i].IslamicConventional==IslamicConventional)

                   /*  rootState.Lookup.Schemes_LK=rootState.Lookup.Schemes_LK.filter(v=> {
                        let IslamicConventional=v.IslamicConventional
                        return IslamicConventional === 'Wholesale' || IslamicConventional === 'Retail'
                    }) */
                 
                   
            //console.log('after - > ' + rootState.Lookup.Schemes_LK.length)
            }
            if(IslamicConventional === 'Islamic'){
                rootState.Lookup.Schemes_LK=rootState.Lookup.Schemes_LK.filter(v=> {
                    let IslamicConventional=v.IslamicConventional
                    return IslamicConventional === 'Islamic' 
                })
            }else{
                rootState.Lookup.Schemes_LK=rootState.Lookup.Schemes_LK.filter(v=> {
                    let IslamicConventional=v.IslamicConventional
                    return IslamicConventional === 'Conventional'  || IslamicConventional === 'Islamic' 
                }) 
            }
           /*  for(var i=0; i<rootState.Lookup.Schemes_LK.length; i++){

                console.log(rootState.Lookup.Schemes_LK[i].SchemeName)
            } */
            return true
        })
        .catch(function (error){
            var payload = "Method:  GetListOfFund -> " + error.toString()

            dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 

           // console.log(error.response);
            return 'error'
        });
    },

    async PostTransaction_Submit_RedeemSwitch({ state, rootState ,dispatch}, Obj){
        
        return this.$httpClient({
            method: "post",
            url: apipath_transaction_selfprocess + '/' + rootState.CD.FormDetails.ApplicationId + '/submit',
            // headers: { Authorization: "Bearer " +  state.TransactionAPIToken},
            //tokenkey_transaction
            //process.env.VUE_APP_TRANSACTIONTOKEN
            data : {
                "UpdatedBy":rootState.AOD.OnBoardUTAccountNo,
             }
        })
        .then(function (response) {
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(response)
            })

          // console.log('PostTransaction_Submit_RedeemSwitch')
           
          // console.log(response)
            if(response.data.StatusCode == "200"){
               // rootState.CD.FormDetails.ApplicationId = response.data.ApplicationId
                return true
            }
            else{

                return response.data.Message
            }
        })
        .catch(function (error){
           var payload = "Method:  PostTransaction_Submit_RedeemSwitch -> " + error.toString()

           dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            })  
            

         //   console.log('PostTransaction_Submit_RedeemSwitch')
            
         //   console.log(error)
            return error.toString()
        });
    },

    async PostTransaction_Submit({ state, rootState ,dispatch}, Obj){
       

        
        return this.$httpClient({
            method: "post",
            url: apipath_transaction_selfprocess + '/' + rootState.CD.FormDetails.ApplicationId + '/submit',
            // headers: { Authorization: "Bearer " + state.TransactionAPIToken },
            //tokenkey_transaction
            //process.env.VUE_APP_TRANSACTIONTOKEN
            data : {
                "UpdatedBy":rootState.AOD.OnBoardUTAccountNo,
            }
        })
        .then(function (response) {
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(response)
            })

        //  console.log(url)
            if(response.data.StatusCode == "200"){
            // rootState.CD.FormDetails.ApplicationId = response.data.ApplicationId
                return true
            }
            else{

                return response.data.Message
            }
        })
        .catch(function (error){
           var payload = "Method:  PostTransaction_Submit -> " + error.toString()

           dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 

        //  console.log(error);
            return error.toString()
        });
    },

    async PostTransaction_Delete({ state, rootState,dispatch }, Obj){
      

        return this.$httpClient({
            method: "post",
            url: apipath_transaction_selfprocess + '/' + rootState.CD.FormDetails.ApplicationId + '/delete',
            // headers: { Authorization: "Bearer " +  tokenkey_transaction},
            //process.env.VUE_APP_TRANSACTIONTOKEN
            data : {
                "DeleteBy":rootState.AOD.OnBoardUTAccountNo,
             }
        })
        .then(function (response) {
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(response)
            })

          //  console.log(url)
           // console.log(response.data.StatusCode)

            if(response.data.StatusCode == "200"){
               // rootState.CD.FormDetails.ApplicationId = response.data.ApplicationId
                return true
            }
            else{
                return response.data.Message
            }
        })
        .catch(function (error){

            var payload = "Method:  PostTransaction_Delete -> " + error.toString()

            dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 
          //  console.log(error);
            return error.toString()
        });
    },
    async loadAgentData({state,rootState,dispatch}){
      

        return this.$httpClient({
            method: "get",
            url: apiconnectuat + 'agents?status=A&registrationtype=UTS&excludechannelgroup=IUTA', 
            // headers: { Authorization: "Bearer " + state.AgentAPIToken }
            //process.env.VUE_APP_AGENTAPI
        }).then(function (json) {
            //console.log(json)
        rootState.Lookup.Agents_LK = [];
        rootState.Lookup.Agents_LK2 = [];
        
        if(json.data.Agents.length>0){
            for(var i=0; i< json.data.Agents.length; i++){
                rootState.Lookup.Agents_LK.push({
                    value: json.data.Agents[i].Id,
                    label: json.data.Agents[i].Name + " ("+ json.data.Agents[i].Id+ ")"
                })
    
                 rootState.Lookup.Agents_LK2.push({
                    value: json.data.Agents[i].Id,
                    label: json.data.Agents[i].Name + " ("+ json.data.Agents[i].Id+ ")"
                })
            }
            return true
        }else{
           return -1
        }
        }).catch(function (error) {
           var payload = "Method:  loadAgentData -> " + error.toString()

           dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 
           // console.log(error);
            return error.toString()
        });
    },

    async TransactRedeemProcess({state,rootState,dispatch}){
       
        var TempRedeem = [];
        var TempSwitch=[];
        for(var i=0; i<rootState.CD.Transaction.Redemption.length;i++){
            TempRedeem.push({
                TranID: rootState.CD.Transaction.Redemption[i].Id
            })
        }
        for(var i=0; i<rootState.CD.Transaction.Switching.length;i++){
            TempSwitch.push({
                TranID: rootState.CD.Transaction.Switching[i].Id
            })
        }
         return this.$httpClient({
            method: "post",
            url: apipath_transaction_selfprocess + '/' + rootState.CD.FormDetails.ApplicationId + '/process',
            // headers: { Authorization: "Bearer " +  tokenkey_transaction},
            //process.env.VUE_APP_TRANSACTIONTOKEN
            data : {
                "ByUser":rootState.CD.CustomerDetails.CustomerId,
                "TransactionCart": {
                    "Redemption": TempRedeem,
                    "Switching": TempSwitch
                  }
            }
        }).then(function (response) {
            
           
            /* var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = today.getFullYear();
       
        var d = new Date();
            var currentTime = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
       
           var currentDateTime =yyyy  + '-' + mm + '-' + dd + ' ' + currentTime;

           rootState.Transactions.TransactionDateTime = currentDateTime */


           dayjs.extend(timeZone)
                         
           var tempd2 =dayjs().format('YYYY-MM-DD',{ timeZone: 'Asia/Kuala_Lumpur' })
           
           var tempd2_1 =dayjs().format('HH:mm:ss',{ timeZone: 'Asia/Kuala_Lumpur' })
           
           var currentDateTime = tempd2 + ' '+ tempd2_1
           rootState.Transactions.TransactionDateTime = currentDateTime;

            if(response.data.StatusCode === '200'){
                rootState.CD.FormDetails.ApplicationId = response.data.ApplicationId
                rootState.AD.FailReason = response.data.Message
                return true
            }
            else{
                rootState.AD.FailReason = response.data.Message
                return false
            }
        })
        .catch(function (error) {
            var payload = "Method:  TransactRedeemProcess -> " + error.toString()

            dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            })
 
            rootState.AD.FailReason = "Something went wrong! Please refresh the page and re-try."
            return false
        });  
    },

    async getTranactionApplicationEmis({state,rootState,dispatch}){
        

        return this.$httpClient({
            method: "get",
            url: apipath_transaction_selfprocess + '/' + rootState.CD.FormDetails.ApplicationId ,
            // headers: { Authorization: "Bearer " +  state.TransactionAPIToken}
            //tokenkey_transaction
            //process.env.VUE_APP_TRANSACTIONTOKEN
        }).then(function (json) {
            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:JSON.stringify(json)
            })

           // if(json.data._id != undefined){
                rootState.Transactions.TransactionApplicationID = json.data._id

                if(json.data.TransactionCart.Redemption != undefined){
                    if(json.data.TransactionCart.Redemption.length>0){
                        rootState.CD.Transaction.Redemption = [];
                        for(var i= 0; i<json.data.TransactionCart.Redemption.length; i++){
                            rootState.CD.Transaction.Redemption.push({
                                Id : json.data.TransactionCart.Redemption[i].Id,
    
                            })
                        }
                    }
                }
               
                if(json.data.TransactionCart.Switching != undefined){
                    if(json.data.TransactionCart.Switching.length>0){
                        rootState.CD.Transaction.Switching = [];
                        for(var i= 0; i<json.data.TransactionCart.Switching.length; i++){
                            rootState.CD.Transaction.Switching.push({
                                Id : json.data.TransactionCart.Switching[i].Id,
    
                            })
                        }
                    }
                }
                
           // }
            return true;

        }).catch(function (error) {
            var payload = "Method:  getTranactionApplicationEmis -> " + error.toString()

            dispatch('GenEmail',{payload: payload}) 

            dispatch('Logging',{
                typeid:'3',
                appid:'2',
                str:payload
            }) 

             return error.toString()
             //'Error. Unable to read response from Transaction Application API'
         });  
    },

    //ONLINE REDEMPTION

    async sendAckEmail({ rootState },Obj) {
 
        return this.$httpClient({
            method: "post",
            url: apiconnectuat+'notification',
            // headers: { Authorization: "Bearer v3s9uunyx8pbgptgc33vwrc7" },
            data : { 
                "CustomerID": rootState.Transactions.OnlineTransactionUserID,
                "Application": rootState.CD.FormDetails.ApplicationFormId,
                "NotificationType": "emailtemplate",
                "ContentTemplate": {
                    "AppID": "iAccess",
                    "Code": "ONLINE_REDEMPTION_ACK_RECEIPT"
                },
                "ContentVariables": [
                    {
                      "Keyword": "<v_InvestorName>",
                      "Value": rootState.Transactions.OnlineTransactionInvestor
                    },
                    {
                      "Keyword": "<v_RefNo>",
                      "Value": rootState.CD.FormDetails.ApplicationFormId
                    },
                    {
                      "Keyword": "<v_TrxDateTime>",
                      "Value": Obj.trxDateTime
                    }
                  ],
                "email": {
                    "serviceId": "1",
                    "toAddress": rootState.Transactions.OnlineTransactionEmail,
                    "subject": "anything",
                    "body": "anything",
                    "attachments": [ {
                        "fileName": "online_redemption_"+rootState.CD.FormDetails.ApplicationFormId+".pdf",
                        "content": Obj.base64String,
                        "content-type": "application/*"
                    }]
                  }
            }
        })
        .then(function (response) {
        //    console.log(response)
            response.toString()
           
        })
        .catch(function (error) {
            return error.toString();
        });
    },

    async GetLookupOnline({ rootState }) {
        return this.$httpClient({
            method: "get",
            url: apipath_onboarding_formlookup,
            // headers: { Authorization: "Bearer " +  tokenkey_onboarding}
            //process.env.VUE_APP_ONBOARDING
        })
        .then(function (response) {
          
                var PRSWithdrawalReasonAL = response.data.PRSWithdrawalReason.length;
                rootState.Lookup.Form.PRSWithdrawalReason = [];
                for(var i=0;i<PRSWithdrawalReasonAL ;i++){
                    if((response.data.PRSWithdrawalReason[i].Value ==='R001')||(response.data.PRSWithdrawalReason[i].Value ==='R003')||(response.data.PRSWithdrawalReason[i].Value ==='R004')){
                       // console.log(response.data.PRSWithdrawalReason[i].Value )
                        rootState.Lookup.Form.PRSWithdrawalReason.push({
                            label:response.data.PRSWithdrawalReason[i].Name + '-' + response.data.PRSWithdrawalReason[i].Value,
                            value:response.data.PRSWithdrawalReason[i].Value
                        });
                    }
                }
                
            return true
           
        })
        .catch(function (error) {
           // console.log(error.response);
            return error
        });
    },

    async TokenValidate({ rootState },Obj) {
        var username = Obj.AuthUser
        
        return this.$httpClient({
            method: "post",
            url: apiconnectuat + 'iaccess/auth/validate',
            // headers: { Authorization: "Bearer " +  tokenkey_iaccess},
            data : {
                "token":Obj.AuthToken
            }
            //process.env.VUE_APP_ONBOARDING
        })
        .then(function (response) {
         // console.log(response.data)
            if(response.data.sub != undefined){
               if(username === response.data.sub){
                   return true
               }else{
                   return -1
               }
            }else{
                    return -1
            } 
        })
        .catch(function (error) {
         //   console.log(error.response);
            //return true
           return error.response.data.message
        });
    },

  /*  async GetUserAccountHolding({commit, state, rootState,dispatch}){
        var url = ''
        var AccountId=rootState.Transactions.OnlineTransactionAccount;
        var scheme=rootState.Transactions.OnlineTransactionScheme;
        var plan = rootState.Transactions.OnlineTransactionPlan;
        var AccountType =plan
        url = apipath_onelook_accountholding + '?accountid=' + AccountId + '&scheme=' + scheme +'&excludechannelgroup=IUTA'
       
        return axios({
            method: "get",
            url: url,
            headers: { Authorization: "Bearer " +  tokenkey_onelook}
            //process.env.VUE_APP_ONELOOKTOKEN
        })
        .then(function (response) { 
           //(response.data.AccountHoldings)
            if(response.data.AccountHoldings!==undefined) {
                if(AccountType==='PRS'){
                    var result = response.data.AccountHoldings.reduce(function(res, obj) {
                        if (!(obj.Scheme in res)){
                            res.__array.push(res[obj.Scheme] = obj);
                            if (obj.Plan === "PRS70")
                            {
                                
                                res[obj.Scheme].BalanceAmountA = obj.Amount;
                                res[obj.Scheme].BalanceUnitsA = obj.Units;
                            }
                            
                            if (obj.Plan === "PRS30") {
                                res[obj.Scheme].BalanceAmountB = obj.Amount;
                                res[obj.Scheme].BalanceUnitsB = obj.Units;
                            }
                        }
                        else {
                            res[obj.Scheme].Units += obj.Units;
                            res[obj.Scheme].Amount += obj.Amount;
                            res[obj.Scheme].Plan = "PRS";
                            
                            if (obj.Plan === "PRS70" && obj.Units!=0)
                            {
                                res[obj.Scheme].BalanceAmountA = obj.Amount;
                                res[obj.Scheme].BalanceUnitsA = obj.Units;
                            }
                            
                            if (obj.Plan === "PRS30" && obj.Units!=0) {
                                res[obj.Scheme].BalanceAmountB = obj.Amount;
                                res[obj.Scheme].BalanceUnitsB = obj.Units;
                            }
                        }
                        return res;
                    }, 
                    {__array:[]})
                    .__array.sort(function(a,b) { 
                        return b.bytes - a.bytes; 
                    });
                    rootState.CD.Holdings = []

                    var tempUnits=0
                    var tempAmount = 0;
                    var tempFloatingUnitOut = 0;
                    var tempSubmittedUnitOut = 0;
                    var tempFloatingUnitIn = 0;

                    var FloatingUnit = 0;

                    for(var j=0; j<result.length;j++){
                        if(result[j].Units!=0){
                            tempUnits = result[j].Units + tempUnits
                           // console.log(tempUnits)
                            tempAmount = result[j].Amount + tempAmount
                          //  console.log(tempAmount)
                            if(result[j].FloatingUnitOut == undefined){
                                result[j].FloatingUnitOut = 0
                            }
                            tempFloatingUnitOut = parseFloat(result[j].FloatingUnitOut) + parseFloat(tempFloatingUnitOut)
                           // console.log(tempFloatingUnitOut)

                            
                            if(result[j].SubmittedUnitOut == undefined){
                                result[j].SubmittedUnitOut = 0
                            }
                            tempSubmittedUnitOut = parseFloat(result[j].SubmittedUnitOut) + parseFloat(tempSubmittedUnitOut)
                           // console.log(tempSubmittedUnitOut)


                             
                            if(result[j].FloatingUnitIn == undefined){
                                result[j].FloatingUnitIn = 0
                            }
                            tempFloatingUnitIn = parseFloat(result[j].FloatingUnitIn) + parseFloat(tempFloatingUnitIn)
                          //  console.log(tempFloatingUnitIn)
                            
                            FloatingUnit = parseFloat(response.data.AccountHoldings[j].FloatingUnits)
                        }
                    }

                    //var FloatingUnit = parseFloat(tempFloatingUnitIn) - parseFloat(tempSubmittedUnitOut)
                    var balanaceAvailableUnit = parseFloat(tempUnits) - parseFloat(tempFloatingUnitOut) - parseFloat(tempSubmittedUnitOut)
                    //console.log(balanaceAvailableUnit)


                    for(var i=0;i<result.length;i++){

                        if(result[i].Units!=0){
                            rootState.CD.Holdings.push({
                                CustomerId: result[i].CustomerID,
                                //AccountType: result[i].AccountType,
                                AccountID: result[i].AccountID,
                                Scheme: result[i].Scheme,
                                //ProductType: result[i].ProductType,
                                ProductName: result[i].FundName,
                                Plan: result[i].Plan,
                                BalanceUnit: parseFloat(balanaceAvailableUnit).toFixed(2),//result[i].Units,
                                FloatingUnit : parseFloat(FloatingUnit).toFixed(2),
                                Amount:parseFloat(result[i].Amount).toFixed(2),
                                BalanceUnitA: result[i].BalanceUnitsA,
                                BalanceUnitB: result[i].BalanceUnitsB,
                                BalanceAmountA: result[i].BalanceAmountA,
                                BalanceAmountB: result[i].BalanceAmountB,
                                NAV: result[i].NAV,
                                NAVDate: result[i].NAVDate,
                                //AgentName: result[i].AgentName,
                                AgentID: result[i].AgentID,
                                //ProductID: result[i].ProductID,
                                Currency: result[i].Currency
                            })
                        }
                    }
                }
                else if(AccountType==='CS')  {
                   
                    rootState.CD.Holdings = []
                    var tempUnits=0
                    var tempAmount = 0;
                    var tempFloatingUnitOut = 0;
                    var tempSubmittedUnitOut = 0;
                    var tempFloatingUnitIn = 0;
                    var FloatingUnit = 0;
                    for(var j=0; j<response.data.AccountHoldings.length;j++){
                        if(response.data.AccountHoldings[j].Plan == "CS"){
                            if((response.data.AccountHoldings[j].Units!=0)){
                                tempUnits = response.data.AccountHoldings[j].Units + tempUnits
                            //    console.log(tempUnits)
                                tempAmount = response.data.AccountHoldings[j].Amount + tempAmount
                            //    console.log(tempAmount)

                                if(response.data.AccountHoldings[j].FloatingUnitOut == undefined){
                                    response.data.AccountHoldings[j].FloatingUnitOut = 0
                                }
                                tempFloatingUnitOut =  parseFloat(response.data.AccountHoldings[j].FloatingUnitOut) + parseFloat(tempFloatingUnitOut)
                            //    console.log(parseFloat(tempFloatingUnitOut))

                                if(response.data.AccountHoldings[j].SubmittedUnitOut == undefined){
                                    response.data.AccountHoldings[j].SubmittedUnitOut = 0
                                }
                                tempSubmittedUnitOut =  parseFloat(response.data.AccountHoldings[j].SubmittedUnitOut) +  parseFloat(tempSubmittedUnitOut)
                              //  console.log( parseFloat(tempSubmittedUnitOut))

                                if(response.data.AccountHoldings[j].FloatingUnitIn == undefined){
                                    response.data.AccountHoldings[j].FloatingUnitIn = 0
                                }
                                
                                tempFloatingUnitIn = parseFloat(response.data.AccountHoldings[j].FloatingUnitIn) + parseFloat(tempFloatingUnitIn)
                             //   console.log(tempFloatingUnitIn)

                                if(response.data.AccountHoldings[j].FloatingUnits == undefined){
                                    response.data.AccountHoldings[j].FloatingUnits = 0;
                                }
                                

                                 FloatingUnit = parseFloat(response.data.AccountHoldings[j].FloatingUnits)
                            }
                        }
                    }

                    
                    
                    //parseFloat(tempFloatingUnitIn) - parseFloat(tempSubmittedUnitOut)

                    var balanaceAvailableUnit = parseFloat(tempUnits) - parseFloat(tempFloatingUnitOut) - parseFloat(tempSubmittedUnitOut)
                   // console.log(balanaceAvailableUnit)
                   
                    //response.data.AccountHoldings.length
                    for(var i=0;i<1;i++){
                     if(response.data.AccountHoldings[i].Plan == "CS"){
                        rootState.CD.Account.AccountId=response.data.AccountHoldings[i].AccountID
                        if((response.data.AccountHoldings[i].Units!=0)){
                                        //console.log(response.data.AccountHoldings[i].Amount)
                            rootState.CD.Holdings.push({
                                CustomerId: response.data.AccountHoldings[i].CustomerID,
                                //AccountType: response.data.AccountHoldings[i].AccountType,
                                AccountID: response.data.AccountHoldings[i].AccountID,
                                Scheme: response.data.AccountHoldings[i].Scheme,
                                //ProductType: response.data.AccountHoldings[i].ProductType,
                                ProductName: response.data.AccountHoldings[i].FundName,
                                Plan: response.data.AccountHoldings[i].Plan,
                                BalanceUnit: parseFloat(balanaceAvailableUnit).toFixed(2),
                                FloatingUnit : parseFloat(FloatingUnit).toFixed(2),
                                Amount: parseFloat(tempAmount).toFixed(2),
                                BalanceUnitA: response.data.AccountHoldings[i].BalanceUnitsA,
                                BalanceUnitB: response.data.AccountHoldings[i].BalanceUnitsB,
                                BalanceAmountA: response.data.AccountHoldings[i].BalanceAmountA,
                                BalanceAmountB: response.data.AccountHoldings[i].BalanceAmountB,
                                NAV: response.data.AccountHoldings[i].NAV,
                                NAVDate: response.data.AccountHoldings[i].NAVDate,
                                //AgentName: response.data.AccountHoldings[i].AgentName,
                                AgentID: response.data.AccountHoldings[i].AgentID,
                                //ProductID: response.data.AccountHoldings[i].ProductID,
                                Currency: response.data.AccountHoldings[i].Currency
                            })
                        }
                     }
                        
                    }
                } else if(AccountType==='EPF') {
                   
                    rootState.CD.Holdings = []
                    var tempUnits=0
                    var tempAmount = 0;
                    var tempFloatingUnitOut = 0;
                    var tempSubmittedUnitOut = 0;
                    var tempFloatingUnitIn = 0;
                    var FloatingUnit = 0;

                    for(var j=0; j<response.data.AccountHoldings.length;j++){
                        
                        if(response.data.AccountHoldings[j].Plan == "EPF"){                        
                            if((response.data.AccountHoldings[j].Units!=0)){
                                tempUnits = response.data.AccountHoldings[j].Units + tempUnits
                            //    console.log(tempUnits)
                                tempAmount = response.data.AccountHoldings[j].Amount + tempAmount
                             //   console.log(tempAmount)

                                if(response.data.AccountHoldings[j].FloatingUnitOut == undefined){
                                    response.data.AccountHoldings[j].FloatingUnitOut = 0
                                }
                                tempFloatingUnitOut =  parseFloat(response.data.AccountHoldings[j].FloatingUnitOut) + parseFloat(tempFloatingUnitOut)
                             //   console.log(parseFloat(tempFloatingUnitOut))

                                if(response.data.AccountHoldings[j].SubmittedUnitOut == undefined){
                                    response.data.AccountHoldings[j].SubmittedUnitOut = 0
                                }
                                tempSubmittedUnitOut =  parseFloat(response.data.AccountHoldings[j].SubmittedUnitOut) +  parseFloat(tempSubmittedUnitOut)
                            //    console.log( parseFloat(tempSubmittedUnitOut))

                                if(response.data.AccountHoldings[j].FloatingUnitIn == undefined){
                                    response.data.AccountHoldings[j].FloatingUnitIn = 0
                                }
                                
                                tempFloatingUnitIn = parseFloat(response.data.AccountHoldings[j].FloatingUnitIn) + parseFloat(tempFloatingUnitIn)
                            //    console.log(tempFloatingUnitIn)
                                
                                FloatingUnit = parseFloat(response.data.AccountHoldings[j].FloatingUnits)
                            }
                        }
                    }

                    
                    var balanaceAvailableUnit = parseFloat(tempUnits) - parseFloat(tempFloatingUnitOut) - parseFloat(tempSubmittedUnitOut)
                   // console.log(balanaceAvailableUnit)
                   
                    //response.data.AccountHoldings.length
                    for(var i=0;i<1;i++){
                     if(response.data.AccountHoldings[i].Plan == "EPF"){
                        rootState.CD.Account.AccountId=response.data.AccountHoldings[i].AccountID
                        if((response.data.AccountHoldings[i].Units!=0)){
                                        //console.log(response.data.AccountHoldings[i].Amount)
                            rootState.CD.Holdings.push({
                                CustomerId: response.data.AccountHoldings[i].CustomerID,
                                //AccountType: response.data.AccountHoldings[i].AccountType,
                                AccountID: response.data.AccountHoldings[i].AccountID,
                                Scheme: response.data.AccountHoldings[i].Scheme,
                                //ProductType: response.data.AccountHoldings[i].ProductType,
                                ProductName: response.data.AccountHoldings[i].FundName,
                                Plan: response.data.AccountHoldings[i].Plan,
                                BalanceUnit: parseFloat(balanaceAvailableUnit).toFixed(2),
                                FloatingUnit : parseFloat(FloatingUnit).toFixed(2),
                                Amount: parseFloat(tempAmount).toFixed(2),
                                BalanceUnitA: response.data.AccountHoldings[i].BalanceUnitsA,
                                BalanceUnitB: response.data.AccountHoldings[i].BalanceUnitsB,
                                BalanceAmountA: response.data.AccountHoldings[i].BalanceAmountA,
                                BalanceAmountB: response.data.AccountHoldings[i].BalanceAmountB,
                                NAV: response.data.AccountHoldings[i].NAV,
                                NAVDate: response.data.AccountHoldings[i].NAVDate,
                                //AgentName: response.data.AccountHoldings[i].AgentName,
                                AgentID: response.data.AccountHoldings[i].AgentID,
                                //ProductID: response.data.AccountHoldings[i].ProductID,
                                Currency: response.data.AccountHoldings[i].Currency
                            })
                        }
                     }
                        
                    }
                }
            }
            return true;
        })
        .catch(function (error) {
           // console.log(error);
            return 'error'
        });
    },

     async PostRedemptionDirectProcess({rootState},Obj){

        var selectedAgent = ""
        if(rootState.Transactions.AgentDetails.length<0){
            selectedAgent = "R000000"
        }else{
            selectedAgent =  rootState.Transactions.AgentDetails.value
        }

        return axios({
            method: "post",
            url: apipath_transaction_selfdraft + '/' + Obj.ApplicationId + '/directprocess',
            headers: { Authorization: "Bearer " + tokenkey_transaction },
            data : {
                "_id": Obj.ApplicationId,
                "ApplicationFormId": rootState.CD.FormDetails.ApplicationFormId,
                "Channel": Obj.Channel,
                "AccountId": Obj.AccountId,
                "AccountType": Obj.AccountType,
                "CustomerID": Obj.CustomerID,
                "isSophisticatedInvestor": false,
                //"EPFNo": rootState.CD.CustomerDetails.EPFNo,
                "AgentCode": selectedAgent,
                "UserId": rootState.Transactions.OnlineTransactionUsername,
                "TransactionCart": {
                    "InvestmentSelf": TempInvest,
                    "SwitchingSelf":TempSwitch ,
                    "RedemptionSelf": TempRedeem
                }
            }
        })
        .then(function (response) {

            if(response.data.StatusCode == "200"){
                rootState.CD.FormDetails.ApplicationId = response.data.ApplicationId
                return true
            }
            else{
                return false
            }
        })
        .catch(function (error) {
            console.log(error);
            return 'error'
        });
   
        
    }, */
    async PostOnlineRedemptionTransaction({rootState}, Obj) {

        var TempRedeem = [];
          TempRedeem.push({
                AmountOrUnit: Obj.Content.AmountOrUnit,
                TypeOfProduct: Obj.Content.TypeOfProduct,
                Scheme: Obj.Content.Scheme,
                PaymentInstruction: Obj.Content.PaymentInstruction,
                Id: Obj.Content.Id,
                Plan: Obj.Content.Plan,
                Units: Obj.Content.Units,
                SchemeCurrency: Obj.Content.SchemeCurrency,
                RedeemAll : Obj.Content.RedeemAll,
                WithdrawalReason : Obj.Content.WithdrawalReason,
                BankAccountNumber : Obj.Content.BankAccountNumber,
                BankMICRCode : Obj.Content.BankMICRCode,
            })
              // console.log(TempRedeem)
        return this.$httpClient({
            method: "post",
            url: apipath_transaction_selfdraft + '/' + Obj.ApplicationId + '/draft',
            // headers: { Authorization: "Bearer " +  tokenkey_transaction},
            //process.env.VUE_APP_TRANSACTIONTOKEN
            data : {
                "_id": Obj.ApplicationId,
                "Channel": Obj.Channel,
                "AccountId": Obj.AccountId,
                "AccountType": Obj.AccountType,
                "CustomerID": Obj.CustomerID,
                "isSophisticatedInvestor": false,
                "AgentCode": "-1000",
                "UserId": rootState.Transactions.OnlineTransactionUserID,
                "TransactionCart": {
                    "RedemptionSelf": TempRedeem
                }
            }
        })
        .then(function (response) {
           // console.log(response)
            if(response.data.StatusCode == "200"){
                rootState.CD.FormDetails.ApplicationId = response.data.ApplicationId

                return true
            }
            else{
                return false
            }
        })
        .catch(function (error) {
         //   console.log(error);
            return error
        });   
    },

    async getTransactionCart({state,rootState}, Obj){
        rootState.CD.FormDetails.ApplicationId = Obj.ApplicationId
        return this.$httpClient({
            method: "get",
            url: apiconnectuat + 'transaction/application/' + rootState.CD.FormDetails.ApplicationId ,
            // headers: { Authorization: "Bearer " + tokenkey_transaction}
            //process.env.VUE_APP_TRANSACTIONTOKEN 
        }).then(function (json) {
            rootState.CD.Transaction.Redemption = [];
            if(json.data.TransactionCart.Redemption.length > 0 ){
                
                rootState.CD.FormDetails.ApplicationFormId =  json.data.ApplicationFormId
                var redemptionCartObj = json.data.TransactionCart.Redemption
                for(var i=0; i<redemptionCartObj.length; i++){
                    rootState.CD.Transaction.Redemption.push({
                        accountId: json.data.AccountId,
                        Id: redemptionCartObj[i].Id,
                        AmountOrUnit: redemptionCartObj[i].AmountOrUnit,
                        TypeOfProduct: redemptionCartObj[i].Plan,
                        FundID: redemptionCartObj[i].Scheme,
                        PaymentInstruction: redemptionCartObj[i].PaymentInstruction,
                        BankAccountNumber: redemptionCartObj[i].BankAccountNumber,
                        Plan:redemptionCartObj[i].Plan,// SelItem.Form.Plan,
                        Units: redemptionCartObj[i].Units,
                        FundCurrency: redemptionCartObj[i].SchemeCurrency,
                        FundCode: redemptionCartObj[i].FundCode,
                        doclink:'',
                        cutOffTime:''
                    })
                }

                if(rootState.AD.FundList.length>0){
                    for(var j=0; j<rootState.AD.FundList.length; j++){
                        for(var t=0; t<rootState.CD.Transaction.Redemption.length;  t++){
                            if(rootState.AD.FundList[j].Scheme == rootState.CD.Transaction.Redemption[t].FundID){
                                rootState.CD.Transaction.Redemption[t].FundName = rootState.AD.FundList[j].SchemeName
                                rootState.CD.Transaction.Redemption[t].FundCode = rootState.AD.FundList[j].FundCode
                                rootState.CD.Transaction.Redemption[t].cutOffTime= rootState.AD.FundList[j].RequestCutoffTime
                            }
                            if(rootState.Transactions.OnlineTransactionPlan != 'EPF'){
                                
                                if( rootState.CD.Transaction.Redemption[t].PaymentInstruction == 'CQ'){
                                    rootState.CD.Transaction.Redemption[t].PaymentInstruction = 'Cheque'
                                }else if((rootState.CD.Transaction.Redemption[t].PaymentInstruction =='FTT')||(rootState.CD.Transaction.Redemption[t].PaymentInstruction =='TT')){
                                    rootState.CD.Transaction.Redemption[t].PaymentInstruction = 'Telegraphic / Interbank Transfer'
                                }
                            }else{
                                rootState.CD.Transaction.Redemption[t].PaymentInstruction ='Credited to EPF Account'
                            }
                           
                        }
                    }
                }
                

            return true
            }else{
                return 'Error. Unable to read response from Transaction Cart Response'
            }
        }).catch(function (error) {
             return 'Error.Unable to read response from Transaction Cart Response'
         });  
    },
    async getDocumentDownloadLink({state,rootState},Obj){
        Obj.AsOfDate 
        //   AsOfDate:today,
        //FundCode:FundCode
        return this.$httpClient({
            method: "get",
            url: apiconnectuat + 'fund/documents?pproductcode='+Obj.FundCode+'&pdoctype=PS',
            // headers: { Authorization: "Bearer " +  tokenkey_fund}
            //process.env.VUE_APP_FUND
        }).then(function (json) {   
             //   console.log('/fund/documents?pproductcode='+Obj.FundCode+'&pdoctype=PSIM')
              //  console.log(json)

                if(json.data.documentsResult.length > 0){
                    for(var i=0; i<json.data.documentsResult.length; i++){
                        if(json.data.documentsResult[i].Language === 'EN'){
                         //   console.log(json.data.documentsResult[i].DocUrl)
                            return  json.data.documentsResult[i].DocUrl
                        }
                    }
                    
                }else{
                    return false
                }

        }).catch(function (error) {
            return false
        }); 
    },


    //rootState.CD.FormDetails.ApplicationId
    async getTranactionApplicationAPI({state,rootState}){
        return this.$httpClient({
            method: "get",
            url: apipath_transaction_selfprocess + '/' + rootState.CD.FormDetails.ApplicationId ,
            // headers: { Authorization: "Bearer " +  tokenkey_transaction}
            //process.env.VUE_APP_TRANSACTIONTOKEN
        }).then(function (json) {
         //   console.log(json)
           // if(json.data._id != undefined){
                rootState.Transactions.TransactionApplicationID = json.data._id
                var schemenName = ''
                for(var j=0; j<rootState.CD.Holdings.length; j++){
                    
                    schemenName = rootState.CD.Holdings[j].ProductName
                }
                if(json.data.TransactionCart.Redemption != undefined){
                    if(json.data.TransactionCart.Redemption.length>0){
                        rootState.CD.Transaction.Redemption = [];
                        for(var i= 0; i<json.data.TransactionCart.Redemption.length; i++){
                            rootState.CD.Transaction.Redemption.push({
                                accountId: json.data.AccountId,
                                Id : json.data.TransactionCart.Redemption[i].Id,
                                Amount:json.data.TransactionCart.Redemption[i].Amount,
                                AmountOrUnit:json.data.TransactionCart.Redemption[i].AmountOrUnit,
                                Units: json.data.TransactionCart.Redemption[i].Units,
                                FundName:schemenName,
                                PaymentInstruction:json.data.TransactionCart.Redemption[i].PaymentInstruction,
                                TypeOfProduct:json.data.TransactionCart.Redemption[i].TypeOfProduct,
    
                            })
                        }
                    }
                }

                for(var t=0; t<rootState.CD.Transaction.Redemption.length;  t++){
                  
                    if(rootState.Transactions.OnlineTransactionPlan != 'EPF'){
                        
                        if( rootState.CD.Transaction.Redemption[t].PaymentInstruction == 'CQ'){
                            rootState.CD.Transaction.Redemption[t].PaymentInstruction = 'Cheque'
                        }else if((rootState.CD.Transaction.Redemption[t].PaymentInstruction =='FTT')||(rootState.CD.Transaction.Redemption[t].PaymentInstruction =='TT')){
                            rootState.CD.Transaction.Redemption[t].PaymentInstruction = 'Telegraphic / Interbank Transfer'
                        }
                    }else{
                        rootState.CD.Transaction.Redemption[t].PaymentInstruction ='Credited to EPF Account'
                    }
                   
                }
              
           // }
            return true;


        }).catch(function (error) {
             
             return 'Error. Unable to read response from Transaction Application API'
         });  
    },
    async TrnxCifCustomerAccountInfo({state,rootState},obj){ 
     return this.$httpClient({
            method: "get",
            url: apiconnectuat  + 'cif/' + rootState.Transactions.OnlineTransactionUserID + '/enquiry/accounts?includejointholder=true',
            // headers: { Authorization: "Bearer " + CIFToken }  
        }).then(function(json){
            if(json.data.Account !=undefined){
                for(var i=0; i < json.data.Account.length; i++){
                    if(rootState.Transactions.OnlineTransactionAccount === json.data.Account[i].AccountID){
                        rootState.Transactions.OnlineTransactionInvestor = json.data.Account[i].AccountName
                        rootState.Transactions.OnlineTransactionsJointAccounts=[]
                        var jointAccount = json.data.Account[i].JointHolders
                        if(json.data.Account[i].JointHolders != undefined){
                            for(var j=0; j<jointAccount.length; j++){
                                rootState.Transactions.OnlineTransactionsJointAccounts.push({
                                    JointCustomerName : jointAccount[j].JointCustomerName
                                })
                            }
                        }
                       
                    }
                }
            }
          
            return true;
        })
        .catch(function (error){
          //  console.log(error);
            return error
        });
    },

    async PostTransaction_Submit_online({ state, rootState }, Obj){
        return this.$httpClient({
            method: "post",
            url: apipath_transaction_selfprocess + '/' + rootState.CD.FormDetails.ApplicationId + '/submit',
            // headers: { Authorization: "Bearer " + tokenkey_transaction},
            //process.env.VUE_APP_TRANSACTIONTOKEN 
            data : {
                "UpdatedBy":rootState.Transactions.OnlineTransactionAccount
                
             }
        })
        .then(function (response) {
            if(response.data.StatusCode === '200'){
                rootState.AD.TC_TransactionStatus='0000'
                rootState.AD.TC_Reason = 'In Progress'
                rootState.AD.AccountType = rootState.Transactions.OnlineTransactionType

                if((rootState.CD.FormDetails.ApplicationId=='')||(rootState.CD.FormDetails.ApplicationId== undefined)){
                    var textArray = rootState.CD.FormDetails.ApplicationId.split('-')
                    rootState.CD.FormDetails.ApplicationId = textArray.slice(4).join('-').trim()
                }

                return true
            }
            else{
                
               rootState.AD.TC_TransactionStatus='000'
               rootState.AD.TC_Reason = response.data.Message
               rootState.AD.AccountType = rootState.Transactions.OnlineTransactionType

               if((rootState.CD.FormDetails.ApplicationId=='')||(rootState.CD.FormDetails.ApplicationId== undefined)){
                    var textArray = rootState.CD.FormDetails.ApplicationId.split('-')
                    rootState.CD.FormDetails.ApplicationId = textArray.slice(4).join('-').trim()
                }

               rootState.AD.FailReason = response.data.Message
                return true
            }
        })
        .catch(function (error){
          //  console.log(error);
            return error
        });
    },

    async TransactOnlineRedeemProcess({state,rootState}){
        // console.log('--> ' + rootState.CD.CustomerDetails.CustomerId)
       //  console.log('324 -->  ' + rootState.CD.FormDetails.ApplicationId)
         var TempRedeem = [];
         for(var i=0; i<rootState.CD.Transaction.Redemption.length;i++){
             TempRedeem.push({
                 TranID: rootState.CD.Transaction.Redemption[i].Id
             })
         }
      
         var today = new Date();
         var dd = String(today.getDate()).padStart(2, '0');
         var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
         var yyyy = today.getFullYear();
    
    
         var d = new Date();
         var currentTime = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    
        var currentDateTime = dd +'-' + + mm + '-' + yyyy  + ' ' + currentTime;

        rootState.Transactions.TransactionDateTime = currentDateTime

       
         return this.$httpClient({
             method: "post",
             url: apipath_transaction_selfprocess + '/' + rootState.CD.FormDetails.ApplicationId + '/process',
            //  headers: { Authorization: "Bearer " +  tokenkey_transaction},
             //process.env.VUE_APP_TRANSACTIONTOKEN
             data : {
                 "ByUser":rootState.Transactions.OnlineTransactionUserID,
                 "TransactionCart": {
                     "Redemption": TempRedeem
                   }
             }
         }).then(function (response) {
           //  console.log(response)
             if(response.data.StatusCode === '200'){
                 rootState.AD.TC_TransactionStatus='0000'
                 rootState.CD.FormDetails.ApplicationId = response.data.ApplicationId
                 return true
             }
             else{
                 
                rootState.AD.TC_TransactionStatus='000'
                rootState.AD.FailReason = response.data.Message
                 return false
             }
         })
         .catch(function (error) {
             
            rootState.AD.TC_TransactionStatus='000'
             rootState.AD.FailReason = "Something went wrong! Please refresh the page and re-try."
             return false
         });  
     },
     async getInvestorMobile({commit, state, rootState,dispatch}){ 
         return axios({
            method: "get",
            url: apiconnectuat+'cif/'+ rootState.Transactions.OnlineTransactionUserID+ '/enquiry/customerinformation', 
           headers: { Authorization: "Bearer " +  CIFToken}
           //process.env.VUE_APP_CIF
        }).then(function(json){
            //StoreStateAOD.ContactInformation.MobileNo
          //  console.log(json.data.CIF.CustomerDetail)
            if((json.data.CIF.CustomerDetail.Name != undefined)|| (json.data.CIF.CustomerDetail.Name != '')){
                rootState.AD.InvestorName  = json.data.CIF.CustomerDetail.Name 
            }
            if((json.data.CIF.CustomerDetail.TelMobile != undefined)|| (json.data.CIF.CustomerDetail.TelMobile != '')){
                rootState.AOD.ContactInformation.MobileNo =json.data.CIF.CustomerDetail.TelMobile
                return true
            }else{
                return false
            }
        }).catch(function (error) {
          //  console.log(error);
            return false
        });
     },
    async RetriveCifInfo({commit, state, rootState,dispatch}){

        return this.$httpClient({
            method: "get",
            url: apiconnectuat+'cif/account/'+ rootState.Transactions.OnlineTransactionAccount ,
          //  headers: { Authorization: "Bearer " +  CIFToken}
           //process.env.VUE_APP_CIF
        }).then(function(response){
            if(response.data.IsSuccessful==true){
                var customer_ic  = response.data.Account.CustomerID
                var bdate_year = customer_ic.substr(0, 2);
                var bdate_month = customer_ic.substr(2, 2) - 1;
                var bdate_day = customer_ic.substr(4, 2);
                var date = new Date(bdate_year, bdate_month, bdate_day);
                var dateNow = new Date();
                var dateYear = date.getFullYear();
    
                var dateNowYear = dateNow.getFullYear();
                rootState.CD.CustomerDetails.Age = dateNowYear - dateYear;
    
                rootState.AOD.ContactInformation.MobileNo  = response.data.Account.TelMobile
            
                rootState.CD.BankAccount = [];
                if(response.data.Account.BankAccounts != undefined){
                    for(var i=0;i<response.data.Account.BankAccounts.length;i++){
                        rootState.CD.BankAccount.push({
                            Currency: response.data.Account.BankAccounts[i].Currency,
                            AccountName: response.data.Account.BankAccounts[i].AccountName,
                            AccountNo: response.data.Account.BankAccounts[i].AccountNo,
                            value: response.data.Account.BankAccounts[i].AccountNo,
                            BankName: response.data.Account.BankAccounts[i].BankName,
                            label: response.data.Account.BankAccounts[i].BankName,
                            IsJointAccount:response.data.Account.BankAccounts[i].IsJointAccount,
                            JointHolderName: response.data.Account.BankAccounts[i].JointHolderName,
                            MICRCode: response.data.Account.BankAccounts[i].MICRCode,
                            AccountID:  response.data.Account.BankAccounts[i].AccountName,
                            Default: true,
                            IsNew : false,
                            Status : "Existing",
                            ValidationId : response.data.Account.BankAccounts[i].ValidationId,
                            ValidationIdType : response.data.Account.BankAccounts[i].ValidationIdType
                        })
    
                    } 
                }
                                     
                    
                   // console.log(rootState.CD.BankAccount)
                    return true
            }else{
                return false;
            }
          
            
        }) .catch(function (error) {
          //  console.log(error);
            return false
        });

    },
}

//mutations
const mutations = {

    ResetState_CallApi(state) {
        Object.assign(state, getDefaultState())
    },
    GetAgeByDOB(state, DateOfBirth){
        var today = new Date();
        var birthDate = new Date(DateOfBirth);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age = age - 1;
        }
        state.Age = age;
    },
    // General Function\
    SET_GenderByNRICPRS(state, nric) {
        var str = nric.substr(nric.length - 1);
        if (str % 2 === 0) {
            state.Gender = 'F'
        } else
        if (str % 2 !== 0) {
            state.Gender = 'M'
        }
        
       // console.log("Gender >" + state.Gender)
    },
    SET_AgeByNRICPRS(state, nric) {
       // console.log('here')
        var Age;
        var bdate_year = nric.substr(0, 2);
        var bdate_month = nric.substr(2, 2) - 1;
        var bdate_day = nric.substr(4, 2);
        var date = new Date(bdate_year, bdate_month, bdate_day);
        var dateNow = new Date();
        var dateYear = date.getFullYear();

        var dateNowYear = dateNow.getFullYear();
        Age = dateNowYear - dateYear;
       // console.log("Age >" + Age)
        state.Age = Age;
    },
    SET_DateofBirthByNRICPRS(state, nric) {
        var bdate_year = nric.substr(0, 2);
        var bdate_month = nric.substr(2, 2) - 1;
        var bdate_day = nric.substr(4, 2);
        var date = new Date(bdate_year, bdate_month, bdate_day);

        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var yyyy = date.getFullYear();

        var date  = yyyy + '-' + mm + '-' + dd;
       // console.log("date >" + date)
       state.DOB = date;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
